// Generated from ./util_cohort_builder_grammar/stable/CohortDefinition.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";

import { CohortDefinitionListener } from "./CohortDefinitionListener.js";
import { CohortDefinitionVisitor } from "./CohortDefinitionVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;


export class CohortDefinition extends antlr.Parser {
    public static readonly INCLUDE = 1;
    public static readonly EXCLUDE = 2;
    public static readonly STUDY_PERIOD = 3;
    public static readonly BASELINE = 4;
    public static readonly FOLLOW_UP = 5;
    public static readonly INDEX_DATE = 6;
    public static readonly EVENT = 7;
    public static readonly CALENDAR_DATE = 8;
    public static readonly UPPER_DATE_BOUND = 9;
    public static readonly LOWER_DATE_BOUND = 10;
    public static readonly DERIVED_EVENT_DATE = 11;
    public static readonly CONSTRAINTS = 12;
    public static readonly ANY_ORDER = 13;
    public static readonly IS_EVENT_DATE = 14;
    public static readonly TC = 15;
    public static readonly TEMPORAL_CONSTRAINT_ABBR = 16;
    public static readonly TEMPORAL_CONSTRAINT = 17;
    public static readonly POSITION = 18;
    public static readonly CF = 19;
    public static readonly CONCEPT_FILTER = 20;
    public static readonly CONCEPT_FILTER_ABBR = 21;
    public static readonly NF = 22;
    public static readonly NUMERIC_FILTER = 23;
    public static readonly NUMERIC_FILTER_ABBR = 24;
    public static readonly SF = 25;
    public static readonly STRING_FILTER = 26;
    public static readonly STRING_FILTER_ABBR = 27;
    public static readonly UF = 28;
    public static readonly UNIQUENESS_FILTER = 29;
    public static readonly UNIQUENESS_FILTER_ABBR = 30;
    public static readonly RF = 31;
    public static readonly RELATED_ENTITY_FILTER = 32;
    public static readonly RELATED_ENTITY_FILTER_ABBR = 33;
    public static readonly QUALIFIED_CARE_SITE_ALIAS = 34;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE_ALIAS = 35;
    public static readonly QUALIFIED_DRUG_EXPOSURE_ALIAS = 36;
    public static readonly QUALIFIED_MEASUREMENT_ALIAS = 37;
    public static readonly QUALIFIED_OBSERVATION_ALIAS = 38;
    public static readonly QUALIFIED_PERSON_ALIAS = 39;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS = 40;
    public static readonly QUALIFIED_PROVIDER_ALIAS = 41;
    public static readonly QUALIFIED_VISIT_OCCURRENCE_ALIAS = 42;
    public static readonly QUALIFIED_DERIVED_EVENT_NAME = 43;
    public static readonly SUBJECT_VARIABLE_CARE_SITE_ALIAS = 44;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS = 45;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS = 46;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT_ALIAS = 47;
    public static readonly SUBJECT_VARIABLE_OBSERVATION_ALIAS = 48;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS = 49;
    public static readonly SUBJECT_VARIABLE_PROVIDER_ALIAS = 50;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS = 51;
    public static readonly SUBJECT_VARIABLE_DERIVED_EVENT_NAME = 52;
    public static readonly CONCEPT_GROUP = 53;
    public static readonly CARE_SITE_ALIAS = 54;
    public static readonly CONDITION_OCCURRENCE_ALIAS = 55;
    public static readonly DRUG_EXPOSURE_ALIAS = 56;
    public static readonly MEASUREMENT_ALIAS = 57;
    public static readonly OBSERVATION_ALIAS = 58;
    public static readonly PERSON_ALIAS = 59;
    public static readonly PROCEDURE_OCCURRENCE_ALIAS = 60;
    public static readonly PROVIDER_ALIAS = 61;
    public static readonly VISIT_OCCURRENCE_ALIAS = 62;
    public static readonly MERGED_EVENT_NAME = 63;
    public static readonly SEQUENCE_EVENT_NAME = 64;
    public static readonly INSTANCE_EVENT_NAME = 65;
    public static readonly SUBJECTS_VARIABLE_NAME = 66;
    public static readonly NAMESPACE_QUALIFIER = 67;
    public static readonly SUBJECTS_VARIABLE = 68;
    public static readonly CONCEPT = 69;
    public static readonly QUALIFIED_MERGED_EVENT = 70;
    public static readonly QUALIFIED_SEQUENCE_EVENT = 71;
    public static readonly QUALIFIED_INSTANCE_EVENT = 72;
    public static readonly SUBJECT_VARIABLE_MERGED_EVENT = 73;
    public static readonly SUBJECT_VARIABLE_SEQUENCE_EVENT = 74;
    public static readonly SUBJECT_VARIABLE_INSTANCE_EVENT = 75;
    public static readonly MERGED_EVENT = 76;
    public static readonly SEQUENCE_EVENT = 77;
    public static readonly INSTANCE_EVENT = 78;
    public static readonly DERIVED_EVENT = 79;
    public static readonly LINE_COMMENT = 80;
    public static readonly INT = 81;
    public static readonly M = 82;
    public static readonly D = 83;
    public static readonly Y = 84;
    public static readonly DATE = 85;
    public static readonly OPEN_PAREN = 86;
    public static readonly CLOSE_PAREN = 87;
    public static readonly SEMICOLON = 88;
    public static readonly COMMA = 89;
    public static readonly EQ = 90;
    public static readonly MULTIPLY = 91;
    public static readonly DIVIDE = 92;
    public static readonly ADD = 93;
    public static readonly SUBTRACT = 94;
    public static readonly CONTAINS = 95;
    public static readonly NEQ = 96;
    public static readonly LTE = 97;
    public static readonly GTE = 98;
    public static readonly LT = 99;
    public static readonly GT = 100;
    public static readonly MAX = 101;
    public static readonly MIN = 102;
    public static readonly AVG = 103;
    public static readonly COUNT = 104;
    public static readonly LEAST = 105;
    public static readonly GREATEST = 106;
    public static readonly IN = 107;
    public static readonly AND = 108;
    public static readonly OR = 109;
    public static readonly NOT = 110;
    public static readonly COMPLEMENT = 111;
    public static readonly UNION = 112;
    public static readonly INTERSECTION = 113;
    public static readonly DIFFERENCE = 114;
    public static readonly INDEX = 115;
    public static readonly TIME_UNIT = 116;
    public static readonly DAYS = 117;
    public static readonly WEEKS = 118;
    public static readonly MONTHS = 119;
    public static readonly YEARS = 120;
    public static readonly MINIMUM_BETWEEN = 121;
    public static readonly MAXIMUM_BETWEEN = 122;
    public static readonly TOTAL_BETWEEN = 123;
    public static readonly FIXED_WINDOW = 124;
    public static readonly ROLLING_WINDOW = 125;
    public static readonly PERIOD = 126;
    public static readonly WS = 127;
    public static readonly CARE_SITE = 128;
    public static readonly CONDITION_OCCURRENCE = 129;
    public static readonly DRUG_EXPOSURE = 130;
    public static readonly MEASUREMENT = 131;
    public static readonly OBSERVATION = 132;
    public static readonly PERSON = 133;
    public static readonly PROCEDURE_OCCURRENCE = 134;
    public static readonly PROVIDER = 135;
    public static readonly VISIT_OCCURRENCE = 136;
    public static readonly QUALIFIED_CARE_SITE = 137;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE = 138;
    public static readonly QUALIFIED_DRUG_EXPOSURE = 139;
    public static readonly QUALIFIED_MEASUREMENT = 140;
    public static readonly QUALIFIED_OBSERVATION = 141;
    public static readonly QUALIFIED_PERSON = 142;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE = 143;
    public static readonly QUALIFIED_PROVIDER = 144;
    public static readonly QUALIFIED_VISIT_OCCURRENCE = 145;
    public static readonly SUBJECT_VARIABLE_CARE_SITE = 146;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE = 147;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE = 148;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT = 149;
    public static readonly SUBJECT_VARIABLE_OBSERVATION = 150;
    public static readonly SUBJECT_VARIABLE_PERSON = 151;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE = 152;
    public static readonly SUBJECT_VARIABLE_PROVIDER = 153;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE = 154;
    public static readonly CONDITION_OCCURRENCE_DATE_ATTRIBUTE = 155;
    public static readonly DRUG_EXPOSURE_DATE_ATTRIBUTE = 156;
    public static readonly MEASUREMENT_DATE_ATTRIBUTE = 157;
    public static readonly OBSERVATION_DATE_ATTRIBUTE = 158;
    public static readonly PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE = 159;
    public static readonly VISIT_OCCURRENCE_DATE_ATTRIBUTE = 160;
    public static readonly PERSON_DATE_TIME_ATTRIBUTE = 161;
    public static readonly DRUG_EXPOSURE_INT_ATTRIBUTE = 162;
    public static readonly MEASUREMENT_FLOAT_ATTRIBUTE = 163;
    public static readonly PERSON_INT_ATTRIBUTE = 164;
    public static readonly COMMON_NUMERIC_FLOAT_ATTRIBUTE = 165;
    public static readonly QUANTITY = 166;
    public static readonly CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE = 167;
    public static readonly DRUG_EXPOSURE_CONCEPT_ATTRIBUTE = 168;
    public static readonly MEASUREMENT_CONCEPT_ATTRIBUTE = 169;
    public static readonly OBSERVATION_CONCEPT_ATTRIBUTE = 170;
    public static readonly PERSON_CONCEPT_ATTRIBUTE = 171;
    public static readonly PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE = 172;
    public static readonly PROVIDER_CONCEPT_ATTRIBUTE = 173;
    public static readonly VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE = 174;
    public static readonly COMMON_CONCEPT_ATTRIBUTE = 175;
    public static readonly CARE_SITE_CONCEPT_ATTRIBUTE = 176;
    public static readonly COMMON_STRING_ATTRIBUTE = 177;
    public static readonly GENDER_SOURCE_VALUE = 178;
    public static readonly CARE_SITE_STRING_ATTRIBUTE = 179;
    public static readonly CONDITION_OCCURRENCE_STRING_ATTRIBUTE = 180;
    public static readonly DRUG_EXPOSURE_STRING_ATTRIBUTE = 181;
    public static readonly MEASUREMENT_STRING_ATTRIBUTE = 182;
    public static readonly OBSERVATION_STRING_ATTRIBUTE = 183;
    public static readonly PERSON_STRING_ATTRIBUTE = 184;
    public static readonly PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE = 185;
    public static readonly PROVIDER_STRING_ATTRIBUTE = 186;
    public static readonly VISIT_OCCURRENCE_STRING_ATTRIBUTE = 187;
    public static readonly RULE_cohort_definition = 0;
    public static readonly RULE_inclusion_criteria = 1;
    public static readonly RULE_exclusion_criteria = 2;
    public static readonly RULE_cohort_criterion_set = 3;
    public static readonly RULE_study_period_criteria = 4;
    public static readonly RULE_baseline_period_criteria = 5;
    public static readonly RULE_follow_up_period_criteria = 6;
    public static readonly RULE_overall_study_period = 7;
    public static readonly RULE_overall_study_period_error = 8;
    public static readonly RULE_overall_study_period_error2 = 9;
    public static readonly RULE_overall_study_period_error3 = 10;
    public static readonly RULE_baseline_period = 11;
    public static readonly RULE_baseline_period_error = 12;
    public static readonly RULE_follow_up_period = 13;
    public static readonly RULE_follow_up_period_error = 14;
    public static readonly RULE_subjects_variable = 15;
    public static readonly RULE_event_count_criteria = 16;
    public static readonly RULE_count_criteria = 17;
    public static readonly RULE_event_count_criteria_error = 18;
    public static readonly RULE_demographic_event_criteria = 19;
    public static readonly RULE_demographic_event_filters = 20;
    public static readonly RULE_demographic_event_filter = 21;
    public static readonly RULE_demographic_concept_filter = 22;
    public static readonly RULE_demographic_concept_group_filter = 23;
    public static readonly RULE_demographic_concept_id_filter = 24;
    public static readonly RULE_demographic_numeric_filter = 25;
    public static readonly RULE_demographic_int_filter = 26;
    public static readonly RULE_demographic_error_filter = 27;
    public static readonly RULE_subject_variable_event_name = 28;
    public static readonly RULE_index_date = 29;
    public static readonly RULE_index_date_definition = 30;
    public static readonly RULE_calendar_date = 31;
    public static readonly RULE_index_event_date = 32;
    public static readonly RULE_index_date_bounds = 33;
    public static readonly RULE_upper_date_bounds = 34;
    public static readonly RULE_lower_date_bounds = 35;
    public static readonly RULE_calendarError = 36;
    public static readonly RULE_index_event_date_error = 37;
    public static readonly RULE_lower_date_bounds_error = 38;
    public static readonly RULE_upper_date_bounds_error = 39;
    public static readonly RULE_derived_event = 40;
    public static readonly RULE_merged_event = 41;
    public static readonly RULE_merged_event_criteria = 42;
    public static readonly RULE_merged_event_criterion = 43;
    public static readonly RULE_merged_event_filter_criterion = 44;
    public static readonly RULE_merged_event_event = 45;
    public static readonly RULE_merged_event_filter = 46;
    public static readonly RULE_merged_event_uniqueness_filter = 47;
    public static readonly RULE_merged_event_uniqueness_filter_criteria = 48;
    public static readonly RULE_merged_event_filter_error = 49;
    public static readonly RULE_sequence_event = 50;
    public static readonly RULE_sequence_event_criteria = 51;
    public static readonly RULE_sequence_event_criterion = 52;
    public static readonly RULE_sequence_event_constraint = 53;
    public static readonly RULE_temporal_constraint = 54;
    public static readonly RULE_sequence_temporal_filter = 55;
    public static readonly RULE_sequence_event_event = 56;
    public static readonly RULE_selected_sequence_event = 57;
    public static readonly RULE_unselected_sequence_event = 58;
    public static readonly RULE_instance_event = 59;
    public static readonly RULE_instance_event_criteria = 60;
    public static readonly RULE_instance_event_criterion = 61;
    public static readonly RULE_instance_event_event = 62;
    public static readonly RULE_instance_event_position = 63;
    public static readonly RULE_aggregation_qualified = 64;
    public static readonly RULE_specific_instance = 65;
    public static readonly RULE_instance_event_position_error = 66;
    public static readonly RULE_qualified_simple_event = 67;
    public static readonly RULE_qualified_derived_event = 68;
    public static readonly RULE_sequence_event_constraint_error = 69;
    public static readonly RULE_derived_event_error = 70;
    public static readonly RULE_derived_uniqueness_filter = 71;
    public static readonly RULE_derived_uniqueness_filter_window = 72;
    public static readonly RULE_derived_fixed_window_uniqueness_filter = 73;
    public static readonly RULE_derived_rolling_window_uniqueness_filter = 74;
    public static readonly RULE_derived_event_int = 75;
    public static readonly RULE_simple_event = 76;
    public static readonly RULE_condition_occurrence_event = 77;
    public static readonly RULE_drug_exposure_event = 78;
    public static readonly RULE_measurement_event = 79;
    public static readonly RULE_observation_event = 80;
    public static readonly RULE_procedure_occurrence_event = 81;
    public static readonly RULE_visit_occurrence_event = 82;
    public static readonly RULE_condition_occurrence_event_definition = 83;
    public static readonly RULE_drug_exposure_event_definition = 84;
    public static readonly RULE_measurement_event_definition = 85;
    public static readonly RULE_observation_event_definition = 86;
    public static readonly RULE_procedure_occurrence_event_definition = 87;
    public static readonly RULE_visit_occurrence_event_definition = 88;
    public static readonly RULE_condition_occurrence_event_criteria = 89;
    public static readonly RULE_condition_occurrence_event_filter = 90;
    public static readonly RULE_condition_occurrence_concept_filters = 91;
    public static readonly RULE_condition_occurrence_concept_group_filter = 92;
    public static readonly RULE_condition_occurrence_concept_filter = 93;
    public static readonly RULE_condition_occurrence_uniqueness_filters = 94;
    public static readonly RULE_condition_occurrence_uniqueness_filter = 95;
    public static readonly RULE_condition_occurrence_related_entity_filters = 96;
    public static readonly RULE_condition_occurrence_related_entity_filter = 97;
    public static readonly RULE_condition_occurrence_sub_filter = 98;
    public static readonly RULE_condition_occurrence_error_sub_filter = 99;
    public static readonly RULE_condition_occurrence_error_filter = 100;
    public static readonly RULE_drug_exposure_event_criteria = 101;
    public static readonly RULE_drug_exposure_event_filter = 102;
    public static readonly RULE_drug_exposure_concept_filters = 103;
    public static readonly RULE_drug_exposure_concept_group_filter = 104;
    public static readonly RULE_drug_exposure_concept_filter = 105;
    public static readonly RULE_drug_exposure_numeric_filters = 106;
    public static readonly RULE_drug_exposure_float_filter = 107;
    public static readonly RULE_drug_exposure_int_filter = 108;
    public static readonly RULE_drug_exposure_uniqueness_filters = 109;
    public static readonly RULE_drug_exposure_uniqueness_filter = 110;
    public static readonly RULE_drug_exposure_related_entity_filters = 111;
    public static readonly RULE_drug_exposure_related_entity_filter = 112;
    public static readonly RULE_drug_exposure_error_filter = 113;
    public static readonly RULE_measurement_event_criteria = 114;
    public static readonly RULE_measurement_event_filter = 115;
    public static readonly RULE_measurement_concept_filters = 116;
    public static readonly RULE_measurement_concept_group_filter = 117;
    public static readonly RULE_measurement_concept_filter = 118;
    public static readonly RULE_measurement_numeric_filters = 119;
    public static readonly RULE_measurement_float_filter = 120;
    public static readonly RULE_measurement_uniqueness_filters = 121;
    public static readonly RULE_measurement_uniqueness_filter = 122;
    public static readonly RULE_measurement_related_entity_filters = 123;
    public static readonly RULE_measurement_related_entity_filter = 124;
    public static readonly RULE_measurement_error_filter = 125;
    public static readonly RULE_observation_event_criteria = 126;
    public static readonly RULE_observation_event_filter = 127;
    public static readonly RULE_observation_concept_filters = 128;
    public static readonly RULE_observation_concept_group_filter = 129;
    public static readonly RULE_observation_concept_filter = 130;
    public static readonly RULE_observation_numeric_filters = 131;
    public static readonly RULE_observation_float_filter = 132;
    public static readonly RULE_observation_uniqueness_filters = 133;
    public static readonly RULE_observation_uniqueness_filter = 134;
    public static readonly RULE_observation_related_entity_filters = 135;
    public static readonly RULE_observation_related_entity_filter = 136;
    public static readonly RULE_observation_error_filter = 137;
    public static readonly RULE_procedure_occurrence_event_criteria = 138;
    public static readonly RULE_procedure_occurrence_event_filter = 139;
    public static readonly RULE_procedure_occurrence_concept_filters = 140;
    public static readonly RULE_procedure_occurrence_concept_group_filter = 141;
    public static readonly RULE_procedure_occurrence_concept_filter = 142;
    public static readonly RULE_procedure_occurrence_numeric_filters = 143;
    public static readonly RULE_procedure_occurrence_int_filter = 144;
    public static readonly RULE_procedure_occurrence_uniqueness_filters = 145;
    public static readonly RULE_procedure_occurrence_uniqueness_filter = 146;
    public static readonly RULE_procedure_occurrence_related_entity_filters = 147;
    public static readonly RULE_procedure_occurrence_related_entity_filter = 148;
    public static readonly RULE_procedure_occurrence_error_filter = 149;
    public static readonly RULE_provider_concept_filters = 150;
    public static readonly RULE_provider_concept_group_filter = 151;
    public static readonly RULE_provider_concept_filter = 152;
    public static readonly RULE_provider_sub_filter = 153;
    public static readonly RULE_provider_error_sub_filter = 154;
    public static readonly RULE_visit_occurrence_event_criteria = 155;
    public static readonly RULE_visit_occurrence_event_filter = 156;
    public static readonly RULE_visit_occurrence_concept_filters = 157;
    public static readonly RULE_visit_occurrence_concept_group_filter = 158;
    public static readonly RULE_visit_occurrence_concept_filter = 159;
    public static readonly RULE_visit_occurrence_uniqueness_filters = 160;
    public static readonly RULE_visit_occurrence_uniqueness_filter = 161;
    public static readonly RULE_visit_occurrence_related_entity_filters = 162;
    public static readonly RULE_visit_occurrence_related_entity_filter = 163;
    public static readonly RULE_visit_occurrence_sub_filter = 164;
    public static readonly RULE_visit_occurrence_error_sub_filter = 165;
    public static readonly RULE_visit_occurrence_error_filter = 166;
    public static readonly RULE_comparison_op = 167;
    public static readonly RULE_simple_uniqueness_filter = 168;
    public static readonly RULE_simple_uniqueness_filter_window = 169;
    public static readonly RULE_fixed_window_uniqueness_filter = 170;
    public static readonly RULE_rolling_window_uniqueness_filter = 171;
    public static readonly RULE_simple_event_float = 172;
    public static readonly RULE_simple_event_int = 173;
    public static readonly RULE_concept_group_selection = 174;

    public static readonly literalNames = [
        null, "'INCLUDE'", "'EXCLUDE'", "'STUDY_PERIOD'", "'BASELINE'", 
        "'FOLLOW_UP'", "'INDEX_DATE'", "'EVENT'", "'CALENDAR_DATE'", "'UPPER_DATE_BOUND'", 
        "'LOWER_DATE_BOUND'", "'derived_event_date'", "'CONSTRAINTS'", "'ANY_ORDER'", 
        "'IS_EVENT_DATE'", null, "'TC'", "'TEMPORAL_CONSTRAINT'", "'POSITION'", 
        null, "'CONCEPT_FILTER'", "'CF'", null, "'NUMERIC_FILTER'", "'NF'", 
        null, "'STRING_FILTER'", "'SF'", null, "'UNIQUENESS_FILTER'", "'UF'", 
        null, "'RELATED_ENTITY_FILTER'", "'RF'", null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, "'::'", "'SUBJECTS_VARIABLE'", 
        null, "'QUALIFIED_MERGED_EVENT'", "'QUALIFIED_SEQUENCE_EVENT'", 
        "'QUALIFIED_INSTANCE_EVENT'", "'SUBJECT_VARIABLE_MERGED_EVENT'", 
        "'SUBJECT_VARIABLE_SEQUENCE_EVENT'", "'SUBJECT_VARIABLE_INSTANCE_EVENT'", 
        "'MERGED_EVENT'", "'SEQUENCE_EVENT'", "'INSTANCE_EVENT'", "'DERIVED_EVENT'", 
        null, null, null, null, null, null, "'('", "')'", "';'", "','", 
        "'='", "'*'", "'/'", "'+'", "'-'", "'CONTAINS'", "'!='", "'<='", 
        "'>='", "'<'", "'>'", "'MAX'", "'MIN'", "'AVG'", "'COUNT'", "'LEAST'", 
        "'GREATEST'", "'IN'", "'AND'", "'OR'", "'NOT'", "'COMPLEMENT'", 
        "'UNION'", "'INTERSECTION'", "'DIFFERENCE'", "'INDEX'", null, "'DAYS'", 
        "'WEEKS'", "'MONTHS'", "'YEARS'", "'MINIMUM_BETWEEN'", "'MAXIMUM_BETWEEN'", 
        "'TOTAL_BETWEEN'", "'FIXED_WINDOW'", "'ROLLING_WINDOW'", "'.'", 
        null, "'CARE_SITE'", "'CONDITION_OCCURRENCE'", "'DRUG_EXPOSURE'", 
        "'MEASUREMENT'", "'OBSERVATION'", "'PERSON'", "'PROCEDURE_OCCURRENCE'", 
        "'PROVIDER'", "'VISIT_OCCURRENCE'", "'QUALIFIED_CARE_SITE'", "'QUALIFIED_CONDITION_OCCURRENCE'", 
        "'QUALIFIED_DRUG_EXPOSURE'", "'QUALIFIED_MEASUREMENT'", "'QUALIFIED_OBSERVATION'", 
        "'QUALIFIED_PERSON'", "'QUALIFIED_PROCEDURE_OCCURRENCE'", "'QUALIFIED_PROVIDER'", 
        "'QUALIFIED_VISIT_OCCURRENCE'", "'SUBJECT_VARIABLE_CARE_SITE'", 
        "'SUBJECT_VARIABLE_CONDITION_OCCURRENCE'", "'SUBJECT_VARIABLE_DRUG_EXPOSURE'", 
        "'SUBJECT_VARIABLE_MEASUREMENT'", "'SUBJECT_VARIABLE_OBSERVATION'", 
        "'SUBJECT_VARIABLE_PERSON'", "'SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE'", 
        "'SUBJECT_VARIABLE_PROVIDER'", "'SUBJECT_VARIABLE_VISIT_OCCURRENCE'", 
        null, null, "'measurement_date'", "'observation_date'", "'procedure_date'", 
        null, "'birth_datetime'", null, null, null, "'value_as_number'", 
        "'quantity'", null, null, null, null, null, null, "'specialty_concept'", 
        null, null, "'place_of_service_concept'", "'value_as_string'", "'gender_source_value'"
    ];

    public static readonly symbolicNames = [
        null, "INCLUDE", "EXCLUDE", "STUDY_PERIOD", "BASELINE", "FOLLOW_UP", 
        "INDEX_DATE", "EVENT", "CALENDAR_DATE", "UPPER_DATE_BOUND", "LOWER_DATE_BOUND", 
        "DERIVED_EVENT_DATE", "CONSTRAINTS", "ANY_ORDER", "IS_EVENT_DATE", 
        "TC", "TEMPORAL_CONSTRAINT_ABBR", "TEMPORAL_CONSTRAINT", "POSITION", 
        "CF", "CONCEPT_FILTER", "CONCEPT_FILTER_ABBR", "NF", "NUMERIC_FILTER", 
        "NUMERIC_FILTER_ABBR", "SF", "STRING_FILTER", "STRING_FILTER_ABBR", 
        "UF", "UNIQUENESS_FILTER", "UNIQUENESS_FILTER_ABBR", "RF", "RELATED_ENTITY_FILTER", 
        "RELATED_ENTITY_FILTER_ABBR", "QUALIFIED_CARE_SITE_ALIAS", "QUALIFIED_CONDITION_OCCURRENCE_ALIAS", 
        "QUALIFIED_DRUG_EXPOSURE_ALIAS", "QUALIFIED_MEASUREMENT_ALIAS", 
        "QUALIFIED_OBSERVATION_ALIAS", "QUALIFIED_PERSON_ALIAS", "QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS", 
        "QUALIFIED_PROVIDER_ALIAS", "QUALIFIED_VISIT_OCCURRENCE_ALIAS", 
        "QUALIFIED_DERIVED_EVENT_NAME", "SUBJECT_VARIABLE_CARE_SITE_ALIAS", 
        "SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS", 
        "SUBJECT_VARIABLE_MEASUREMENT_ALIAS", "SUBJECT_VARIABLE_OBSERVATION_ALIAS", 
        "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_PROVIDER_ALIAS", 
        "SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS", "SUBJECT_VARIABLE_DERIVED_EVENT_NAME", 
        "CONCEPT_GROUP", "CARE_SITE_ALIAS", "CONDITION_OCCURRENCE_ALIAS", 
        "DRUG_EXPOSURE_ALIAS", "MEASUREMENT_ALIAS", "OBSERVATION_ALIAS", 
        "PERSON_ALIAS", "PROCEDURE_OCCURRENCE_ALIAS", "PROVIDER_ALIAS", 
        "VISIT_OCCURRENCE_ALIAS", "MERGED_EVENT_NAME", "SEQUENCE_EVENT_NAME", 
        "INSTANCE_EVENT_NAME", "SUBJECTS_VARIABLE_NAME", "NAMESPACE_QUALIFIER", 
        "SUBJECTS_VARIABLE", "CONCEPT", "QUALIFIED_MERGED_EVENT", "QUALIFIED_SEQUENCE_EVENT", 
        "QUALIFIED_INSTANCE_EVENT", "SUBJECT_VARIABLE_MERGED_EVENT", "SUBJECT_VARIABLE_SEQUENCE_EVENT", 
        "SUBJECT_VARIABLE_INSTANCE_EVENT", "MERGED_EVENT", "SEQUENCE_EVENT", 
        "INSTANCE_EVENT", "DERIVED_EVENT", "LINE_COMMENT", "INT", "M", "D", 
        "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", "SEMICOLON", "COMMA", 
        "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", "CONTAINS", "NEQ", 
        "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", "COUNT", "LEAST", 
        "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", "UNION", "INTERSECTION", 
        "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", "WEEKS", "MONTHS", "YEARS", 
        "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", "TOTAL_BETWEEN", "FIXED_WINDOW", 
        "ROLLING_WINDOW", "PERIOD", "WS", "CARE_SITE", "CONDITION_OCCURRENCE", 
        "DRUG_EXPOSURE", "MEASUREMENT", "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", 
        "PROVIDER", "VISIT_OCCURRENCE", "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", 
        "QUALIFIED_DRUG_EXPOSURE", "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", 
        "QUALIFIED_PERSON", "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", 
        "QUALIFIED_VISIT_OCCURRENCE", "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE", 
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE", 
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY", "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", "MEASUREMENT_CONCEPT_ATTRIBUTE", 
        "OBSERVATION_CONCEPT_ATTRIBUTE", "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE", "COMMON_STRING_ATTRIBUTE", 
        "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", 
        "DRUG_EXPOSURE_STRING_ATTRIBUTE", "MEASUREMENT_STRING_ATTRIBUTE", 
        "OBSERVATION_STRING_ATTRIBUTE", "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE"
    ];
    public static readonly ruleNames = [
        "cohort_definition", "inclusion_criteria", "exclusion_criteria", 
        "cohort_criterion_set", "study_period_criteria", "baseline_period_criteria", 
        "follow_up_period_criteria", "overall_study_period", "overall_study_period_error", 
        "overall_study_period_error2", "overall_study_period_error3", "baseline_period", 
        "baseline_period_error", "follow_up_period", "follow_up_period_error", 
        "subjects_variable", "event_count_criteria", "count_criteria", "event_count_criteria_error", 
        "demographic_event_criteria", "demographic_event_filters", "demographic_event_filter", 
        "demographic_concept_filter", "demographic_concept_group_filter", 
        "demographic_concept_id_filter", "demographic_numeric_filter", "demographic_int_filter", 
        "demographic_error_filter", "subject_variable_event_name", "index_date", 
        "index_date_definition", "calendar_date", "index_event_date", "index_date_bounds", 
        "upper_date_bounds", "lower_date_bounds", "calendarError", "index_event_date_error", 
        "lower_date_bounds_error", "upper_date_bounds_error", "derived_event", 
        "merged_event", "merged_event_criteria", "merged_event_criterion", 
        "merged_event_filter_criterion", "merged_event_event", "merged_event_filter", 
        "merged_event_uniqueness_filter", "merged_event_uniqueness_filter_criteria", 
        "merged_event_filter_error", "sequence_event", "sequence_event_criteria", 
        "sequence_event_criterion", "sequence_event_constraint", "temporal_constraint", 
        "sequence_temporal_filter", "sequence_event_event", "selected_sequence_event", 
        "unselected_sequence_event", "instance_event", "instance_event_criteria", 
        "instance_event_criterion", "instance_event_event", "instance_event_position", 
        "aggregation_qualified", "specific_instance", "instance_event_position_error", 
        "qualified_simple_event", "qualified_derived_event", "sequence_event_constraint_error", 
        "derived_event_error", "derived_uniqueness_filter", "derived_uniqueness_filter_window", 
        "derived_fixed_window_uniqueness_filter", "derived_rolling_window_uniqueness_filter", 
        "derived_event_int", "simple_event", "condition_occurrence_event", 
        "drug_exposure_event", "measurement_event", "observation_event", 
        "procedure_occurrence_event", "visit_occurrence_event", "condition_occurrence_event_definition", 
        "drug_exposure_event_definition", "measurement_event_definition", 
        "observation_event_definition", "procedure_occurrence_event_definition", 
        "visit_occurrence_event_definition", "condition_occurrence_event_criteria", 
        "condition_occurrence_event_filter", "condition_occurrence_concept_filters", 
        "condition_occurrence_concept_group_filter", "condition_occurrence_concept_filter", 
        "condition_occurrence_uniqueness_filters", "condition_occurrence_uniqueness_filter", 
        "condition_occurrence_related_entity_filters", "condition_occurrence_related_entity_filter", 
        "condition_occurrence_sub_filter", "condition_occurrence_error_sub_filter", 
        "condition_occurrence_error_filter", "drug_exposure_event_criteria", 
        "drug_exposure_event_filter", "drug_exposure_concept_filters", "drug_exposure_concept_group_filter", 
        "drug_exposure_concept_filter", "drug_exposure_numeric_filters", 
        "drug_exposure_float_filter", "drug_exposure_int_filter", "drug_exposure_uniqueness_filters", 
        "drug_exposure_uniqueness_filter", "drug_exposure_related_entity_filters", 
        "drug_exposure_related_entity_filter", "drug_exposure_error_filter", 
        "measurement_event_criteria", "measurement_event_filter", "measurement_concept_filters", 
        "measurement_concept_group_filter", "measurement_concept_filter", 
        "measurement_numeric_filters", "measurement_float_filter", "measurement_uniqueness_filters", 
        "measurement_uniqueness_filter", "measurement_related_entity_filters", 
        "measurement_related_entity_filter", "measurement_error_filter", 
        "observation_event_criteria", "observation_event_filter", "observation_concept_filters", 
        "observation_concept_group_filter", "observation_concept_filter", 
        "observation_numeric_filters", "observation_float_filter", "observation_uniqueness_filters", 
        "observation_uniqueness_filter", "observation_related_entity_filters", 
        "observation_related_entity_filter", "observation_error_filter", 
        "procedure_occurrence_event_criteria", "procedure_occurrence_event_filter", 
        "procedure_occurrence_concept_filters", "procedure_occurrence_concept_group_filter", 
        "procedure_occurrence_concept_filter", "procedure_occurrence_numeric_filters", 
        "procedure_occurrence_int_filter", "procedure_occurrence_uniqueness_filters", 
        "procedure_occurrence_uniqueness_filter", "procedure_occurrence_related_entity_filters", 
        "procedure_occurrence_related_entity_filter", "procedure_occurrence_error_filter", 
        "provider_concept_filters", "provider_concept_group_filter", "provider_concept_filter", 
        "provider_sub_filter", "provider_error_sub_filter", "visit_occurrence_event_criteria", 
        "visit_occurrence_event_filter", "visit_occurrence_concept_filters", 
        "visit_occurrence_concept_group_filter", "visit_occurrence_concept_filter", 
        "visit_occurrence_uniqueness_filters", "visit_occurrence_uniqueness_filter", 
        "visit_occurrence_related_entity_filters", "visit_occurrence_related_entity_filter", 
        "visit_occurrence_sub_filter", "visit_occurrence_error_sub_filter", 
        "visit_occurrence_error_filter", "comparison_op", "simple_uniqueness_filter", 
        "simple_uniqueness_filter_window", "fixed_window_uniqueness_filter", 
        "rolling_window_uniqueness_filter", "simple_event_float", "simple_event_int", 
        "concept_group_selection",
    ];

    public get grammarFileName(): string { return "CohortDefinition.g4"; }
    public get literalNames(): (string | null)[] { return CohortDefinition.literalNames; }
    public get symbolicNames(): (string | null)[] { return CohortDefinition.symbolicNames; }
    public get ruleNames(): string[] { return CohortDefinition.ruleNames; }
    public get serializedATN(): number[] { return CohortDefinition._serializedATN; }

    protected createFailedPredicateException(predicate?: string, message?: string): antlr.FailedPredicateException {
        return new antlr.FailedPredicateException(this, predicate, message);
    }

    public constructor(input: antlr.TokenStream) {
        super(input);
        this.interpreter = new antlr.ParserATNSimulator(this, CohortDefinition._ATN, CohortDefinition.decisionsToDFA, new antlr.PredictionContextCache());
    }
    public cohort_definition(): Cohort_definitionContext {
        let localContext = new Cohort_definitionContext(this.context, this.state);
        this.enterRule(localContext, 0, CohortDefinition.RULE_cohort_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            {
            this.state = 350;
            this.inclusion_criteria();
            }
            this.state = 352;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 2) {
                {
                this.state = 351;
                this.exclusion_criteria();
                }
            }

            this.state = 355;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 3) {
                {
                this.state = 354;
                this.study_period_criteria();
                }
            }

            this.state = 358;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 4) {
                {
                this.state = 357;
                this.baseline_period_criteria();
                }
            }

            this.state = 361;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 5) {
                {
                this.state = 360;
                this.follow_up_period_criteria();
                }
            }

            this.state = 364;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            do {
                {
                {
                this.state = 363;
                this.subjects_variable();
                }
                }
                this.state = 366;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            } while (_la === 66);
            this.state = 369;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 6) {
                {
                this.state = 368;
                this.index_date();
                }
            }

            this.state = 374;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (((((_la - 63)) & ~0x1F) === 0 && ((1 << (_la - 63)) & 7) !== 0)) {
                {
                {
                this.state = 371;
                this.derived_event();
                }
                }
                this.state = 376;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            this.state = 378;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            do {
                {
                {
                this.state = 377;
                this.simple_event();
                }
                }
                this.state = 380;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            } while (((((_la - 55)) & ~0x1F) === 0 && ((1 << (_la - 55)) & 175) !== 0));
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public inclusion_criteria(): Inclusion_criteriaContext {
        let localContext = new Inclusion_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 2, CohortDefinition.RULE_inclusion_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 382;
            this.match(CohortDefinition.INCLUDE);
            this.state = 383;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 384;
            this.cohort_criterion_set();
            this.state = 385;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 386;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public exclusion_criteria(): Exclusion_criteriaContext {
        let localContext = new Exclusion_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 4, CohortDefinition.RULE_exclusion_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 388;
            this.match(CohortDefinition.EXCLUDE);
            this.state = 389;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 390;
            this.cohort_criterion_set();
            this.state = 391;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 392;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public cohort_criterion_set(): Cohort_criterion_setContext {
        let localContext = new Cohort_criterion_setContext(this.context, this.state);
        this.enterRule(localContext, 6, CohortDefinition.RULE_cohort_criterion_set);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 394;
            this.match(CohortDefinition.SUBJECTS_VARIABLE_NAME);
            this.state = 399;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 89) {
                {
                {
                this.state = 395;
                this.match(CohortDefinition.COMMA);
                this.state = 396;
                this.match(CohortDefinition.SUBJECTS_VARIABLE_NAME);
                }
                }
                this.state = 401;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public study_period_criteria(): Study_period_criteriaContext {
        let localContext = new Study_period_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 8, CohortDefinition.RULE_study_period_criteria);
        try {
            this.state = 406;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 9, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 402;
                this.overall_study_period();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 403;
                this.overall_study_period_error();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 404;
                this.overall_study_period_error2();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 405;
                this.overall_study_period_error3();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public baseline_period_criteria(): Baseline_period_criteriaContext {
        let localContext = new Baseline_period_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 10, CohortDefinition.RULE_baseline_period_criteria);
        try {
            this.state = 410;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 10, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 408;
                this.baseline_period();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 409;
                this.baseline_period_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public follow_up_period_criteria(): Follow_up_period_criteriaContext {
        let localContext = new Follow_up_period_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 12, CohortDefinition.RULE_follow_up_period_criteria);
        try {
            this.state = 414;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 11, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 412;
                this.follow_up_period();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 413;
                this.follow_up_period_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public overall_study_period(): Overall_study_periodContext {
        let localContext = new Overall_study_periodContext(this.context, this.state);
        this.enterRule(localContext, 14, CohortDefinition.RULE_overall_study_period);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 416;
            this.match(CohortDefinition.STUDY_PERIOD);
            this.state = 417;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 418;
            this.match(CohortDefinition.DATE);
            this.state = 419;
            this.match(CohortDefinition.COMMA);
            this.state = 420;
            this.match(CohortDefinition.DATE);
            this.state = 421;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 422;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public overall_study_period_error(): Overall_study_period_errorContext {
        let localContext = new Overall_study_period_errorContext(this.context, this.state);
        this.enterRule(localContext, 16, CohortDefinition.RULE_overall_study_period_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 424;
            this.match(CohortDefinition.STUDY_PERIOD);
            this.state = 425;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 426;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 427;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public overall_study_period_error2(): Overall_study_period_error2Context {
        let localContext = new Overall_study_period_error2Context(this.context, this.state);
        this.enterRule(localContext, 18, CohortDefinition.RULE_overall_study_period_error2);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 429;
            this.match(CohortDefinition.STUDY_PERIOD);
            this.state = 430;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 431;
            this.match(CohortDefinition.DATE);
            this.state = 432;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 433;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public overall_study_period_error3(): Overall_study_period_error3Context {
        let localContext = new Overall_study_period_error3Context(this.context, this.state);
        this.enterRule(localContext, 20, CohortDefinition.RULE_overall_study_period_error3);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 435;
            this.match(CohortDefinition.STUDY_PERIOD);
            this.state = 436;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 437;
            this.match(CohortDefinition.DATE);
            this.state = 438;
            this.match(CohortDefinition.COMMA);
            this.state = 439;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 440;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public baseline_period(): Baseline_periodContext {
        let localContext = new Baseline_periodContext(this.context, this.state);
        this.enterRule(localContext, 22, CohortDefinition.RULE_baseline_period);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 442;
            this.match(CohortDefinition.BASELINE);
            this.state = 443;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 444;
            this.match(CohortDefinition.INT);
            this.state = 445;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 446;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public baseline_period_error(): Baseline_period_errorContext {
        let localContext = new Baseline_period_errorContext(this.context, this.state);
        this.enterRule(localContext, 24, CohortDefinition.RULE_baseline_period_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 448;
            this.match(CohortDefinition.BASELINE);
            this.state = 449;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 450;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 451;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public follow_up_period(): Follow_up_periodContext {
        let localContext = new Follow_up_periodContext(this.context, this.state);
        this.enterRule(localContext, 26, CohortDefinition.RULE_follow_up_period);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 453;
            this.match(CohortDefinition.FOLLOW_UP);
            this.state = 454;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 455;
            this.match(CohortDefinition.INT);
            this.state = 456;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 457;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public follow_up_period_error(): Follow_up_period_errorContext {
        let localContext = new Follow_up_period_errorContext(this.context, this.state);
        this.enterRule(localContext, 28, CohortDefinition.RULE_follow_up_period_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 459;
            this.match(CohortDefinition.FOLLOW_UP);
            this.state = 460;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 461;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 462;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public subjects_variable(): Subjects_variableContext {
        let localContext = new Subjects_variableContext(this.context, this.state);
        this.enterRule(localContext, 30, CohortDefinition.RULE_subjects_variable);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 464;
            this.match(CohortDefinition.SUBJECTS_VARIABLE_NAME);
            this.state = 465;
            this.match(CohortDefinition.EQ);
            this.state = 469;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 12, this.context) ) {
            case 1:
                {
                this.state = 466;
                this.demographic_event_criteria();
                }
                break;
            case 2:
                {
                this.state = 467;
                this.event_count_criteria();
                }
                break;
            case 3:
                {
                this.state = 468;
                this.event_count_criteria_error();
                }
                break;
            }
            this.state = 471;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public event_count_criteria(): Event_count_criteriaContext {
        let localContext = new Event_count_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 32, CohortDefinition.RULE_event_count_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 473;
            localContext._prefix = this.match(CohortDefinition.COUNT);
            this.state = 474;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 475;
            localContext._criteria = this.count_criteria();
            this.state = 476;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public count_criteria(): Count_criteriaContext {
        let localContext = new Count_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 34, CohortDefinition.RULE_count_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 478;
            this.subject_variable_event_name();
            this.state = 479;
            this.comparison_op();
            this.state = 480;
            this.match(CohortDefinition.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public event_count_criteria_error(): Event_count_criteria_errorContext {
        let localContext = new Event_count_criteria_errorContext(this.context, this.state);
        this.enterRule(localContext, 36, CohortDefinition.RULE_event_count_criteria_error);
        try {
            this.state = 496;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 13, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 482;
                this.match(CohortDefinition.COUNT);
                this.state = 483;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 484;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 485;
                this.match(CohortDefinition.COUNT);
                this.state = 486;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 487;
                this.subject_variable_event_name();
                this.state = 488;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 490;
                this.match(CohortDefinition.COUNT);
                this.state = 491;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 492;
                this.subject_variable_event_name();
                this.state = 493;
                this.comparison_op();
                this.state = 494;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_event_criteria(): Demographic_event_criteriaContext {
        let localContext = new Demographic_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 38, CohortDefinition.RULE_demographic_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 498;
            localContext._prefix = this.match(CohortDefinition.PERSON);
            this.state = 499;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 501;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 19 || _la === 22) {
                {
                this.state = 500;
                this.demographic_event_filters();
                }
            }

            this.state = 503;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_event_filters(): Demographic_event_filtersContext {
        let localContext = new Demographic_event_filtersContext(this.context, this.state);
        this.enterRule(localContext, 40, CohortDefinition.RULE_demographic_event_filters);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 505;
            this.demographic_event_filter();
            this.state = 510;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 89) {
                {
                {
                this.state = 506;
                this.match(CohortDefinition.COMMA);
                this.state = 507;
                this.demographic_event_filter();
                }
                }
                this.state = 512;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_event_filter(): Demographic_event_filterContext {
        let localContext = new Demographic_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 42, CohortDefinition.RULE_demographic_event_filter);
        try {
            this.state = 516;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 16, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 513;
                this.demographic_concept_filter();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 514;
                this.demographic_numeric_filter();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 515;
                this.demographic_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_concept_filter(): Demographic_concept_filterContext {
        let localContext = new Demographic_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 44, CohortDefinition.RULE_demographic_concept_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 518;
            this.match(CohortDefinition.CF);
            this.state = 519;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 522;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 17, this.context) ) {
            case 1:
                {
                this.state = 520;
                this.demographic_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 521;
                this.demographic_concept_id_filter();
                }
                break;
            }
            this.state = 524;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_concept_group_filter(): Demographic_concept_group_filterContext {
        let localContext = new Demographic_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 46, CohortDefinition.RULE_demographic_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 526;
            this.match(CohortDefinition.PERSON_CONCEPT_ATTRIBUTE);
            this.state = 527;
            this.match(CohortDefinition.IN);
            this.state = 528;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_concept_id_filter(): Demographic_concept_id_filterContext {
        let localContext = new Demographic_concept_id_filterContext(this.context, this.state);
        this.enterRule(localContext, 48, CohortDefinition.RULE_demographic_concept_id_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 530;
            this.match(CohortDefinition.PERSON_CONCEPT_ATTRIBUTE);
            this.state = 531;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 90 || _la === 96)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 532;
            this.match(CohortDefinition.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_numeric_filter(): Demographic_numeric_filterContext {
        let localContext = new Demographic_numeric_filterContext(this.context, this.state);
        this.enterRule(localContext, 50, CohortDefinition.RULE_demographic_numeric_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 534;
            this.match(CohortDefinition.NF);
            this.state = 535;
            this.match(CohortDefinition.OPEN_PAREN);
            {
            this.state = 536;
            this.demographic_int_filter();
            }
            this.state = 537;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_int_filter(): Demographic_int_filterContext {
        let localContext = new Demographic_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 52, CohortDefinition.RULE_demographic_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 539;
            this.match(CohortDefinition.PERSON_INT_ATTRIBUTE);
            this.state = 540;
            this.comparison_op();
            this.state = 541;
            this.match(CohortDefinition.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_error_filter(): Demographic_error_filterContext {
        let localContext = new Demographic_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 54, CohortDefinition.RULE_demographic_error_filter);
        try {
            this.state = 568;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 18, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 543;
                this.match(CohortDefinition.CF);
                this.state = 544;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 545;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 546;
                this.match(CohortDefinition.CF);
                this.state = 547;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 548;
                this.match(CohortDefinition.PERSON_CONCEPT_ATTRIBUTE);
                this.state = 549;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 550;
                this.match(CohortDefinition.CF);
                this.state = 551;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 552;
                this.match(CohortDefinition.PERSON_CONCEPT_ATTRIBUTE);
                this.state = 553;
                this.match(CohortDefinition.IN);
                this.state = 554;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 555;
                this.match(CohortDefinition.NF);
                this.state = 556;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 557;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 558;
                this.match(CohortDefinition.NF);
                this.state = 559;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 560;
                this.match(CohortDefinition.PERSON_INT_ATTRIBUTE);
                this.state = 561;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 562;
                this.match(CohortDefinition.NF);
                this.state = 563;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 564;
                this.match(CohortDefinition.PERSON_INT_ATTRIBUTE);
                this.state = 565;
                this.comparison_op();
                this.state = 566;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public subject_variable_event_name(): Subject_variable_event_nameContext {
        let localContext = new Subject_variable_event_nameContext(this.context, this.state);
        this.enterRule(localContext, 56, CohortDefinition.RULE_subject_variable_event_name);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 570;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 44)) & ~0x1F) === 0 && ((1 << (_la - 44)) & 511) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date(): Index_dateContext {
        let localContext = new Index_dateContext(this.context, this.state);
        this.enterRule(localContext, 58, CohortDefinition.RULE_index_date);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 572;
            this.match(CohortDefinition.INDEX_DATE);
            this.state = 573;
            this.match(CohortDefinition.EQ);
            this.state = 574;
            this.index_date_definition();
            this.state = 575;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date_definition(): Index_date_definitionContext {
        let localContext = new Index_date_definitionContext(this.context, this.state);
        this.enterRule(localContext, 60, CohortDefinition.RULE_index_date_definition);
        try {
            this.state = 581;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 19, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 577;
                this.calendar_date();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 578;
                this.calendarError();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 579;
                this.index_event_date();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 580;
                this.index_event_date_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public calendar_date(): Calendar_dateContext {
        let localContext = new Calendar_dateContext(this.context, this.state);
        this.enterRule(localContext, 62, CohortDefinition.RULE_calendar_date);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 583;
            localContext._index_date_type = this.match(CohortDefinition.CALENDAR_DATE);
            this.state = 584;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 585;
            this.match(CohortDefinition.DATE);
            this.state = 586;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_event_date(): Index_event_dateContext {
        let localContext = new Index_event_dateContext(this.context, this.state);
        this.enterRule(localContext, 64, CohortDefinition.RULE_index_event_date);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 588;
            localContext._index_date_type = this.match(CohortDefinition.EVENT);
            this.state = 589;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 590;
            localContext._date = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 65 || _la === 161)) {
                localContext._date = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 593;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 89) {
                {
                this.state = 591;
                this.match(CohortDefinition.COMMA);
                this.state = 592;
                this.index_date_bounds();
                }
            }

            this.state = 595;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date_bounds(): Index_date_boundsContext {
        let localContext = new Index_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 66, CohortDefinition.RULE_index_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 599;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 21, this.context) ) {
            case 1:
                {
                this.state = 597;
                this.lower_date_bounds();
                }
                break;
            case 2:
                {
                this.state = 598;
                this.lower_date_bounds_error();
                }
                break;
            }
            this.state = 601;
            this.match(CohortDefinition.COMMA);
            this.state = 604;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 22, this.context) ) {
            case 1:
                {
                this.state = 602;
                this.upper_date_bounds();
                }
                break;
            case 2:
                {
                this.state = 603;
                this.upper_date_bounds_error();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public upper_date_bounds(): Upper_date_boundsContext {
        let localContext = new Upper_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 68, CohortDefinition.RULE_upper_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 606;
            this.match(CohortDefinition.UPPER_DATE_BOUND);
            this.state = 607;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 608;
            this.match(CohortDefinition.DATE);
            this.state = 609;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public lower_date_bounds(): Lower_date_boundsContext {
        let localContext = new Lower_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 70, CohortDefinition.RULE_lower_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 611;
            this.match(CohortDefinition.LOWER_DATE_BOUND);
            this.state = 612;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 613;
            this.match(CohortDefinition.DATE);
            this.state = 614;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public calendarError(): CalendarErrorContext {
        let localContext = new CalendarErrorContext(this.context, this.state);
        this.enterRule(localContext, 72, CohortDefinition.RULE_calendarError);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 616;
            this.match(CohortDefinition.CALENDAR_DATE);
            this.state = 617;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 618;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_event_date_error(): Index_event_date_errorContext {
        let localContext = new Index_event_date_errorContext(this.context, this.state);
        this.enterRule(localContext, 74, CohortDefinition.RULE_index_event_date_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 620;
            this.match(CohortDefinition.EVENT);
            this.state = 621;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 622;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public lower_date_bounds_error(): Lower_date_bounds_errorContext {
        let localContext = new Lower_date_bounds_errorContext(this.context, this.state);
        this.enterRule(localContext, 76, CohortDefinition.RULE_lower_date_bounds_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 624;
            this.match(CohortDefinition.LOWER_DATE_BOUND);
            this.state = 625;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 626;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public upper_date_bounds_error(): Upper_date_bounds_errorContext {
        let localContext = new Upper_date_bounds_errorContext(this.context, this.state);
        this.enterRule(localContext, 78, CohortDefinition.RULE_upper_date_bounds_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 628;
            this.match(CohortDefinition.UPPER_DATE_BOUND);
            this.state = 629;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 630;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event(): Derived_eventContext {
        let localContext = new Derived_eventContext(this.context, this.state);
        this.enterRule(localContext, 80, CohortDefinition.RULE_derived_event);
        try {
            this.state = 635;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.MERGED_EVENT_NAME:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 632;
                this.merged_event();
                }
                break;
            case CohortDefinition.SEQUENCE_EVENT_NAME:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 633;
                this.sequence_event();
                }
                break;
            case CohortDefinition.INSTANCE_EVENT_NAME:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 634;
                this.instance_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event(): Merged_eventContext {
        let localContext = new Merged_eventContext(this.context, this.state);
        this.enterRule(localContext, 82, CohortDefinition.RULE_merged_event);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 637;
            this.match(CohortDefinition.MERGED_EVENT_NAME);
            this.state = 638;
            this.match(CohortDefinition.EQ);
            this.state = 639;
            this.match(CohortDefinition.MERGED_EVENT);
            this.state = 640;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 641;
            this.merged_event_criteria();
            this.state = 644;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 89) {
                {
                this.state = 642;
                this.match(CohortDefinition.COMMA);
                this.state = 643;
                this.merged_event_filter_criterion();
                }
            }

            this.state = 646;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 647;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_criteria(): Merged_event_criteriaContext {
        let localContext = new Merged_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 84, CohortDefinition.RULE_merged_event_criteria);
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 649;
            this.merged_event_criterion();
            this.state = 652;
            this.errorHandler.sync(this);
            alternative = 1;
            do {
                switch (alternative) {
                case 1:
                    {
                    {
                    this.state = 650;
                    this.match(CohortDefinition.COMMA);
                    this.state = 651;
                    this.merged_event_criterion();
                    }
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                this.state = 654;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 25, this.context);
            } while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_criterion(): Merged_event_criterionContext {
        let localContext = new Merged_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 86, CohortDefinition.RULE_merged_event_criterion);
        try {
            this.state = 658;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 26, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 656;
                this.merged_event_event();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 657;
                this.derived_event_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter_criterion(): Merged_event_filter_criterionContext {
        let localContext = new Merged_event_filter_criterionContext(this.context, this.state);
        this.enterRule(localContext, 88, CohortDefinition.RULE_merged_event_filter_criterion);
        try {
            this.state = 662;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 27, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 660;
                this.merged_event_filter();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 661;
                this.merged_event_filter_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_event(): Merged_event_eventContext {
        let localContext = new Merged_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 90, CohortDefinition.RULE_merged_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 664;
            this.match(CohortDefinition.DERIVED_EVENT);
            this.state = 665;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 668;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case CohortDefinition.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case CohortDefinition.QUALIFIED_MEASUREMENT_ALIAS:
            case CohortDefinition.QUALIFIED_OBSERVATION_ALIAS:
            case CohortDefinition.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case CohortDefinition.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 666;
                this.qualified_simple_event();
                }
                break;
            case CohortDefinition.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 667;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 670;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter(): Merged_event_filterContext {
        let localContext = new Merged_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 92, CohortDefinition.RULE_merged_event_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 672;
            this.merged_event_uniqueness_filter();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_uniqueness_filter(): Merged_event_uniqueness_filterContext {
        let localContext = new Merged_event_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 94, CohortDefinition.RULE_merged_event_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 674;
            this.match(CohortDefinition.UF);
            this.state = 675;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 676;
            this.merged_event_uniqueness_filter_criteria();
            this.state = 677;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_uniqueness_filter_criteria(): Merged_event_uniqueness_filter_criteriaContext {
        let localContext = new Merged_event_uniqueness_filter_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 96, CohortDefinition.RULE_merged_event_uniqueness_filter_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 681;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.MINIMUM_BETWEEN:
                {
                this.state = 679;
                this.derived_uniqueness_filter();
                }
                break;
            case CohortDefinition.FIXED_WINDOW:
            case CohortDefinition.ROLLING_WINDOW:
                {
                this.state = 680;
                this.derived_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 683;
            localContext._date_attr = this.match(CohortDefinition.DERIVED_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter_error(): Merged_event_filter_errorContext {
        let localContext = new Merged_event_filter_errorContext(this.context, this.state);
        this.enterRule(localContext, 98, CohortDefinition.RULE_merged_event_filter_error);
        try {
            this.state = 739;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 30, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 685;
                this.match(CohortDefinition.UF);
                this.state = 686;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 687;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 688;
                this.match(CohortDefinition.UF);
                this.state = 689;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 690;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 691;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 692;
                this.match(CohortDefinition.UF);
                this.state = 693;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 694;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 695;
                this.derived_event_int();
                this.state = 696;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 698;
                this.match(CohortDefinition.UF);
                this.state = 699;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 700;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 701;
                this.derived_event_int();
                this.state = 702;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 703;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 705;
                this.match(CohortDefinition.UF);
                this.state = 706;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 707;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 708;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 709;
                this.match(CohortDefinition.UF);
                this.state = 710;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 711;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 712;
                this.derived_event_int();
                this.state = 713;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 715;
                this.match(CohortDefinition.UF);
                this.state = 716;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 717;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 718;
                this.derived_event_int();
                this.state = 719;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 720;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 722;
                this.match(CohortDefinition.UF);
                this.state = 723;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 724;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 725;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 726;
                this.match(CohortDefinition.UF);
                this.state = 727;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 728;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 729;
                this.derived_event_int();
                this.state = 730;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 732;
                this.match(CohortDefinition.UF);
                this.state = 733;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 734;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 735;
                this.derived_event_int();
                this.state = 736;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 737;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event(): Sequence_eventContext {
        let localContext = new Sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 100, CohortDefinition.RULE_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 741;
            this.match(CohortDefinition.SEQUENCE_EVENT_NAME);
            this.state = 742;
            this.match(CohortDefinition.EQ);
            this.state = 743;
            this.match(CohortDefinition.SEQUENCE_EVENT);
            this.state = 744;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 745;
            this.sequence_event_criteria();
            this.state = 746;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 747;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_criteria(): Sequence_event_criteriaContext {
        let localContext = new Sequence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 102, CohortDefinition.RULE_sequence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 749;
            this.sequence_event_criterion();
            this.state = 754;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 89) {
                {
                {
                this.state = 750;
                this.match(CohortDefinition.COMMA);
                this.state = 751;
                this.sequence_event_criterion();
                }
                }
                this.state = 756;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_criterion(): Sequence_event_criterionContext {
        let localContext = new Sequence_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 104, CohortDefinition.RULE_sequence_event_criterion);
        try {
            this.state = 761;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 32, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 757;
                this.sequence_event_constraint();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 758;
                this.sequence_event_event();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 759;
                this.sequence_event_constraint_error();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 760;
                this.derived_event_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_constraint(): Sequence_event_constraintContext {
        let localContext = new Sequence_event_constraintContext(this.context, this.state);
        this.enterRule(localContext, 106, CohortDefinition.RULE_sequence_event_constraint);
        try {
            this.state = 765;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.ANY_ORDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 763;
                this.match(CohortDefinition.ANY_ORDER);
                }
                break;
            case CohortDefinition.TC:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 764;
                this.temporal_constraint();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public temporal_constraint(): Temporal_constraintContext {
        let localContext = new Temporal_constraintContext(this.context, this.state);
        this.enterRule(localContext, 108, CohortDefinition.RULE_temporal_constraint);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 767;
            this.match(CohortDefinition.TC);
            this.state = 768;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 769;
            this.sequence_temporal_filter();
            this.state = 770;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_temporal_filter(): Sequence_temporal_filterContext {
        let localContext = new Sequence_temporal_filterContext(this.context, this.state);
        this.enterRule(localContext, 110, CohortDefinition.RULE_sequence_temporal_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 772;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 121)) & ~0x1F) === 0 && ((1 << (_la - 121)) & 7) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 773;
            this.match(CohortDefinition.INT);
            this.state = 774;
            this.match(CohortDefinition.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_event(): Sequence_event_eventContext {
        let localContext = new Sequence_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 112, CohortDefinition.RULE_sequence_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 776;
            this.match(CohortDefinition.DERIVED_EVENT);
            this.state = 777;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 780;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 34, this.context) ) {
            case 1:
                {
                this.state = 778;
                this.selected_sequence_event();
                }
                break;
            case 2:
                {
                this.state = 779;
                this.unselected_sequence_event();
                }
                break;
            }
            this.state = 782;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public selected_sequence_event(): Selected_sequence_eventContext {
        let localContext = new Selected_sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 114, CohortDefinition.RULE_selected_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 786;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case CohortDefinition.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case CohortDefinition.QUALIFIED_MEASUREMENT_ALIAS:
            case CohortDefinition.QUALIFIED_OBSERVATION_ALIAS:
            case CohortDefinition.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case CohortDefinition.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 784;
                this.qualified_simple_event();
                }
                break;
            case CohortDefinition.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 785;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 788;
            this.match(CohortDefinition.COMMA);
            this.state = 789;
            this.match(CohortDefinition.IS_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public unselected_sequence_event(): Unselected_sequence_eventContext {
        let localContext = new Unselected_sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 116, CohortDefinition.RULE_unselected_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 793;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case CohortDefinition.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case CohortDefinition.QUALIFIED_MEASUREMENT_ALIAS:
            case CohortDefinition.QUALIFIED_OBSERVATION_ALIAS:
            case CohortDefinition.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case CohortDefinition.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 791;
                this.qualified_simple_event();
                }
                break;
            case CohortDefinition.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 792;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event(): Instance_eventContext {
        let localContext = new Instance_eventContext(this.context, this.state);
        this.enterRule(localContext, 118, CohortDefinition.RULE_instance_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 795;
            this.match(CohortDefinition.INSTANCE_EVENT_NAME);
            this.state = 796;
            this.match(CohortDefinition.EQ);
            this.state = 797;
            this.match(CohortDefinition.INSTANCE_EVENT);
            this.state = 798;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 799;
            this.instance_event_criteria();
            this.state = 800;
            this.match(CohortDefinition.CLOSE_PAREN);
            this.state = 801;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_criteria(): Instance_event_criteriaContext {
        let localContext = new Instance_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 120, CohortDefinition.RULE_instance_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 803;
            this.instance_event_criterion();
            this.state = 806;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            do {
                {
                {
                this.state = 804;
                this.match(CohortDefinition.COMMA);
                this.state = 805;
                this.instance_event_criterion();
                }
                }
                this.state = 808;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            } while (_la === 89);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_criterion(): Instance_event_criterionContext {
        let localContext = new Instance_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 122, CohortDefinition.RULE_instance_event_criterion);
        try {
            this.state = 815;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 38, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 811;
                this.instance_event_event();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 812;
                this.derived_event_error();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 813;
                this.instance_event_position();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 814;
                this.instance_event_position_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_event(): Instance_event_eventContext {
        let localContext = new Instance_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 124, CohortDefinition.RULE_instance_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 817;
            this.match(CohortDefinition.DERIVED_EVENT);
            this.state = 818;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 821;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case CohortDefinition.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case CohortDefinition.QUALIFIED_MEASUREMENT_ALIAS:
            case CohortDefinition.QUALIFIED_OBSERVATION_ALIAS:
            case CohortDefinition.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case CohortDefinition.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 819;
                this.qualified_simple_event();
                }
                break;
            case CohortDefinition.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 820;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 823;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_position(): Instance_event_positionContext {
        let localContext = new Instance_event_positionContext(this.context, this.state);
        this.enterRule(localContext, 126, CohortDefinition.RULE_instance_event_position);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 825;
            this.match(CohortDefinition.POSITION);
            this.state = 826;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 829;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.MAX:
            case CohortDefinition.MIN:
                {
                this.state = 827;
                this.aggregation_qualified();
                }
                break;
            case CohortDefinition.INDEX:
                {
                this.state = 828;
                this.specific_instance();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 831;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public aggregation_qualified(): Aggregation_qualifiedContext {
        let localContext = new Aggregation_qualifiedContext(this.context, this.state);
        this.enterRule(localContext, 128, CohortDefinition.RULE_aggregation_qualified);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 833;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 101 || _la === 102)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public specific_instance(): Specific_instanceContext {
        let localContext = new Specific_instanceContext(this.context, this.state);
        this.enterRule(localContext, 130, CohortDefinition.RULE_specific_instance);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 835;
            this.match(CohortDefinition.INDEX);
            this.state = 836;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 837;
            this.match(CohortDefinition.INT);
            this.state = 838;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_position_error(): Instance_event_position_errorContext {
        let localContext = new Instance_event_position_errorContext(this.context, this.state);
        this.enterRule(localContext, 132, CohortDefinition.RULE_instance_event_position_error);
        try {
            this.state = 849;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 41, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 840;
                this.match(CohortDefinition.POSITION);
                this.state = 841;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 842;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 843;
                this.match(CohortDefinition.POSITION);
                this.state = 844;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 845;
                this.match(CohortDefinition.INDEX);
                this.state = 846;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 847;
                this.match(CohortDefinition.CLOSE_PAREN);
                this.state = 848;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public qualified_simple_event(): Qualified_simple_eventContext {
        let localContext = new Qualified_simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 134, CohortDefinition.RULE_qualified_simple_event);
        try {
            this.state = 869;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 851;
                this.match(CohortDefinition.QUALIFIED_CONDITION_OCCURRENCE_ALIAS);
                this.state = 852;
                this.match(CohortDefinition.PERIOD);
                this.state = 853;
                this.match(CohortDefinition.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            case CohortDefinition.QUALIFIED_DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 854;
                this.match(CohortDefinition.QUALIFIED_DRUG_EXPOSURE_ALIAS);
                this.state = 855;
                this.match(CohortDefinition.PERIOD);
                this.state = 856;
                this.match(CohortDefinition.DRUG_EXPOSURE_DATE_ATTRIBUTE);
                }
                break;
            case CohortDefinition.QUALIFIED_MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 857;
                this.match(CohortDefinition.QUALIFIED_MEASUREMENT_ALIAS);
                this.state = 858;
                this.match(CohortDefinition.PERIOD);
                this.state = 859;
                this.match(CohortDefinition.MEASUREMENT_DATE_ATTRIBUTE);
                }
                break;
            case CohortDefinition.QUALIFIED_OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 860;
                this.match(CohortDefinition.QUALIFIED_OBSERVATION_ALIAS);
                this.state = 861;
                this.match(CohortDefinition.PERIOD);
                this.state = 862;
                this.match(CohortDefinition.OBSERVATION_DATE_ATTRIBUTE);
                }
                break;
            case CohortDefinition.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 863;
                this.match(CohortDefinition.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS);
                this.state = 864;
                this.match(CohortDefinition.PERIOD);
                this.state = 865;
                this.match(CohortDefinition.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            case CohortDefinition.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 866;
                this.match(CohortDefinition.QUALIFIED_VISIT_OCCURRENCE_ALIAS);
                this.state = 867;
                this.match(CohortDefinition.PERIOD);
                this.state = 868;
                this.match(CohortDefinition.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public qualified_derived_event(): Qualified_derived_eventContext {
        let localContext = new Qualified_derived_eventContext(this.context, this.state);
        this.enterRule(localContext, 136, CohortDefinition.RULE_qualified_derived_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 871;
            this.match(CohortDefinition.QUALIFIED_DERIVED_EVENT_NAME);
            this.state = 872;
            this.match(CohortDefinition.PERIOD);
            this.state = 873;
            this.match(CohortDefinition.DERIVED_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_constraint_error(): Sequence_event_constraint_errorContext {
        let localContext = new Sequence_event_constraint_errorContext(this.context, this.state);
        this.enterRule(localContext, 138, CohortDefinition.RULE_sequence_event_constraint_error);
        let _la: number;
        try {
            this.state = 887;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 43, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 875;
                this.match(CohortDefinition.TC);
                this.state = 876;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 877;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 878;
                this.match(CohortDefinition.TC);
                this.state = 879;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 880;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 121)) & ~0x1F) === 0 && ((1 << (_la - 121)) & 7) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 881;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 882;
                this.match(CohortDefinition.TC);
                this.state = 883;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 884;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 121)) & ~0x1F) === 0 && ((1 << (_la - 121)) & 7) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 885;
                this.match(CohortDefinition.INT);
                this.state = 886;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event_error(): Derived_event_errorContext {
        let localContext = new Derived_event_errorContext(this.context, this.state);
        this.enterRule(localContext, 140, CohortDefinition.RULE_derived_event_error);
        let _la: number;
        try {
            this.state = 901;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 44, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 889;
                this.match(CohortDefinition.DERIVED_EVENT);
                this.state = 890;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 891;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 892;
                this.match(CohortDefinition.DERIVED_EVENT);
                this.state = 893;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 894;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 35)) & ~0x1F) === 0 && ((1 << (_la - 35)) & 431) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 895;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 896;
                this.match(CohortDefinition.DERIVED_EVENT);
                this.state = 897;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 898;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 35)) & ~0x1F) === 0 && ((1 << (_la - 35)) & 431) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 899;
                this.match(CohortDefinition.PERIOD);
                this.state = 900;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_uniqueness_filter(): Derived_uniqueness_filterContext {
        let localContext = new Derived_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 142, CohortDefinition.RULE_derived_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 903;
            this.match(CohortDefinition.MINIMUM_BETWEEN);
            this.state = 904;
            this.derived_event_int();
            this.state = 905;
            this.match(CohortDefinition.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_uniqueness_filter_window(): Derived_uniqueness_filter_windowContext {
        let localContext = new Derived_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 144, CohortDefinition.RULE_derived_uniqueness_filter_window);
        try {
            this.state = 909;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 907;
                this.derived_fixed_window_uniqueness_filter();
                }
                break;
            case CohortDefinition.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 908;
                this.derived_rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_fixed_window_uniqueness_filter(): Derived_fixed_window_uniqueness_filterContext {
        let localContext = new Derived_fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 146, CohortDefinition.RULE_derived_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 911;
            this.match(CohortDefinition.FIXED_WINDOW);
            this.state = 912;
            this.derived_event_int();
            this.state = 913;
            this.match(CohortDefinition.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_rolling_window_uniqueness_filter(): Derived_rolling_window_uniqueness_filterContext {
        let localContext = new Derived_rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 148, CohortDefinition.RULE_derived_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 915;
            this.match(CohortDefinition.ROLLING_WINDOW);
            this.state = 916;
            this.derived_event_int();
            this.state = 917;
            this.match(CohortDefinition.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event_int(): Derived_event_intContext {
        let localContext = new Derived_event_intContext(this.context, this.state);
        this.enterRule(localContext, 150, CohortDefinition.RULE_derived_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 919;
            this.match(CohortDefinition.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event(): Simple_eventContext {
        let localContext = new Simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 152, CohortDefinition.RULE_simple_event);
        try {
            this.state = 927;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 921;
                this.condition_occurrence_event();
                }
                break;
            case CohortDefinition.DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 922;
                this.drug_exposure_event();
                }
                break;
            case CohortDefinition.MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 923;
                this.measurement_event();
                }
                break;
            case CohortDefinition.OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 924;
                this.observation_event();
                }
                break;
            case CohortDefinition.PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 925;
                this.procedure_occurrence_event();
                }
                break;
            case CohortDefinition.VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 926;
                this.visit_occurrence_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext {
        let localContext = new Condition_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 154, CohortDefinition.RULE_condition_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 929;
            localContext._event_name = this.match(CohortDefinition.CONDITION_OCCURRENCE_ALIAS);
            this.state = 930;
            this.match(CohortDefinition.EQ);
            this.state = 931;
            localContext._event_definition = this.condition_occurrence_event_definition();
            this.state = 932;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event(): Drug_exposure_eventContext {
        let localContext = new Drug_exposure_eventContext(this.context, this.state);
        this.enterRule(localContext, 156, CohortDefinition.RULE_drug_exposure_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 934;
            localContext._event_name = this.match(CohortDefinition.DRUG_EXPOSURE_ALIAS);
            this.state = 935;
            this.match(CohortDefinition.EQ);
            this.state = 936;
            localContext._event_definition = this.drug_exposure_event_definition();
            this.state = 937;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event(): Measurement_eventContext {
        let localContext = new Measurement_eventContext(this.context, this.state);
        this.enterRule(localContext, 158, CohortDefinition.RULE_measurement_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 939;
            localContext._event_name = this.match(CohortDefinition.MEASUREMENT_ALIAS);
            this.state = 940;
            this.match(CohortDefinition.EQ);
            this.state = 941;
            localContext._event_definition = this.measurement_event_definition();
            this.state = 942;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event(): Observation_eventContext {
        let localContext = new Observation_eventContext(this.context, this.state);
        this.enterRule(localContext, 160, CohortDefinition.RULE_observation_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 944;
            localContext._event_name = this.match(CohortDefinition.OBSERVATION_ALIAS);
            this.state = 945;
            this.match(CohortDefinition.EQ);
            this.state = 946;
            localContext._event_definition = this.observation_event_definition();
            this.state = 947;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext {
        let localContext = new Procedure_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 162, CohortDefinition.RULE_procedure_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 949;
            localContext._event_name = this.match(CohortDefinition.PROCEDURE_OCCURRENCE_ALIAS);
            this.state = 950;
            this.match(CohortDefinition.EQ);
            this.state = 951;
            localContext._event_definition = this.procedure_occurrence_event_definition();
            this.state = 952;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext {
        let localContext = new Visit_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 164, CohortDefinition.RULE_visit_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 954;
            localContext._event_name = this.match(CohortDefinition.VISIT_OCCURRENCE_ALIAS);
            this.state = 955;
            this.match(CohortDefinition.EQ);
            this.state = 956;
            localContext._event_definition = this.visit_occurrence_event_definition();
            this.state = 957;
            this.match(CohortDefinition.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        let localContext = new Condition_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 166, CohortDefinition.RULE_condition_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 959;
            localContext._prefix = this.match(CohortDefinition.CONDITION_OCCURRENCE);
            this.state = 960;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 962;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2416443392) !== 0)) {
                {
                this.state = 961;
                localContext._criteria = this.condition_occurrence_event_criteria();
                }
            }

            this.state = 964;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        let localContext = new Drug_exposure_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 168, CohortDefinition.RULE_drug_exposure_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 966;
            localContext._prefix = this.match(CohortDefinition.DRUG_EXPOSURE);
            this.state = 967;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 969;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2420637696) !== 0)) {
                {
                this.state = 968;
                localContext._criteria = this.drug_exposure_event_criteria();
                }
            }

            this.state = 971;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        let localContext = new Measurement_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 170, CohortDefinition.RULE_measurement_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 973;
            localContext._prefix = this.match(CohortDefinition.MEASUREMENT);
            this.state = 974;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 976;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2420637696) !== 0)) {
                {
                this.state = 975;
                localContext._criteria = this.measurement_event_criteria();
                }
            }

            this.state = 978;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        let localContext = new Observation_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 172, CohortDefinition.RULE_observation_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 980;
            localContext._prefix = this.match(CohortDefinition.OBSERVATION);
            this.state = 981;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 983;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2420637696) !== 0)) {
                {
                this.state = 982;
                localContext._criteria = this.observation_event_criteria();
                }
            }

            this.state = 985;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        let localContext = new Procedure_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 174, CohortDefinition.RULE_procedure_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 987;
            localContext._prefix = this.match(CohortDefinition.PROCEDURE_OCCURRENCE);
            this.state = 988;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 990;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2420637696) !== 0)) {
                {
                this.state = 989;
                localContext._criteria = this.procedure_occurrence_event_criteria();
                }
            }

            this.state = 992;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        let localContext = new Visit_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 176, CohortDefinition.RULE_visit_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 994;
            localContext._prefix = this.match(CohortDefinition.VISIT_OCCURRENCE);
            this.state = 995;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 997;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 2416443392) !== 0)) {
                {
                this.state = 996;
                localContext._criteria = this.visit_occurrence_event_criteria();
                }
            }

            this.state = 999;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext {
        let localContext = new Condition_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 178, CohortDefinition.RULE_condition_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1001;
            this.condition_occurrence_event_filter();
            this.state = 1006;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 89) {
                {
                {
                this.state = 1002;
                this.match(CohortDefinition.COMMA);
                this.state = 1003;
                this.condition_occurrence_event_filter();
                }
                }
                this.state = 1008;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext {
        let localContext = new Condition_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 180, CohortDefinition.RULE_condition_occurrence_event_filter);
        try {
            this.state = 1013;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 54, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1009;
                this.condition_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1010;
                this.condition_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1011;
                this.condition_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1012;
                this.condition_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext {
        let localContext = new Condition_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 182, CohortDefinition.RULE_condition_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1015;
            this.match(CohortDefinition.CF);
            this.state = 1016;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1019;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 55, this.context) ) {
            case 1:
                {
                this.state = 1017;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1018;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1021;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext {
        let localContext = new Condition_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 184, CohortDefinition.RULE_condition_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1023;
            this.match(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1024;
            this.match(CohortDefinition.IN);
            this.state = 1025;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext {
        let localContext = new Condition_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 186, CohortDefinition.RULE_condition_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1027;
            this.match(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1028;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 90 || _la === 96)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1029;
            this.match(CohortDefinition.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext {
        let localContext = new Condition_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 188, CohortDefinition.RULE_condition_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1031;
            this.match(CohortDefinition.UF);
            this.state = 1032;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1033;
            this.condition_occurrence_uniqueness_filter();
            this.state = 1034;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        let localContext = new Condition_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 190, CohortDefinition.RULE_condition_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1038;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.MINIMUM_BETWEEN:
                {
                this.state = 1036;
                this.simple_uniqueness_filter();
                }
                break;
            case CohortDefinition.FIXED_WINDOW:
            case CohortDefinition.ROLLING_WINDOW:
                {
                this.state = 1037;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1040;
            localContext._date_attr = this.match(CohortDefinition.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext {
        let localContext = new Condition_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 192, CohortDefinition.RULE_condition_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1042;
            this.match(CohortDefinition.RF);
            this.state = 1043;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1044;
            this.condition_occurrence_related_entity_filter();
            this.state = 1045;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        let localContext = new Condition_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 194, CohortDefinition.RULE_condition_occurrence_related_entity_filter);
        try {
            this.state = 1049;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1047;
                this.provider_sub_filter();
                }
                break;
            case CohortDefinition.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1048;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext {
        let localContext = new Condition_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 196, CohortDefinition.RULE_condition_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1051;
            this.match(CohortDefinition.CONDITION_OCCURRENCE);
            this.state = 1054;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 58, this.context) ) {
            case 1:
                {
                this.state = 1052;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1053;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext {
        let localContext = new Condition_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 198, CohortDefinition.RULE_condition_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 1066;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 59, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1057;
                this.match(CohortDefinition.CONDITION_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1058;
                this.match(CohortDefinition.CONDITION_OCCURRENCE);
                this.state = 1059;
                this.match(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1060;
                this.match(CohortDefinition.CONDITION_OCCURRENCE);
                this.state = 1061;
                this.match(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1062;
                this.match(CohortDefinition.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1063;
                this.match(CohortDefinition.CONDITION_OCCURRENCE);
                this.state = 1064;
                this.match(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1065;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext {
        let localContext = new Condition_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 200, CohortDefinition.RULE_condition_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1152;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 60, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1068;
                this.match(CohortDefinition.CF);
                this.state = 1069;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1070;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1071;
                this.match(CohortDefinition.CF);
                this.state = 1072;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1073;
                this.match(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1074;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1075;
                this.match(CohortDefinition.CF);
                this.state = 1076;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1077;
                this.match(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1078;
                this.match(CohortDefinition.IN);
                this.state = 1079;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1080;
                this.match(CohortDefinition.CF);
                this.state = 1081;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1082;
                this.match(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1083;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1084;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1085;
                this.match(CohortDefinition.UF);
                this.state = 1086;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1087;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1088;
                this.match(CohortDefinition.UF);
                this.state = 1089;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1090;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1091;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1092;
                this.match(CohortDefinition.UF);
                this.state = 1093;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1094;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1095;
                this.simple_event_int();
                this.state = 1096;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1098;
                this.match(CohortDefinition.UF);
                this.state = 1099;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1100;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1101;
                this.simple_event_int();
                this.state = 1102;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1103;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1105;
                this.match(CohortDefinition.UF);
                this.state = 1106;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1107;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1108;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1109;
                this.match(CohortDefinition.UF);
                this.state = 1110;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1111;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1112;
                this.simple_event_int();
                this.state = 1113;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1115;
                this.match(CohortDefinition.UF);
                this.state = 1116;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1117;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1118;
                this.simple_event_int();
                this.state = 1119;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1120;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1122;
                this.match(CohortDefinition.UF);
                this.state = 1123;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1124;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1125;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1126;
                this.match(CohortDefinition.UF);
                this.state = 1127;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1128;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1129;
                this.simple_event_int();
                this.state = 1130;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1132;
                this.match(CohortDefinition.UF);
                this.state = 1133;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1134;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1135;
                this.simple_event_int();
                this.state = 1136;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1137;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1139;
                this.match(CohortDefinition.RF);
                this.state = 1140;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1141;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1142;
                this.match(CohortDefinition.RF);
                this.state = 1143;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1144;
                this.provider_error_sub_filter();
                this.state = 1145;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1147;
                this.match(CohortDefinition.RF);
                this.state = 1148;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1149;
                this.visit_occurrence_error_sub_filter();
                this.state = 1150;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext {
        let localContext = new Drug_exposure_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 202, CohortDefinition.RULE_drug_exposure_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1154;
            this.drug_exposure_event_filter();
            this.state = 1159;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 89) {
                {
                {
                this.state = 1155;
                this.match(CohortDefinition.COMMA);
                this.state = 1156;
                this.drug_exposure_event_filter();
                }
                }
                this.state = 1161;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext {
        let localContext = new Drug_exposure_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 204, CohortDefinition.RULE_drug_exposure_event_filter);
        try {
            this.state = 1167;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 62, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1162;
                this.drug_exposure_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1163;
                this.drug_exposure_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1164;
                this.drug_exposure_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1165;
                this.drug_exposure_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1166;
                this.drug_exposure_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext {
        let localContext = new Drug_exposure_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 206, CohortDefinition.RULE_drug_exposure_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1169;
            this.match(CohortDefinition.CF);
            this.state = 1170;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1173;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 63, this.context) ) {
            case 1:
                {
                this.state = 1171;
                this.drug_exposure_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1172;
                this.drug_exposure_concept_filter();
                }
                break;
            }
            this.state = 1175;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext {
        let localContext = new Drug_exposure_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 208, CohortDefinition.RULE_drug_exposure_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1177;
            this.match(CohortDefinition.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 1178;
            this.match(CohortDefinition.IN);
            this.state = 1179;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext {
        let localContext = new Drug_exposure_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 210, CohortDefinition.RULE_drug_exposure_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1181;
            this.match(CohortDefinition.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 1182;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 90 || _la === 96)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1183;
            this.match(CohortDefinition.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext {
        let localContext = new Drug_exposure_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 212, CohortDefinition.RULE_drug_exposure_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1185;
            this.match(CohortDefinition.NF);
            this.state = 1186;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1189;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.QUANTITY:
                {
                this.state = 1187;
                this.drug_exposure_float_filter();
                }
                break;
            case CohortDefinition.DRUG_EXPOSURE_INT_ATTRIBUTE:
                {
                this.state = 1188;
                this.drug_exposure_int_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1191;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext {
        let localContext = new Drug_exposure_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 214, CohortDefinition.RULE_drug_exposure_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1193;
            this.match(CohortDefinition.QUANTITY);
            this.state = 1194;
            this.comparison_op();
            this.state = 1195;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext {
        let localContext = new Drug_exposure_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 216, CohortDefinition.RULE_drug_exposure_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1197;
            this.match(CohortDefinition.DRUG_EXPOSURE_INT_ATTRIBUTE);
            this.state = 1198;
            this.comparison_op();
            this.state = 1199;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext {
        let localContext = new Drug_exposure_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 218, CohortDefinition.RULE_drug_exposure_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1201;
            this.match(CohortDefinition.UF);
            this.state = 1202;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1203;
            this.drug_exposure_uniqueness_filter();
            this.state = 1204;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        let localContext = new Drug_exposure_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 220, CohortDefinition.RULE_drug_exposure_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1208;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.MINIMUM_BETWEEN:
                {
                this.state = 1206;
                this.simple_uniqueness_filter();
                }
                break;
            case CohortDefinition.FIXED_WINDOW:
            case CohortDefinition.ROLLING_WINDOW:
                {
                this.state = 1207;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1210;
            this.match(CohortDefinition.DRUG_EXPOSURE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext {
        let localContext = new Drug_exposure_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 222, CohortDefinition.RULE_drug_exposure_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1212;
            this.match(CohortDefinition.RF);
            this.state = 1213;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1214;
            this.drug_exposure_related_entity_filter();
            this.state = 1215;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        let localContext = new Drug_exposure_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 224, CohortDefinition.RULE_drug_exposure_related_entity_filter);
        try {
            this.state = 1219;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1217;
                this.provider_sub_filter();
                }
                break;
            case CohortDefinition.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1218;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext {
        let localContext = new Drug_exposure_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 226, CohortDefinition.RULE_drug_exposure_error_filter);
        let _la: number;
        try {
            this.state = 1328;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 67, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1221;
                this.match(CohortDefinition.CF);
                this.state = 1222;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1223;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1224;
                this.match(CohortDefinition.CF);
                this.state = 1225;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1226;
                this.match(CohortDefinition.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 1227;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1228;
                this.match(CohortDefinition.CF);
                this.state = 1229;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1230;
                this.match(CohortDefinition.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 1231;
                this.match(CohortDefinition.IN);
                this.state = 1232;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1233;
                this.match(CohortDefinition.CF);
                this.state = 1234;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1235;
                this.match(CohortDefinition.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 1236;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1237;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1238;
                this.match(CohortDefinition.NF);
                this.state = 1239;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1240;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1241;
                this.match(CohortDefinition.NF);
                this.state = 1242;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1243;
                this.match(CohortDefinition.QUANTITY);
                this.state = 1244;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1245;
                this.match(CohortDefinition.NF);
                this.state = 1246;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1247;
                this.match(CohortDefinition.QUANTITY);
                this.state = 1248;
                this.comparison_op();
                this.state = 1249;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1251;
                this.match(CohortDefinition.NF);
                this.state = 1252;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1253;
                this.match(CohortDefinition.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 1254;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1255;
                this.match(CohortDefinition.NF);
                this.state = 1256;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1257;
                this.match(CohortDefinition.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 1258;
                this.comparison_op();
                this.state = 1259;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1261;
                this.match(CohortDefinition.UF);
                this.state = 1262;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1263;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1264;
                this.match(CohortDefinition.UF);
                this.state = 1265;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1266;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1267;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1268;
                this.match(CohortDefinition.UF);
                this.state = 1269;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1270;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1271;
                this.simple_event_int();
                this.state = 1272;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1274;
                this.match(CohortDefinition.UF);
                this.state = 1275;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1276;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1277;
                this.simple_event_int();
                this.state = 1278;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1279;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1281;
                this.match(CohortDefinition.UF);
                this.state = 1282;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1283;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1284;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1285;
                this.match(CohortDefinition.UF);
                this.state = 1286;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1287;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1288;
                this.simple_event_int();
                this.state = 1289;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1291;
                this.match(CohortDefinition.UF);
                this.state = 1292;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1293;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1294;
                this.simple_event_int();
                this.state = 1295;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1296;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1298;
                this.match(CohortDefinition.UF);
                this.state = 1299;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1300;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1301;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1302;
                this.match(CohortDefinition.UF);
                this.state = 1303;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1304;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1305;
                this.simple_event_int();
                this.state = 1306;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1308;
                this.match(CohortDefinition.UF);
                this.state = 1309;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1310;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1311;
                this.simple_event_int();
                this.state = 1312;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1313;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1315;
                this.match(CohortDefinition.RF);
                this.state = 1316;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1317;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1318;
                this.match(CohortDefinition.RF);
                this.state = 1319;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1320;
                this.provider_error_sub_filter();
                this.state = 1321;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1323;
                this.match(CohortDefinition.RF);
                this.state = 1324;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1325;
                this.visit_occurrence_error_sub_filter();
                this.state = 1326;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext {
        let localContext = new Measurement_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 228, CohortDefinition.RULE_measurement_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1330;
            this.measurement_event_filter();
            this.state = 1335;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 89) {
                {
                {
                this.state = 1331;
                this.match(CohortDefinition.COMMA);
                this.state = 1332;
                this.measurement_event_filter();
                }
                }
                this.state = 1337;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_filter(): Measurement_event_filterContext {
        let localContext = new Measurement_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 230, CohortDefinition.RULE_measurement_event_filter);
        try {
            this.state = 1343;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 69, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1338;
                this.measurement_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1339;
                this.measurement_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1340;
                this.measurement_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1341;
                this.measurement_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1342;
                this.measurement_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext {
        let localContext = new Measurement_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 232, CohortDefinition.RULE_measurement_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1345;
            this.match(CohortDefinition.CF);
            this.state = 1346;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1349;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 70, this.context) ) {
            case 1:
                {
                this.state = 1347;
                this.measurement_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1348;
                this.measurement_concept_filter();
                }
                break;
            }
            this.state = 1351;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext {
        let localContext = new Measurement_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 234, CohortDefinition.RULE_measurement_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1353;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 169 || _la === 175)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1354;
            this.match(CohortDefinition.IN);
            this.state = 1355;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filter(): Measurement_concept_filterContext {
        let localContext = new Measurement_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 236, CohortDefinition.RULE_measurement_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1357;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 169 || _la === 175)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1358;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 90 || _la === 96)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1359;
            this.match(CohortDefinition.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext {
        let localContext = new Measurement_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 238, CohortDefinition.RULE_measurement_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1361;
            this.match(CohortDefinition.NF);
            this.state = 1362;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1363;
            this.measurement_float_filter();
            this.state = 1364;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        let localContext = new Measurement_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 240, CohortDefinition.RULE_measurement_float_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1366;
            _la = this.tokenStream.LA(1);
            if(!(_la === 163 || _la === 165)) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1367;
            this.comparison_op();
            this.state = 1368;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext {
        let localContext = new Measurement_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 242, CohortDefinition.RULE_measurement_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1370;
            this.match(CohortDefinition.UF);
            this.state = 1371;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1372;
            this.measurement_uniqueness_filter();
            this.state = 1373;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        let localContext = new Measurement_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 244, CohortDefinition.RULE_measurement_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1377;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.MINIMUM_BETWEEN:
                {
                this.state = 1375;
                this.simple_uniqueness_filter();
                }
                break;
            case CohortDefinition.FIXED_WINDOW:
            case CohortDefinition.ROLLING_WINDOW:
                {
                this.state = 1376;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1379;
            this.match(CohortDefinition.MEASUREMENT_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext {
        let localContext = new Measurement_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 246, CohortDefinition.RULE_measurement_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1381;
            this.match(CohortDefinition.RF);
            this.state = 1382;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1383;
            this.measurement_related_entity_filter();
            this.state = 1384;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        let localContext = new Measurement_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 248, CohortDefinition.RULE_measurement_related_entity_filter);
        try {
            this.state = 1388;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1386;
                this.provider_sub_filter();
                }
                break;
            case CohortDefinition.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1387;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_error_filter(): Measurement_error_filterContext {
        let localContext = new Measurement_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 250, CohortDefinition.RULE_measurement_error_filter);
        let _la: number;
        try {
            this.state = 1501;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 73, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1390;
                this.match(CohortDefinition.CF);
                this.state = 1391;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1392;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1393;
                this.match(CohortDefinition.CF);
                this.state = 1394;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1395;
                this.match(CohortDefinition.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1396;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1397;
                this.match(CohortDefinition.CF);
                this.state = 1398;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1399;
                this.match(CohortDefinition.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1400;
                this.match(CohortDefinition.IN);
                this.state = 1401;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1402;
                this.match(CohortDefinition.CF);
                this.state = 1403;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1404;
                this.match(CohortDefinition.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1405;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1406;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1407;
                this.match(CohortDefinition.CF);
                this.state = 1408;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1409;
                this.match(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1410;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1411;
                this.match(CohortDefinition.CF);
                this.state = 1412;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1413;
                this.match(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1414;
                this.match(CohortDefinition.IN);
                this.state = 1415;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1416;
                this.match(CohortDefinition.CF);
                this.state = 1417;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1418;
                this.match(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1419;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1420;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1421;
                this.match(CohortDefinition.NF);
                this.state = 1422;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1423;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1424;
                this.match(CohortDefinition.NF);
                this.state = 1425;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1426;
                _la = this.tokenStream.LA(1);
                if(!(_la === 163 || _la === 165)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1427;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1428;
                this.match(CohortDefinition.NF);
                this.state = 1429;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1430;
                _la = this.tokenStream.LA(1);
                if(!(_la === 163 || _la === 165)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1431;
                this.comparison_op();
                this.state = 1432;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1434;
                this.match(CohortDefinition.UF);
                this.state = 1435;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1436;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1437;
                this.match(CohortDefinition.UF);
                this.state = 1438;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1439;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1440;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1441;
                this.match(CohortDefinition.UF);
                this.state = 1442;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1443;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1444;
                this.simple_event_int();
                this.state = 1445;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1447;
                this.match(CohortDefinition.UF);
                this.state = 1448;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1449;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1450;
                this.simple_event_int();
                this.state = 1451;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1452;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1454;
                this.match(CohortDefinition.UF);
                this.state = 1455;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1456;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1457;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1458;
                this.match(CohortDefinition.UF);
                this.state = 1459;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1460;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1461;
                this.simple_event_int();
                this.state = 1462;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1464;
                this.match(CohortDefinition.UF);
                this.state = 1465;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1466;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1467;
                this.simple_event_int();
                this.state = 1468;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1469;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1471;
                this.match(CohortDefinition.UF);
                this.state = 1472;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1473;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1474;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1475;
                this.match(CohortDefinition.UF);
                this.state = 1476;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1477;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1478;
                this.simple_event_int();
                this.state = 1479;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1481;
                this.match(CohortDefinition.UF);
                this.state = 1482;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1483;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1484;
                this.simple_event_int();
                this.state = 1485;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1486;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1488;
                this.match(CohortDefinition.RF);
                this.state = 1489;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1490;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1491;
                this.match(CohortDefinition.RF);
                this.state = 1492;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1493;
                this.provider_error_sub_filter();
                this.state = 1494;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 1496;
                this.match(CohortDefinition.RF);
                this.state = 1497;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1498;
                this.visit_occurrence_error_sub_filter();
                this.state = 1499;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_criteria(): Observation_event_criteriaContext {
        let localContext = new Observation_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 252, CohortDefinition.RULE_observation_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1503;
            this.observation_event_filter();
            this.state = 1508;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 89) {
                {
                {
                this.state = 1504;
                this.match(CohortDefinition.COMMA);
                this.state = 1505;
                this.observation_event_filter();
                }
                }
                this.state = 1510;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_filter(): Observation_event_filterContext {
        let localContext = new Observation_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 254, CohortDefinition.RULE_observation_event_filter);
        try {
            this.state = 1516;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 75, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1511;
                this.observation_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1512;
                this.observation_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1513;
                this.observation_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1514;
                this.observation_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1515;
                this.observation_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filters(): Observation_concept_filtersContext {
        let localContext = new Observation_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 256, CohortDefinition.RULE_observation_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1518;
            this.match(CohortDefinition.CF);
            this.state = 1519;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1522;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 76, this.context) ) {
            case 1:
                {
                this.state = 1520;
                this.observation_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1521;
                this.observation_concept_filter();
                }
                break;
            }
            this.state = 1524;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext {
        let localContext = new Observation_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 258, CohortDefinition.RULE_observation_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1526;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 170 || _la === 175)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1527;
            this.match(CohortDefinition.IN);
            this.state = 1528;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filter(): Observation_concept_filterContext {
        let localContext = new Observation_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 260, CohortDefinition.RULE_observation_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1530;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 170 || _la === 175)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1531;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 90 || _la === 96)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1532;
            this.match(CohortDefinition.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext {
        let localContext = new Observation_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 262, CohortDefinition.RULE_observation_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1534;
            this.match(CohortDefinition.NF);
            this.state = 1535;
            this.match(CohortDefinition.OPEN_PAREN);
            {
            this.state = 1536;
            this.observation_float_filter();
            }
            this.state = 1537;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_float_filter(): Observation_float_filterContext {
        let localContext = new Observation_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 264, CohortDefinition.RULE_observation_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1539;
            this.match(CohortDefinition.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
            this.state = 1540;
            this.comparison_op();
            this.state = 1541;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext {
        let localContext = new Observation_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 266, CohortDefinition.RULE_observation_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1543;
            this.match(CohortDefinition.UF);
            this.state = 1544;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1545;
            this.observation_uniqueness_filter();
            this.state = 1546;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        let localContext = new Observation_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 268, CohortDefinition.RULE_observation_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1550;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.MINIMUM_BETWEEN:
                {
                this.state = 1548;
                this.simple_uniqueness_filter();
                }
                break;
            case CohortDefinition.FIXED_WINDOW:
            case CohortDefinition.ROLLING_WINDOW:
                {
                this.state = 1549;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1552;
            this.match(CohortDefinition.OBSERVATION_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext {
        let localContext = new Observation_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 270, CohortDefinition.RULE_observation_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1554;
            this.match(CohortDefinition.RF);
            this.state = 1555;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1556;
            this.observation_related_entity_filter();
            this.state = 1557;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        let localContext = new Observation_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 272, CohortDefinition.RULE_observation_related_entity_filter);
        try {
            this.state = 1561;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1559;
                this.provider_sub_filter();
                }
                break;
            case CohortDefinition.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1560;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_error_filter(): Observation_error_filterContext {
        let localContext = new Observation_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 274, CohortDefinition.RULE_observation_error_filter);
        let _la: number;
        try {
            this.state = 1674;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 79, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1563;
                this.match(CohortDefinition.CF);
                this.state = 1564;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1565;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1566;
                this.match(CohortDefinition.CF);
                this.state = 1567;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1568;
                this.match(CohortDefinition.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1569;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1570;
                this.match(CohortDefinition.CF);
                this.state = 1571;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1572;
                this.match(CohortDefinition.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1573;
                this.match(CohortDefinition.IN);
                this.state = 1574;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1575;
                this.match(CohortDefinition.CF);
                this.state = 1576;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1577;
                this.match(CohortDefinition.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1578;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1579;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1580;
                this.match(CohortDefinition.CF);
                this.state = 1581;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1582;
                this.match(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1583;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1584;
                this.match(CohortDefinition.CF);
                this.state = 1585;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1586;
                this.match(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1587;
                this.match(CohortDefinition.IN);
                this.state = 1588;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1589;
                this.match(CohortDefinition.CF);
                this.state = 1590;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1591;
                this.match(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1592;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1593;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1594;
                this.match(CohortDefinition.NF);
                this.state = 1595;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1596;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1597;
                this.match(CohortDefinition.NF);
                this.state = 1598;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1599;
                this.match(CohortDefinition.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 1600;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1601;
                this.match(CohortDefinition.NF);
                this.state = 1602;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1603;
                this.match(CohortDefinition.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 1604;
                this.comparison_op();
                this.state = 1605;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1607;
                this.match(CohortDefinition.UF);
                this.state = 1608;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1609;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1610;
                this.match(CohortDefinition.UF);
                this.state = 1611;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1612;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1613;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1614;
                this.match(CohortDefinition.UF);
                this.state = 1615;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1616;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1617;
                this.simple_event_int();
                this.state = 1618;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1620;
                this.match(CohortDefinition.UF);
                this.state = 1621;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1622;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1623;
                this.simple_event_int();
                this.state = 1624;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1625;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1627;
                this.match(CohortDefinition.UF);
                this.state = 1628;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1629;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1630;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1631;
                this.match(CohortDefinition.UF);
                this.state = 1632;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1633;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1634;
                this.simple_event_int();
                this.state = 1635;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1637;
                this.match(CohortDefinition.UF);
                this.state = 1638;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1639;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1640;
                this.simple_event_int();
                this.state = 1641;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1642;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1644;
                this.match(CohortDefinition.UF);
                this.state = 1645;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1646;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1647;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1648;
                this.match(CohortDefinition.UF);
                this.state = 1649;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1650;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1651;
                this.simple_event_int();
                this.state = 1652;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1654;
                this.match(CohortDefinition.UF);
                this.state = 1655;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1656;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1657;
                this.simple_event_int();
                this.state = 1658;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1659;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1661;
                this.match(CohortDefinition.RF);
                this.state = 1662;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1663;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1664;
                this.match(CohortDefinition.RF);
                this.state = 1665;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1666;
                this.provider_error_sub_filter();
                this.state = 1667;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 1669;
                this.match(CohortDefinition.RF);
                this.state = 1670;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1671;
                this.visit_occurrence_error_sub_filter();
                this.state = 1672;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext {
        let localContext = new Procedure_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 276, CohortDefinition.RULE_procedure_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1676;
            this.procedure_occurrence_event_filter();
            this.state = 1681;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 89) {
                {
                {
                this.state = 1677;
                this.match(CohortDefinition.COMMA);
                this.state = 1678;
                this.procedure_occurrence_event_filter();
                }
                }
                this.state = 1683;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext {
        let localContext = new Procedure_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 278, CohortDefinition.RULE_procedure_occurrence_event_filter);
        try {
            this.state = 1689;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 81, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1684;
                this.procedure_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1685;
                this.procedure_occurrence_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1686;
                this.procedure_occurrence_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1687;
                this.procedure_occurrence_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1688;
                this.procedure_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext {
        let localContext = new Procedure_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 280, CohortDefinition.RULE_procedure_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1691;
            this.match(CohortDefinition.CF);
            this.state = 1692;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1695;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 82, this.context) ) {
            case 1:
                {
                this.state = 1693;
                this.procedure_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1694;
                this.procedure_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1697;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext {
        let localContext = new Procedure_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 282, CohortDefinition.RULE_procedure_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1699;
            this.match(CohortDefinition.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1700;
            this.match(CohortDefinition.IN);
            this.state = 1701;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext {
        let localContext = new Procedure_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 284, CohortDefinition.RULE_procedure_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1703;
            this.match(CohortDefinition.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1704;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 90 || _la === 96)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1705;
            this.match(CohortDefinition.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext {
        let localContext = new Procedure_occurrence_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 286, CohortDefinition.RULE_procedure_occurrence_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1707;
            this.match(CohortDefinition.NF);
            this.state = 1708;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1709;
            this.procedure_occurrence_int_filter();
            this.state = 1710;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        let localContext = new Procedure_occurrence_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 288, CohortDefinition.RULE_procedure_occurrence_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1712;
            this.match(CohortDefinition.QUANTITY);
            this.state = 1713;
            this.comparison_op();
            this.state = 1714;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext {
        let localContext = new Procedure_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 290, CohortDefinition.RULE_procedure_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1716;
            this.match(CohortDefinition.UF);
            this.state = 1717;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1718;
            this.procedure_occurrence_uniqueness_filter();
            this.state = 1719;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        let localContext = new Procedure_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 292, CohortDefinition.RULE_procedure_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1723;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.MINIMUM_BETWEEN:
                {
                this.state = 1721;
                this.simple_uniqueness_filter();
                }
                break;
            case CohortDefinition.FIXED_WINDOW:
            case CohortDefinition.ROLLING_WINDOW:
                {
                this.state = 1722;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1725;
            this.match(CohortDefinition.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext {
        let localContext = new Procedure_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 294, CohortDefinition.RULE_procedure_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1727;
            this.match(CohortDefinition.RF);
            this.state = 1728;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1729;
            this.procedure_occurrence_related_entity_filter();
            this.state = 1730;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        let localContext = new Procedure_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 296, CohortDefinition.RULE_procedure_occurrence_related_entity_filter);
        try {
            this.state = 1734;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1732;
                this.provider_sub_filter();
                }
                break;
            case CohortDefinition.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1733;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext {
        let localContext = new Procedure_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 298, CohortDefinition.RULE_procedure_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1833;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 85, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1736;
                this.match(CohortDefinition.CF);
                this.state = 1737;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1738;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1739;
                this.match(CohortDefinition.CF);
                this.state = 1740;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1741;
                this.match(CohortDefinition.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1742;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1743;
                this.match(CohortDefinition.CF);
                this.state = 1744;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1745;
                this.match(CohortDefinition.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1746;
                this.match(CohortDefinition.IN);
                this.state = 1747;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1748;
                this.match(CohortDefinition.CF);
                this.state = 1749;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1750;
                this.match(CohortDefinition.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1751;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1752;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1753;
                this.match(CohortDefinition.NF);
                this.state = 1754;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1755;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1756;
                this.match(CohortDefinition.NF);
                this.state = 1757;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1758;
                this.match(CohortDefinition.QUANTITY);
                this.state = 1759;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1760;
                this.match(CohortDefinition.NF);
                this.state = 1761;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1762;
                this.match(CohortDefinition.QUANTITY);
                this.state = 1763;
                this.comparison_op();
                this.state = 1764;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1766;
                this.match(CohortDefinition.UF);
                this.state = 1767;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1768;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1769;
                this.match(CohortDefinition.UF);
                this.state = 1770;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1771;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1772;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1773;
                this.match(CohortDefinition.UF);
                this.state = 1774;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1775;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1776;
                this.simple_event_int();
                this.state = 1777;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1779;
                this.match(CohortDefinition.UF);
                this.state = 1780;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1781;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1782;
                this.simple_event_int();
                this.state = 1783;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1784;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1786;
                this.match(CohortDefinition.UF);
                this.state = 1787;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1788;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1789;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1790;
                this.match(CohortDefinition.UF);
                this.state = 1791;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1792;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1793;
                this.simple_event_int();
                this.state = 1794;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1796;
                this.match(CohortDefinition.UF);
                this.state = 1797;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1798;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1799;
                this.simple_event_int();
                this.state = 1800;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1801;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1803;
                this.match(CohortDefinition.UF);
                this.state = 1804;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1805;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1806;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1807;
                this.match(CohortDefinition.UF);
                this.state = 1808;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1809;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1810;
                this.simple_event_int();
                this.state = 1811;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1813;
                this.match(CohortDefinition.UF);
                this.state = 1814;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1815;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1816;
                this.simple_event_int();
                this.state = 1817;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1818;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1820;
                this.match(CohortDefinition.RF);
                this.state = 1821;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1822;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1823;
                this.match(CohortDefinition.RF);
                this.state = 1824;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1825;
                this.provider_error_sub_filter();
                this.state = 1826;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1828;
                this.match(CohortDefinition.RF);
                this.state = 1829;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1830;
                this.visit_occurrence_error_sub_filter();
                this.state = 1831;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filters(): Provider_concept_filtersContext {
        let localContext = new Provider_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 300, CohortDefinition.RULE_provider_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1835;
            this.match(CohortDefinition.CF);
            this.state = 1836;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1839;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 86, this.context) ) {
            case 1:
                {
                this.state = 1837;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1838;
                this.provider_concept_filter();
                }
                break;
            }
            this.state = 1841;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext {
        let localContext = new Provider_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 302, CohortDefinition.RULE_provider_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1843;
            this.match(CohortDefinition.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1844;
            this.match(CohortDefinition.IN);
            this.state = 1845;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filter(): Provider_concept_filterContext {
        let localContext = new Provider_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 304, CohortDefinition.RULE_provider_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1847;
            this.match(CohortDefinition.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1848;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 90 || _la === 96)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1849;
            this.match(CohortDefinition.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_sub_filter(): Provider_sub_filterContext {
        let localContext = new Provider_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 306, CohortDefinition.RULE_provider_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1851;
            this.match(CohortDefinition.PROVIDER);
            this.state = 1854;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 87, this.context) ) {
            case 1:
                {
                this.state = 1852;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1853;
                this.provider_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext {
        let localContext = new Provider_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 308, CohortDefinition.RULE_provider_error_sub_filter);
        let _la: number;
        try {
            this.state = 1866;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 88, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1857;
                this.match(CohortDefinition.PROVIDER);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1858;
                this.match(CohortDefinition.PROVIDER);
                this.state = 1859;
                this.match(CohortDefinition.PROVIDER_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1860;
                this.match(CohortDefinition.PROVIDER);
                this.state = 1861;
                this.match(CohortDefinition.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1862;
                this.match(CohortDefinition.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1863;
                this.match(CohortDefinition.PROVIDER);
                this.state = 1864;
                this.match(CohortDefinition.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1865;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext {
        let localContext = new Visit_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 310, CohortDefinition.RULE_visit_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1868;
            this.visit_occurrence_event_filter();
            this.state = 1873;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 89) {
                {
                {
                this.state = 1869;
                this.match(CohortDefinition.COMMA);
                this.state = 1870;
                this.visit_occurrence_event_filter();
                }
                }
                this.state = 1875;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext {
        let localContext = new Visit_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 312, CohortDefinition.RULE_visit_occurrence_event_filter);
        try {
            this.state = 1880;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 90, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1876;
                this.visit_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1877;
                this.visit_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1878;
                this.visit_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1879;
                this.visit_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext {
        let localContext = new Visit_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 314, CohortDefinition.RULE_visit_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1882;
            this.match(CohortDefinition.CF);
            this.state = 1883;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1886;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 91, this.context) ) {
            case 1:
                {
                this.state = 1884;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1885;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1888;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext {
        let localContext = new Visit_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 316, CohortDefinition.RULE_visit_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1890;
            this.match(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1891;
            this.match(CohortDefinition.IN);
            this.state = 1892;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext {
        let localContext = new Visit_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 318, CohortDefinition.RULE_visit_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1894;
            this.match(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1895;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 90 || _la === 96)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1896;
            this.match(CohortDefinition.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext {
        let localContext = new Visit_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 320, CohortDefinition.RULE_visit_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1898;
            this.match(CohortDefinition.UF);
            this.state = 1899;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1900;
            this.visit_occurrence_uniqueness_filter();
            this.state = 1901;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        let localContext = new Visit_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 322, CohortDefinition.RULE_visit_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1905;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.MINIMUM_BETWEEN:
                {
                this.state = 1903;
                this.simple_uniqueness_filter();
                }
                break;
            case CohortDefinition.FIXED_WINDOW:
            case CohortDefinition.ROLLING_WINDOW:
                {
                this.state = 1904;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1907;
            this.match(CohortDefinition.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext {
        let localContext = new Visit_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 324, CohortDefinition.RULE_visit_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1909;
            this.match(CohortDefinition.RF);
            this.state = 1910;
            this.match(CohortDefinition.OPEN_PAREN);
            this.state = 1911;
            this.visit_occurrence_related_entity_filter();
            this.state = 1912;
            this.match(CohortDefinition.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        let localContext = new Visit_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 326, CohortDefinition.RULE_visit_occurrence_related_entity_filter);
        try {
            this.state = 1916;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1914;
                this.provider_sub_filter();
                }
                break;
            case CohortDefinition.CONDITION_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1915;
                this.condition_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext {
        let localContext = new Visit_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 328, CohortDefinition.RULE_visit_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1918;
            this.match(CohortDefinition.VISIT_OCCURRENCE);
            this.state = 1921;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 94, this.context) ) {
            case 1:
                {
                this.state = 1919;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1920;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext {
        let localContext = new Visit_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 330, CohortDefinition.RULE_visit_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 1933;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 95, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1924;
                this.match(CohortDefinition.VISIT_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1925;
                this.match(CohortDefinition.VISIT_OCCURRENCE);
                this.state = 1926;
                this.match(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1927;
                this.match(CohortDefinition.VISIT_OCCURRENCE);
                this.state = 1928;
                this.match(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1929;
                this.match(CohortDefinition.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1930;
                this.match(CohortDefinition.VISIT_OCCURRENCE);
                this.state = 1931;
                this.match(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1932;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext {
        let localContext = new Visit_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 332, CohortDefinition.RULE_visit_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 2019;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 96, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1935;
                this.match(CohortDefinition.CF);
                this.state = 1936;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1937;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1938;
                this.match(CohortDefinition.CF);
                this.state = 1939;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1940;
                this.match(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1941;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1942;
                this.match(CohortDefinition.CF);
                this.state = 1943;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1944;
                this.match(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1945;
                this.match(CohortDefinition.IN);
                this.state = 1946;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1947;
                this.match(CohortDefinition.CF);
                this.state = 1948;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1949;
                this.match(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1950;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 90 || _la === 96)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1951;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1952;
                this.match(CohortDefinition.UF);
                this.state = 1953;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1954;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1955;
                this.match(CohortDefinition.UF);
                this.state = 1956;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1957;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1958;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1959;
                this.match(CohortDefinition.UF);
                this.state = 1960;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1961;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1962;
                this.simple_event_int();
                this.state = 1963;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1965;
                this.match(CohortDefinition.UF);
                this.state = 1966;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1967;
                this.match(CohortDefinition.MINIMUM_BETWEEN);
                this.state = 1968;
                this.simple_event_int();
                this.state = 1969;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1970;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1972;
                this.match(CohortDefinition.UF);
                this.state = 1973;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1974;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1975;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1976;
                this.match(CohortDefinition.UF);
                this.state = 1977;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1978;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1979;
                this.simple_event_int();
                this.state = 1980;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1982;
                this.match(CohortDefinition.UF);
                this.state = 1983;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1984;
                this.match(CohortDefinition.FIXED_WINDOW);
                this.state = 1985;
                this.simple_event_int();
                this.state = 1986;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 1987;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1989;
                this.match(CohortDefinition.UF);
                this.state = 1990;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1991;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1992;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1993;
                this.match(CohortDefinition.UF);
                this.state = 1994;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 1995;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 1996;
                this.simple_event_int();
                this.state = 1997;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1999;
                this.match(CohortDefinition.UF);
                this.state = 2000;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 2001;
                this.match(CohortDefinition.ROLLING_WINDOW);
                this.state = 2002;
                this.simple_event_int();
                this.state = 2003;
                this.match(CohortDefinition.TIME_UNIT);
                this.state = 2004;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 2006;
                this.match(CohortDefinition.RF);
                this.state = 2007;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 2008;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 2009;
                this.match(CohortDefinition.RF);
                this.state = 2010;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 2011;
                this.provider_error_sub_filter();
                this.state = 2012;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 2014;
                this.match(CohortDefinition.RF);
                this.state = 2015;
                this.match(CohortDefinition.OPEN_PAREN);
                this.state = 2016;
                this.condition_occurrence_error_sub_filter();
                this.state = 2017;
                this.match(CohortDefinition.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public comparison_op(): Comparison_opContext {
        let localContext = new Comparison_opContext(this.context, this.state);
        this.enterRule(localContext, 334, CohortDefinition.RULE_comparison_op);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 2021;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 90)) & ~0x1F) === 0 && ((1 << (_la - 90)) & 1985) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext {
        let localContext = new Simple_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 336, CohortDefinition.RULE_simple_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 2023;
            this.match(CohortDefinition.MINIMUM_BETWEEN);
            this.state = 2024;
            this.simple_event_int();
            this.state = 2025;
            this.match(CohortDefinition.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext {
        let localContext = new Simple_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 338, CohortDefinition.RULE_simple_uniqueness_filter_window);
        try {
            this.state = 2029;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case CohortDefinition.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 2027;
                this.fixed_window_uniqueness_filter();
                }
                break;
            case CohortDefinition.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 2028;
                this.rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext {
        let localContext = new Fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 340, CohortDefinition.RULE_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 2031;
            this.match(CohortDefinition.FIXED_WINDOW);
            this.state = 2032;
            this.simple_event_int();
            this.state = 2033;
            this.match(CohortDefinition.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext {
        let localContext = new Rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 342, CohortDefinition.RULE_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 2035;
            this.match(CohortDefinition.ROLLING_WINDOW);
            this.state = 2036;
            this.simple_event_int();
            this.state = 2037;
            this.match(CohortDefinition.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_float(): Simple_event_floatContext {
        let localContext = new Simple_event_floatContext(this.context, this.state);
        this.enterRule(localContext, 344, CohortDefinition.RULE_simple_event_float);
        let _la: number;
        try {
            this.state = 2047;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 100, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 2039;
                this.simple_event_int();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 2041;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 81) {
                    {
                    this.state = 2040;
                    this.match(CohortDefinition.INT);
                    }
                }

                this.state = 2043;
                this.match(CohortDefinition.PERIOD);
                this.state = 2045;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 81) {
                    {
                    this.state = 2044;
                    this.match(CohortDefinition.INT);
                    }
                }

                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_int(): Simple_event_intContext {
        let localContext = new Simple_event_intContext(this.context, this.state);
        this.enterRule(localContext, 346, CohortDefinition.RULE_simple_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 2049;
            this.match(CohortDefinition.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        let localContext = new Concept_group_selectionContext(this.context, this.state);
        this.enterRule(localContext, 348, CohortDefinition.RULE_concept_group_selection);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 2051;
            this.match(CohortDefinition.CONCEPT_GROUP);
            this.state = 2056;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 89) {
                {
                {
                this.state = 2052;
                this.match(CohortDefinition.COMMA);
                this.state = 2053;
                this.match(CohortDefinition.CONCEPT_GROUP);
                }
                }
                this.state = 2058;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }

    public static readonly _serializedATN: number[] = [
        4,1,187,2060,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,
        7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,13,7,
        13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,2,
        20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,
        26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,
        33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,
        39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,45,2,
        46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,2,52,7,
        52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,7,56,2,57,7,57,2,58,7,58,2,
        59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,63,7,63,2,64,7,64,2,65,7,
        65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,7,70,2,71,7,71,2,
        72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,77,2,78,7,
        78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,7,84,2,
        85,7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,2,91,7,
        91,2,92,7,92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,2,97,7,97,2,
        98,7,98,2,99,7,99,2,100,7,100,2,101,7,101,2,102,7,102,2,103,7,103,
        2,104,7,104,2,105,7,105,2,106,7,106,2,107,7,107,2,108,7,108,2,109,
        7,109,2,110,7,110,2,111,7,111,2,112,7,112,2,113,7,113,2,114,7,114,
        2,115,7,115,2,116,7,116,2,117,7,117,2,118,7,118,2,119,7,119,2,120,
        7,120,2,121,7,121,2,122,7,122,2,123,7,123,2,124,7,124,2,125,7,125,
        2,126,7,126,2,127,7,127,2,128,7,128,2,129,7,129,2,130,7,130,2,131,
        7,131,2,132,7,132,2,133,7,133,2,134,7,134,2,135,7,135,2,136,7,136,
        2,137,7,137,2,138,7,138,2,139,7,139,2,140,7,140,2,141,7,141,2,142,
        7,142,2,143,7,143,2,144,7,144,2,145,7,145,2,146,7,146,2,147,7,147,
        2,148,7,148,2,149,7,149,2,150,7,150,2,151,7,151,2,152,7,152,2,153,
        7,153,2,154,7,154,2,155,7,155,2,156,7,156,2,157,7,157,2,158,7,158,
        2,159,7,159,2,160,7,160,2,161,7,161,2,162,7,162,2,163,7,163,2,164,
        7,164,2,165,7,165,2,166,7,166,2,167,7,167,2,168,7,168,2,169,7,169,
        2,170,7,170,2,171,7,171,2,172,7,172,2,173,7,173,2,174,7,174,1,0,
        1,0,3,0,353,8,0,1,0,3,0,356,8,0,1,0,3,0,359,8,0,1,0,3,0,362,8,0,
        1,0,4,0,365,8,0,11,0,12,0,366,1,0,3,0,370,8,0,1,0,5,0,373,8,0,10,
        0,12,0,376,9,0,1,0,4,0,379,8,0,11,0,12,0,380,1,1,1,1,1,1,1,1,1,1,
        1,1,1,2,1,2,1,2,1,2,1,2,1,2,1,3,1,3,1,3,5,3,398,8,3,10,3,12,3,401,
        9,3,1,4,1,4,1,4,1,4,3,4,407,8,4,1,5,1,5,3,5,411,8,5,1,6,1,6,3,6,
        415,8,6,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,7,1,8,1,8,1,8,1,8,1,8,1,9,
        1,9,1,9,1,9,1,9,1,9,1,10,1,10,1,10,1,10,1,10,1,10,1,10,1,11,1,11,
        1,11,1,11,1,11,1,11,1,12,1,12,1,12,1,12,1,12,1,13,1,13,1,13,1,13,
        1,13,1,13,1,14,1,14,1,14,1,14,1,14,1,15,1,15,1,15,1,15,1,15,3,15,
        470,8,15,1,15,1,15,1,16,1,16,1,16,1,16,1,16,1,17,1,17,1,17,1,17,
        1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,1,18,
        1,18,3,18,497,8,18,1,19,1,19,1,19,3,19,502,8,19,1,19,1,19,1,20,1,
        20,1,20,5,20,509,8,20,10,20,12,20,512,9,20,1,21,1,21,1,21,3,21,517,
        8,21,1,22,1,22,1,22,1,22,3,22,523,8,22,1,22,1,22,1,23,1,23,1,23,
        1,23,1,24,1,24,1,24,1,24,1,25,1,25,1,25,1,25,1,25,1,26,1,26,1,26,
        1,26,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,
        1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,1,27,
        3,27,569,8,27,1,28,1,28,1,29,1,29,1,29,1,29,1,29,1,30,1,30,1,30,
        1,30,3,30,582,8,30,1,31,1,31,1,31,1,31,1,31,1,32,1,32,1,32,1,32,
        1,32,3,32,594,8,32,1,32,1,32,1,33,1,33,3,33,600,8,33,1,33,1,33,1,
        33,3,33,605,8,33,1,34,1,34,1,34,1,34,1,34,1,35,1,35,1,35,1,35,1,
        35,1,36,1,36,1,36,1,36,1,37,1,37,1,37,1,37,1,38,1,38,1,38,1,38,1,
        39,1,39,1,39,1,39,1,40,1,40,1,40,3,40,636,8,40,1,41,1,41,1,41,1,
        41,1,41,1,41,1,41,3,41,645,8,41,1,41,1,41,1,41,1,42,1,42,1,42,4,
        42,653,8,42,11,42,12,42,654,1,43,1,43,3,43,659,8,43,1,44,1,44,3,
        44,663,8,44,1,45,1,45,1,45,1,45,3,45,669,8,45,1,45,1,45,1,46,1,46,
        1,47,1,47,1,47,1,47,1,47,1,48,1,48,3,48,682,8,48,1,48,1,48,1,49,
        1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,
        1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,
        1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,
        1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,1,49,
        1,49,3,49,740,8,49,1,50,1,50,1,50,1,50,1,50,1,50,1,50,1,50,1,51,
        1,51,1,51,5,51,753,8,51,10,51,12,51,756,9,51,1,52,1,52,1,52,1,52,
        3,52,762,8,52,1,53,1,53,3,53,766,8,53,1,54,1,54,1,54,1,54,1,54,1,
        55,1,55,1,55,1,55,1,56,1,56,1,56,1,56,3,56,781,8,56,1,56,1,56,1,
        57,1,57,3,57,787,8,57,1,57,1,57,1,57,1,58,1,58,3,58,794,8,58,1,59,
        1,59,1,59,1,59,1,59,1,59,1,59,1,59,1,60,1,60,1,60,4,60,807,8,60,
        11,60,12,60,808,1,61,1,61,1,61,1,61,1,61,3,61,816,8,61,1,62,1,62,
        1,62,1,62,3,62,822,8,62,1,62,1,62,1,63,1,63,1,63,1,63,3,63,830,8,
        63,1,63,1,63,1,64,1,64,1,65,1,65,1,65,1,65,1,65,1,66,1,66,1,66,1,
        66,1,66,1,66,1,66,1,66,1,66,3,66,850,8,66,1,67,1,67,1,67,1,67,1,
        67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,67,1,
        67,3,67,870,8,67,1,68,1,68,1,68,1,68,1,69,1,69,1,69,1,69,1,69,1,
        69,1,69,1,69,1,69,1,69,1,69,1,69,3,69,888,8,69,1,70,1,70,1,70,1,
        70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,1,70,3,70,902,8,70,1,71,1,
        71,1,71,1,71,1,72,1,72,3,72,910,8,72,1,73,1,73,1,73,1,73,1,74,1,
        74,1,74,1,74,1,75,1,75,1,76,1,76,1,76,1,76,1,76,1,76,3,76,928,8,
        76,1,77,1,77,1,77,1,77,1,77,1,78,1,78,1,78,1,78,1,78,1,79,1,79,1,
        79,1,79,1,79,1,80,1,80,1,80,1,80,1,80,1,81,1,81,1,81,1,81,1,81,1,
        82,1,82,1,82,1,82,1,82,1,83,1,83,1,83,3,83,963,8,83,1,83,1,83,1,
        84,1,84,1,84,3,84,970,8,84,1,84,1,84,1,85,1,85,1,85,3,85,977,8,85,
        1,85,1,85,1,86,1,86,1,86,3,86,984,8,86,1,86,1,86,1,87,1,87,1,87,
        3,87,991,8,87,1,87,1,87,1,88,1,88,1,88,3,88,998,8,88,1,88,1,88,1,
        89,1,89,1,89,5,89,1005,8,89,10,89,12,89,1008,9,89,1,90,1,90,1,90,
        1,90,3,90,1014,8,90,1,91,1,91,1,91,1,91,3,91,1020,8,91,1,91,1,91,
        1,92,1,92,1,92,1,92,1,93,1,93,1,93,1,93,1,94,1,94,1,94,1,94,1,94,
        1,95,1,95,3,95,1039,8,95,1,95,1,95,1,96,1,96,1,96,1,96,1,96,1,97,
        1,97,3,97,1050,8,97,1,98,1,98,1,98,3,98,1055,8,98,1,99,1,99,1,99,
        1,99,1,99,1,99,1,99,1,99,1,99,1,99,3,99,1067,8,99,1,100,1,100,1,
        100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,
        1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,
        1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,
        1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,
        1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,
        1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,
        1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,1,100,
        1,100,1,100,1,100,1,100,1,100,3,100,1153,8,100,1,101,1,101,1,101,
        5,101,1158,8,101,10,101,12,101,1161,9,101,1,102,1,102,1,102,1,102,
        1,102,3,102,1168,8,102,1,103,1,103,1,103,1,103,3,103,1174,8,103,
        1,103,1,103,1,104,1,104,1,104,1,104,1,105,1,105,1,105,1,105,1,106,
        1,106,1,106,1,106,3,106,1190,8,106,1,106,1,106,1,107,1,107,1,107,
        1,107,1,108,1,108,1,108,1,108,1,109,1,109,1,109,1,109,1,109,1,110,
        1,110,3,110,1209,8,110,1,110,1,110,1,111,1,111,1,111,1,111,1,111,
        1,112,1,112,3,112,1220,8,112,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,1,113,
        1,113,1,113,3,113,1329,8,113,1,114,1,114,1,114,5,114,1334,8,114,
        10,114,12,114,1337,9,114,1,115,1,115,1,115,1,115,1,115,3,115,1344,
        8,115,1,116,1,116,1,116,1,116,3,116,1350,8,116,1,116,1,116,1,117,
        1,117,1,117,1,117,1,118,1,118,1,118,1,118,1,119,1,119,1,119,1,119,
        1,119,1,120,1,120,1,120,1,120,1,121,1,121,1,121,1,121,1,121,1,122,
        1,122,3,122,1378,8,122,1,122,1,122,1,123,1,123,1,123,1,123,1,123,
        1,124,1,124,3,124,1389,8,124,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,1,125,
        1,125,1,125,1,125,1,125,1,125,1,125,3,125,1502,8,125,1,126,1,126,
        1,126,5,126,1507,8,126,10,126,12,126,1510,9,126,1,127,1,127,1,127,
        1,127,1,127,3,127,1517,8,127,1,128,1,128,1,128,1,128,3,128,1523,
        8,128,1,128,1,128,1,129,1,129,1,129,1,129,1,130,1,130,1,130,1,130,
        1,131,1,131,1,131,1,131,1,131,1,132,1,132,1,132,1,132,1,133,1,133,
        1,133,1,133,1,133,1,134,1,134,3,134,1551,8,134,1,134,1,134,1,135,
        1,135,1,135,1,135,1,135,1,136,1,136,3,136,1562,8,136,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,
        1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,1,137,3,137,
        1675,8,137,1,138,1,138,1,138,5,138,1680,8,138,10,138,12,138,1683,
        9,138,1,139,1,139,1,139,1,139,1,139,3,139,1690,8,139,1,140,1,140,
        1,140,1,140,3,140,1696,8,140,1,140,1,140,1,141,1,141,1,141,1,141,
        1,142,1,142,1,142,1,142,1,143,1,143,1,143,1,143,1,143,1,144,1,144,
        1,144,1,144,1,145,1,145,1,145,1,145,1,145,1,146,1,146,3,146,1724,
        8,146,1,146,1,146,1,147,1,147,1,147,1,147,1,147,1,148,1,148,3,148,
        1735,8,148,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,1,149,
        3,149,1834,8,149,1,150,1,150,1,150,1,150,3,150,1840,8,150,1,150,
        1,150,1,151,1,151,1,151,1,151,1,152,1,152,1,152,1,152,1,153,1,153,
        1,153,3,153,1855,8,153,1,154,1,154,1,154,1,154,1,154,1,154,1,154,
        1,154,1,154,1,154,3,154,1867,8,154,1,155,1,155,1,155,5,155,1872,
        8,155,10,155,12,155,1875,9,155,1,156,1,156,1,156,1,156,3,156,1881,
        8,156,1,157,1,157,1,157,1,157,3,157,1887,8,157,1,157,1,157,1,158,
        1,158,1,158,1,158,1,159,1,159,1,159,1,159,1,160,1,160,1,160,1,160,
        1,160,1,161,1,161,3,161,1906,8,161,1,161,1,161,1,162,1,162,1,162,
        1,162,1,162,1,163,1,163,3,163,1917,8,163,1,164,1,164,1,164,3,164,
        1922,8,164,1,165,1,165,1,165,1,165,1,165,1,165,1,165,1,165,1,165,
        1,165,3,165,1934,8,165,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,1,166,
        3,166,2020,8,166,1,167,1,167,1,168,1,168,1,168,1,168,1,169,1,169,
        3,169,2030,8,169,1,170,1,170,1,170,1,170,1,171,1,171,1,171,1,171,
        1,172,1,172,3,172,2042,8,172,1,172,1,172,3,172,2046,8,172,3,172,
        2048,8,172,1,173,1,173,1,174,1,174,1,174,5,174,2055,8,174,10,174,
        12,174,2058,9,174,1,174,0,0,175,0,2,4,6,8,10,12,14,16,18,20,22,24,
        26,28,30,32,34,36,38,40,42,44,46,48,50,52,54,56,58,60,62,64,66,68,
        70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,
        110,112,114,116,118,120,122,124,126,128,130,132,134,136,138,140,
        142,144,146,148,150,152,154,156,158,160,162,164,166,168,170,172,
        174,176,178,180,182,184,186,188,190,192,194,196,198,200,202,204,
        206,208,210,212,214,216,218,220,222,224,226,228,230,232,234,236,
        238,240,242,244,246,248,250,252,254,256,258,260,262,264,266,268,
        270,272,274,276,278,280,282,284,286,288,290,292,294,296,298,300,
        302,304,306,308,310,312,314,316,318,320,322,324,326,328,330,332,
        334,336,338,340,342,344,346,348,0,10,2,0,90,90,96,96,1,0,44,52,2,
        0,65,65,161,161,1,0,121,123,1,0,101,102,3,0,35,38,40,40,42,43,2,
        0,169,169,175,175,2,0,163,163,165,165,2,0,170,170,175,175,2,0,90,
        90,96,100,2156,0,350,1,0,0,0,2,382,1,0,0,0,4,388,1,0,0,0,6,394,1,
        0,0,0,8,406,1,0,0,0,10,410,1,0,0,0,12,414,1,0,0,0,14,416,1,0,0,0,
        16,424,1,0,0,0,18,429,1,0,0,0,20,435,1,0,0,0,22,442,1,0,0,0,24,448,
        1,0,0,0,26,453,1,0,0,0,28,459,1,0,0,0,30,464,1,0,0,0,32,473,1,0,
        0,0,34,478,1,0,0,0,36,496,1,0,0,0,38,498,1,0,0,0,40,505,1,0,0,0,
        42,516,1,0,0,0,44,518,1,0,0,0,46,526,1,0,0,0,48,530,1,0,0,0,50,534,
        1,0,0,0,52,539,1,0,0,0,54,568,1,0,0,0,56,570,1,0,0,0,58,572,1,0,
        0,0,60,581,1,0,0,0,62,583,1,0,0,0,64,588,1,0,0,0,66,599,1,0,0,0,
        68,606,1,0,0,0,70,611,1,0,0,0,72,616,1,0,0,0,74,620,1,0,0,0,76,624,
        1,0,0,0,78,628,1,0,0,0,80,635,1,0,0,0,82,637,1,0,0,0,84,649,1,0,
        0,0,86,658,1,0,0,0,88,662,1,0,0,0,90,664,1,0,0,0,92,672,1,0,0,0,
        94,674,1,0,0,0,96,681,1,0,0,0,98,739,1,0,0,0,100,741,1,0,0,0,102,
        749,1,0,0,0,104,761,1,0,0,0,106,765,1,0,0,0,108,767,1,0,0,0,110,
        772,1,0,0,0,112,776,1,0,0,0,114,786,1,0,0,0,116,793,1,0,0,0,118,
        795,1,0,0,0,120,803,1,0,0,0,122,815,1,0,0,0,124,817,1,0,0,0,126,
        825,1,0,0,0,128,833,1,0,0,0,130,835,1,0,0,0,132,849,1,0,0,0,134,
        869,1,0,0,0,136,871,1,0,0,0,138,887,1,0,0,0,140,901,1,0,0,0,142,
        903,1,0,0,0,144,909,1,0,0,0,146,911,1,0,0,0,148,915,1,0,0,0,150,
        919,1,0,0,0,152,927,1,0,0,0,154,929,1,0,0,0,156,934,1,0,0,0,158,
        939,1,0,0,0,160,944,1,0,0,0,162,949,1,0,0,0,164,954,1,0,0,0,166,
        959,1,0,0,0,168,966,1,0,0,0,170,973,1,0,0,0,172,980,1,0,0,0,174,
        987,1,0,0,0,176,994,1,0,0,0,178,1001,1,0,0,0,180,1013,1,0,0,0,182,
        1015,1,0,0,0,184,1023,1,0,0,0,186,1027,1,0,0,0,188,1031,1,0,0,0,
        190,1038,1,0,0,0,192,1042,1,0,0,0,194,1049,1,0,0,0,196,1051,1,0,
        0,0,198,1066,1,0,0,0,200,1152,1,0,0,0,202,1154,1,0,0,0,204,1167,
        1,0,0,0,206,1169,1,0,0,0,208,1177,1,0,0,0,210,1181,1,0,0,0,212,1185,
        1,0,0,0,214,1193,1,0,0,0,216,1197,1,0,0,0,218,1201,1,0,0,0,220,1208,
        1,0,0,0,222,1212,1,0,0,0,224,1219,1,0,0,0,226,1328,1,0,0,0,228,1330,
        1,0,0,0,230,1343,1,0,0,0,232,1345,1,0,0,0,234,1353,1,0,0,0,236,1357,
        1,0,0,0,238,1361,1,0,0,0,240,1366,1,0,0,0,242,1370,1,0,0,0,244,1377,
        1,0,0,0,246,1381,1,0,0,0,248,1388,1,0,0,0,250,1501,1,0,0,0,252,1503,
        1,0,0,0,254,1516,1,0,0,0,256,1518,1,0,0,0,258,1526,1,0,0,0,260,1530,
        1,0,0,0,262,1534,1,0,0,0,264,1539,1,0,0,0,266,1543,1,0,0,0,268,1550,
        1,0,0,0,270,1554,1,0,0,0,272,1561,1,0,0,0,274,1674,1,0,0,0,276,1676,
        1,0,0,0,278,1689,1,0,0,0,280,1691,1,0,0,0,282,1699,1,0,0,0,284,1703,
        1,0,0,0,286,1707,1,0,0,0,288,1712,1,0,0,0,290,1716,1,0,0,0,292,1723,
        1,0,0,0,294,1727,1,0,0,0,296,1734,1,0,0,0,298,1833,1,0,0,0,300,1835,
        1,0,0,0,302,1843,1,0,0,0,304,1847,1,0,0,0,306,1851,1,0,0,0,308,1866,
        1,0,0,0,310,1868,1,0,0,0,312,1880,1,0,0,0,314,1882,1,0,0,0,316,1890,
        1,0,0,0,318,1894,1,0,0,0,320,1898,1,0,0,0,322,1905,1,0,0,0,324,1909,
        1,0,0,0,326,1916,1,0,0,0,328,1918,1,0,0,0,330,1933,1,0,0,0,332,2019,
        1,0,0,0,334,2021,1,0,0,0,336,2023,1,0,0,0,338,2029,1,0,0,0,340,2031,
        1,0,0,0,342,2035,1,0,0,0,344,2047,1,0,0,0,346,2049,1,0,0,0,348,2051,
        1,0,0,0,350,352,3,2,1,0,351,353,3,4,2,0,352,351,1,0,0,0,352,353,
        1,0,0,0,353,355,1,0,0,0,354,356,3,8,4,0,355,354,1,0,0,0,355,356,
        1,0,0,0,356,358,1,0,0,0,357,359,3,10,5,0,358,357,1,0,0,0,358,359,
        1,0,0,0,359,361,1,0,0,0,360,362,3,12,6,0,361,360,1,0,0,0,361,362,
        1,0,0,0,362,364,1,0,0,0,363,365,3,30,15,0,364,363,1,0,0,0,365,366,
        1,0,0,0,366,364,1,0,0,0,366,367,1,0,0,0,367,369,1,0,0,0,368,370,
        3,58,29,0,369,368,1,0,0,0,369,370,1,0,0,0,370,374,1,0,0,0,371,373,
        3,80,40,0,372,371,1,0,0,0,373,376,1,0,0,0,374,372,1,0,0,0,374,375,
        1,0,0,0,375,378,1,0,0,0,376,374,1,0,0,0,377,379,3,152,76,0,378,377,
        1,0,0,0,379,380,1,0,0,0,380,378,1,0,0,0,380,381,1,0,0,0,381,1,1,
        0,0,0,382,383,5,1,0,0,383,384,5,86,0,0,384,385,3,6,3,0,385,386,5,
        87,0,0,386,387,5,88,0,0,387,3,1,0,0,0,388,389,5,2,0,0,389,390,5,
        86,0,0,390,391,3,6,3,0,391,392,5,87,0,0,392,393,5,88,0,0,393,5,1,
        0,0,0,394,399,5,66,0,0,395,396,5,89,0,0,396,398,5,66,0,0,397,395,
        1,0,0,0,398,401,1,0,0,0,399,397,1,0,0,0,399,400,1,0,0,0,400,7,1,
        0,0,0,401,399,1,0,0,0,402,407,3,14,7,0,403,407,3,16,8,0,404,407,
        3,18,9,0,405,407,3,20,10,0,406,402,1,0,0,0,406,403,1,0,0,0,406,404,
        1,0,0,0,406,405,1,0,0,0,407,9,1,0,0,0,408,411,3,22,11,0,409,411,
        3,24,12,0,410,408,1,0,0,0,410,409,1,0,0,0,411,11,1,0,0,0,412,415,
        3,26,13,0,413,415,3,28,14,0,414,412,1,0,0,0,414,413,1,0,0,0,415,
        13,1,0,0,0,416,417,5,3,0,0,417,418,5,86,0,0,418,419,5,85,0,0,419,
        420,5,89,0,0,420,421,5,85,0,0,421,422,5,87,0,0,422,423,5,88,0,0,
        423,15,1,0,0,0,424,425,5,3,0,0,425,426,5,86,0,0,426,427,5,87,0,0,
        427,428,5,88,0,0,428,17,1,0,0,0,429,430,5,3,0,0,430,431,5,86,0,0,
        431,432,5,85,0,0,432,433,5,87,0,0,433,434,5,88,0,0,434,19,1,0,0,
        0,435,436,5,3,0,0,436,437,5,86,0,0,437,438,5,85,0,0,438,439,5,89,
        0,0,439,440,5,87,0,0,440,441,5,88,0,0,441,21,1,0,0,0,442,443,5,4,
        0,0,443,444,5,86,0,0,444,445,5,81,0,0,445,446,5,87,0,0,446,447,5,
        88,0,0,447,23,1,0,0,0,448,449,5,4,0,0,449,450,5,86,0,0,450,451,5,
        87,0,0,451,452,5,88,0,0,452,25,1,0,0,0,453,454,5,5,0,0,454,455,5,
        86,0,0,455,456,5,81,0,0,456,457,5,87,0,0,457,458,5,88,0,0,458,27,
        1,0,0,0,459,460,5,5,0,0,460,461,5,86,0,0,461,462,5,87,0,0,462,463,
        5,88,0,0,463,29,1,0,0,0,464,465,5,66,0,0,465,469,5,90,0,0,466,470,
        3,38,19,0,467,470,3,32,16,0,468,470,3,36,18,0,469,466,1,0,0,0,469,
        467,1,0,0,0,469,468,1,0,0,0,470,471,1,0,0,0,471,472,5,88,0,0,472,
        31,1,0,0,0,473,474,5,104,0,0,474,475,5,86,0,0,475,476,3,34,17,0,
        476,477,5,87,0,0,477,33,1,0,0,0,478,479,3,56,28,0,479,480,3,334,
        167,0,480,481,5,81,0,0,481,35,1,0,0,0,482,483,5,104,0,0,483,484,
        5,86,0,0,484,497,5,87,0,0,485,486,5,104,0,0,486,487,5,86,0,0,487,
        488,3,56,28,0,488,489,5,87,0,0,489,497,1,0,0,0,490,491,5,104,0,0,
        491,492,5,86,0,0,492,493,3,56,28,0,493,494,3,334,167,0,494,495,5,
        87,0,0,495,497,1,0,0,0,496,482,1,0,0,0,496,485,1,0,0,0,496,490,1,
        0,0,0,497,37,1,0,0,0,498,499,5,133,0,0,499,501,5,86,0,0,500,502,
        3,40,20,0,501,500,1,0,0,0,501,502,1,0,0,0,502,503,1,0,0,0,503,504,
        5,87,0,0,504,39,1,0,0,0,505,510,3,42,21,0,506,507,5,89,0,0,507,509,
        3,42,21,0,508,506,1,0,0,0,509,512,1,0,0,0,510,508,1,0,0,0,510,511,
        1,0,0,0,511,41,1,0,0,0,512,510,1,0,0,0,513,517,3,44,22,0,514,517,
        3,50,25,0,515,517,3,54,27,0,516,513,1,0,0,0,516,514,1,0,0,0,516,
        515,1,0,0,0,517,43,1,0,0,0,518,519,5,19,0,0,519,522,5,86,0,0,520,
        523,3,46,23,0,521,523,3,48,24,0,522,520,1,0,0,0,522,521,1,0,0,0,
        523,524,1,0,0,0,524,525,5,87,0,0,525,45,1,0,0,0,526,527,5,171,0,
        0,527,528,5,107,0,0,528,529,3,348,174,0,529,47,1,0,0,0,530,531,5,
        171,0,0,531,532,7,0,0,0,532,533,5,69,0,0,533,49,1,0,0,0,534,535,
        5,22,0,0,535,536,5,86,0,0,536,537,3,52,26,0,537,538,5,87,0,0,538,
        51,1,0,0,0,539,540,5,164,0,0,540,541,3,334,167,0,541,542,5,81,0,
        0,542,53,1,0,0,0,543,544,5,19,0,0,544,545,5,86,0,0,545,569,5,87,
        0,0,546,547,5,19,0,0,547,548,5,86,0,0,548,549,5,171,0,0,549,569,
        5,87,0,0,550,551,5,19,0,0,551,552,5,86,0,0,552,553,5,171,0,0,553,
        554,5,107,0,0,554,569,5,87,0,0,555,556,5,22,0,0,556,557,5,86,0,0,
        557,569,5,87,0,0,558,559,5,22,0,0,559,560,5,86,0,0,560,561,5,164,
        0,0,561,569,5,87,0,0,562,563,5,22,0,0,563,564,5,86,0,0,564,565,5,
        164,0,0,565,566,3,334,167,0,566,567,5,87,0,0,567,569,1,0,0,0,568,
        543,1,0,0,0,568,546,1,0,0,0,568,550,1,0,0,0,568,555,1,0,0,0,568,
        558,1,0,0,0,568,562,1,0,0,0,569,55,1,0,0,0,570,571,7,1,0,0,571,57,
        1,0,0,0,572,573,5,6,0,0,573,574,5,90,0,0,574,575,3,60,30,0,575,576,
        5,88,0,0,576,59,1,0,0,0,577,582,3,62,31,0,578,582,3,72,36,0,579,
        582,3,64,32,0,580,582,3,74,37,0,581,577,1,0,0,0,581,578,1,0,0,0,
        581,579,1,0,0,0,581,580,1,0,0,0,582,61,1,0,0,0,583,584,5,8,0,0,584,
        585,5,86,0,0,585,586,5,85,0,0,586,587,5,87,0,0,587,63,1,0,0,0,588,
        589,5,7,0,0,589,590,5,86,0,0,590,593,7,2,0,0,591,592,5,89,0,0,592,
        594,3,66,33,0,593,591,1,0,0,0,593,594,1,0,0,0,594,595,1,0,0,0,595,
        596,5,87,0,0,596,65,1,0,0,0,597,600,3,70,35,0,598,600,3,76,38,0,
        599,597,1,0,0,0,599,598,1,0,0,0,600,601,1,0,0,0,601,604,5,89,0,0,
        602,605,3,68,34,0,603,605,3,78,39,0,604,602,1,0,0,0,604,603,1,0,
        0,0,605,67,1,0,0,0,606,607,5,9,0,0,607,608,5,86,0,0,608,609,5,85,
        0,0,609,610,5,87,0,0,610,69,1,0,0,0,611,612,5,10,0,0,612,613,5,86,
        0,0,613,614,5,85,0,0,614,615,5,87,0,0,615,71,1,0,0,0,616,617,5,8,
        0,0,617,618,5,86,0,0,618,619,5,87,0,0,619,73,1,0,0,0,620,621,5,7,
        0,0,621,622,5,86,0,0,622,623,5,87,0,0,623,75,1,0,0,0,624,625,5,10,
        0,0,625,626,5,86,0,0,626,627,5,87,0,0,627,77,1,0,0,0,628,629,5,9,
        0,0,629,630,5,86,0,0,630,631,5,87,0,0,631,79,1,0,0,0,632,636,3,82,
        41,0,633,636,3,100,50,0,634,636,3,118,59,0,635,632,1,0,0,0,635,633,
        1,0,0,0,635,634,1,0,0,0,636,81,1,0,0,0,637,638,5,63,0,0,638,639,
        5,90,0,0,639,640,5,76,0,0,640,641,5,86,0,0,641,644,3,84,42,0,642,
        643,5,89,0,0,643,645,3,88,44,0,644,642,1,0,0,0,644,645,1,0,0,0,645,
        646,1,0,0,0,646,647,5,87,0,0,647,648,5,88,0,0,648,83,1,0,0,0,649,
        652,3,86,43,0,650,651,5,89,0,0,651,653,3,86,43,0,652,650,1,0,0,0,
        653,654,1,0,0,0,654,652,1,0,0,0,654,655,1,0,0,0,655,85,1,0,0,0,656,
        659,3,90,45,0,657,659,3,140,70,0,658,656,1,0,0,0,658,657,1,0,0,0,
        659,87,1,0,0,0,660,663,3,92,46,0,661,663,3,98,49,0,662,660,1,0,0,
        0,662,661,1,0,0,0,663,89,1,0,0,0,664,665,5,79,0,0,665,668,5,86,0,
        0,666,669,3,134,67,0,667,669,3,136,68,0,668,666,1,0,0,0,668,667,
        1,0,0,0,669,670,1,0,0,0,670,671,5,87,0,0,671,91,1,0,0,0,672,673,
        3,94,47,0,673,93,1,0,0,0,674,675,5,28,0,0,675,676,5,86,0,0,676,677,
        3,96,48,0,677,678,5,87,0,0,678,95,1,0,0,0,679,682,3,142,71,0,680,
        682,3,144,72,0,681,679,1,0,0,0,681,680,1,0,0,0,682,683,1,0,0,0,683,
        684,5,11,0,0,684,97,1,0,0,0,685,686,5,28,0,0,686,687,5,86,0,0,687,
        740,5,87,0,0,688,689,5,28,0,0,689,690,5,86,0,0,690,691,5,121,0,0,
        691,740,5,87,0,0,692,693,5,28,0,0,693,694,5,86,0,0,694,695,5,121,
        0,0,695,696,3,150,75,0,696,697,5,87,0,0,697,740,1,0,0,0,698,699,
        5,28,0,0,699,700,5,86,0,0,700,701,5,121,0,0,701,702,3,150,75,0,702,
        703,5,116,0,0,703,704,5,87,0,0,704,740,1,0,0,0,705,706,5,28,0,0,
        706,707,5,86,0,0,707,708,5,124,0,0,708,740,5,87,0,0,709,710,5,28,
        0,0,710,711,5,86,0,0,711,712,5,124,0,0,712,713,3,150,75,0,713,714,
        5,87,0,0,714,740,1,0,0,0,715,716,5,28,0,0,716,717,5,86,0,0,717,718,
        5,124,0,0,718,719,3,150,75,0,719,720,5,116,0,0,720,721,5,87,0,0,
        721,740,1,0,0,0,722,723,5,28,0,0,723,724,5,86,0,0,724,725,5,125,
        0,0,725,740,5,87,0,0,726,727,5,28,0,0,727,728,5,86,0,0,728,729,5,
        125,0,0,729,730,3,150,75,0,730,731,5,87,0,0,731,740,1,0,0,0,732,
        733,5,28,0,0,733,734,5,86,0,0,734,735,5,125,0,0,735,736,3,150,75,
        0,736,737,5,116,0,0,737,738,5,87,0,0,738,740,1,0,0,0,739,685,1,0,
        0,0,739,688,1,0,0,0,739,692,1,0,0,0,739,698,1,0,0,0,739,705,1,0,
        0,0,739,709,1,0,0,0,739,715,1,0,0,0,739,722,1,0,0,0,739,726,1,0,
        0,0,739,732,1,0,0,0,740,99,1,0,0,0,741,742,5,64,0,0,742,743,5,90,
        0,0,743,744,5,77,0,0,744,745,5,86,0,0,745,746,3,102,51,0,746,747,
        5,87,0,0,747,748,5,88,0,0,748,101,1,0,0,0,749,754,3,104,52,0,750,
        751,5,89,0,0,751,753,3,104,52,0,752,750,1,0,0,0,753,756,1,0,0,0,
        754,752,1,0,0,0,754,755,1,0,0,0,755,103,1,0,0,0,756,754,1,0,0,0,
        757,762,3,106,53,0,758,762,3,112,56,0,759,762,3,138,69,0,760,762,
        3,140,70,0,761,757,1,0,0,0,761,758,1,0,0,0,761,759,1,0,0,0,761,760,
        1,0,0,0,762,105,1,0,0,0,763,766,5,13,0,0,764,766,3,108,54,0,765,
        763,1,0,0,0,765,764,1,0,0,0,766,107,1,0,0,0,767,768,5,15,0,0,768,
        769,5,86,0,0,769,770,3,110,55,0,770,771,5,87,0,0,771,109,1,0,0,0,
        772,773,7,3,0,0,773,774,5,81,0,0,774,775,5,116,0,0,775,111,1,0,0,
        0,776,777,5,79,0,0,777,780,5,86,0,0,778,781,3,114,57,0,779,781,3,
        116,58,0,780,778,1,0,0,0,780,779,1,0,0,0,781,782,1,0,0,0,782,783,
        5,87,0,0,783,113,1,0,0,0,784,787,3,134,67,0,785,787,3,136,68,0,786,
        784,1,0,0,0,786,785,1,0,0,0,787,788,1,0,0,0,788,789,5,89,0,0,789,
        790,5,14,0,0,790,115,1,0,0,0,791,794,3,134,67,0,792,794,3,136,68,
        0,793,791,1,0,0,0,793,792,1,0,0,0,794,117,1,0,0,0,795,796,5,65,0,
        0,796,797,5,90,0,0,797,798,5,78,0,0,798,799,5,86,0,0,799,800,3,120,
        60,0,800,801,5,87,0,0,801,802,5,88,0,0,802,119,1,0,0,0,803,806,3,
        122,61,0,804,805,5,89,0,0,805,807,3,122,61,0,806,804,1,0,0,0,807,
        808,1,0,0,0,808,806,1,0,0,0,808,809,1,0,0,0,809,121,1,0,0,0,810,
        816,1,0,0,0,811,816,3,124,62,0,812,816,3,140,70,0,813,816,3,126,
        63,0,814,816,3,132,66,0,815,810,1,0,0,0,815,811,1,0,0,0,815,812,
        1,0,0,0,815,813,1,0,0,0,815,814,1,0,0,0,816,123,1,0,0,0,817,818,
        5,79,0,0,818,821,5,86,0,0,819,822,3,134,67,0,820,822,3,136,68,0,
        821,819,1,0,0,0,821,820,1,0,0,0,822,823,1,0,0,0,823,824,5,87,0,0,
        824,125,1,0,0,0,825,826,5,18,0,0,826,829,5,86,0,0,827,830,3,128,
        64,0,828,830,3,130,65,0,829,827,1,0,0,0,829,828,1,0,0,0,830,831,
        1,0,0,0,831,832,5,87,0,0,832,127,1,0,0,0,833,834,7,4,0,0,834,129,
        1,0,0,0,835,836,5,115,0,0,836,837,5,86,0,0,837,838,5,81,0,0,838,
        839,5,87,0,0,839,131,1,0,0,0,840,841,5,18,0,0,841,842,5,86,0,0,842,
        850,5,87,0,0,843,844,5,18,0,0,844,845,5,86,0,0,845,846,5,115,0,0,
        846,847,5,86,0,0,847,848,5,87,0,0,848,850,5,87,0,0,849,840,1,0,0,
        0,849,843,1,0,0,0,850,133,1,0,0,0,851,852,5,35,0,0,852,853,5,126,
        0,0,853,870,5,155,0,0,854,855,5,36,0,0,855,856,5,126,0,0,856,870,
        5,156,0,0,857,858,5,37,0,0,858,859,5,126,0,0,859,870,5,157,0,0,860,
        861,5,38,0,0,861,862,5,126,0,0,862,870,5,158,0,0,863,864,5,40,0,
        0,864,865,5,126,0,0,865,870,5,159,0,0,866,867,5,42,0,0,867,868,5,
        126,0,0,868,870,5,160,0,0,869,851,1,0,0,0,869,854,1,0,0,0,869,857,
        1,0,0,0,869,860,1,0,0,0,869,863,1,0,0,0,869,866,1,0,0,0,870,135,
        1,0,0,0,871,872,5,43,0,0,872,873,5,126,0,0,873,874,5,11,0,0,874,
        137,1,0,0,0,875,876,5,15,0,0,876,877,5,86,0,0,877,888,5,87,0,0,878,
        879,5,15,0,0,879,880,5,86,0,0,880,881,7,3,0,0,881,888,5,87,0,0,882,
        883,5,15,0,0,883,884,5,86,0,0,884,885,7,3,0,0,885,886,5,81,0,0,886,
        888,5,87,0,0,887,875,1,0,0,0,887,878,1,0,0,0,887,882,1,0,0,0,888,
        139,1,0,0,0,889,890,5,79,0,0,890,891,5,86,0,0,891,902,5,87,0,0,892,
        893,5,79,0,0,893,894,5,86,0,0,894,895,7,5,0,0,895,902,5,87,0,0,896,
        897,5,79,0,0,897,898,5,86,0,0,898,899,7,5,0,0,899,900,5,126,0,0,
        900,902,5,87,0,0,901,889,1,0,0,0,901,892,1,0,0,0,901,896,1,0,0,0,
        902,141,1,0,0,0,903,904,5,121,0,0,904,905,3,150,75,0,905,906,5,116,
        0,0,906,143,1,0,0,0,907,910,3,146,73,0,908,910,3,148,74,0,909,907,
        1,0,0,0,909,908,1,0,0,0,910,145,1,0,0,0,911,912,5,124,0,0,912,913,
        3,150,75,0,913,914,5,116,0,0,914,147,1,0,0,0,915,916,5,125,0,0,916,
        917,3,150,75,0,917,918,5,116,0,0,918,149,1,0,0,0,919,920,5,81,0,
        0,920,151,1,0,0,0,921,928,3,154,77,0,922,928,3,156,78,0,923,928,
        3,158,79,0,924,928,3,160,80,0,925,928,3,162,81,0,926,928,3,164,82,
        0,927,921,1,0,0,0,927,922,1,0,0,0,927,923,1,0,0,0,927,924,1,0,0,
        0,927,925,1,0,0,0,927,926,1,0,0,0,928,153,1,0,0,0,929,930,5,55,0,
        0,930,931,5,90,0,0,931,932,3,166,83,0,932,933,5,88,0,0,933,155,1,
        0,0,0,934,935,5,56,0,0,935,936,5,90,0,0,936,937,3,168,84,0,937,938,
        5,88,0,0,938,157,1,0,0,0,939,940,5,57,0,0,940,941,5,90,0,0,941,942,
        3,170,85,0,942,943,5,88,0,0,943,159,1,0,0,0,944,945,5,58,0,0,945,
        946,5,90,0,0,946,947,3,172,86,0,947,948,5,88,0,0,948,161,1,0,0,0,
        949,950,5,60,0,0,950,951,5,90,0,0,951,952,3,174,87,0,952,953,5,88,
        0,0,953,163,1,0,0,0,954,955,5,62,0,0,955,956,5,90,0,0,956,957,3,
        176,88,0,957,958,5,88,0,0,958,165,1,0,0,0,959,960,5,129,0,0,960,
        962,5,86,0,0,961,963,3,178,89,0,962,961,1,0,0,0,962,963,1,0,0,0,
        963,964,1,0,0,0,964,965,5,87,0,0,965,167,1,0,0,0,966,967,5,130,0,
        0,967,969,5,86,0,0,968,970,3,202,101,0,969,968,1,0,0,0,969,970,1,
        0,0,0,970,971,1,0,0,0,971,972,5,87,0,0,972,169,1,0,0,0,973,974,5,
        131,0,0,974,976,5,86,0,0,975,977,3,228,114,0,976,975,1,0,0,0,976,
        977,1,0,0,0,977,978,1,0,0,0,978,979,5,87,0,0,979,171,1,0,0,0,980,
        981,5,132,0,0,981,983,5,86,0,0,982,984,3,252,126,0,983,982,1,0,0,
        0,983,984,1,0,0,0,984,985,1,0,0,0,985,986,5,87,0,0,986,173,1,0,0,
        0,987,988,5,134,0,0,988,990,5,86,0,0,989,991,3,276,138,0,990,989,
        1,0,0,0,990,991,1,0,0,0,991,992,1,0,0,0,992,993,5,87,0,0,993,175,
        1,0,0,0,994,995,5,136,0,0,995,997,5,86,0,0,996,998,3,310,155,0,997,
        996,1,0,0,0,997,998,1,0,0,0,998,999,1,0,0,0,999,1000,5,87,0,0,1000,
        177,1,0,0,0,1001,1006,3,180,90,0,1002,1003,5,89,0,0,1003,1005,3,
        180,90,0,1004,1002,1,0,0,0,1005,1008,1,0,0,0,1006,1004,1,0,0,0,1006,
        1007,1,0,0,0,1007,179,1,0,0,0,1008,1006,1,0,0,0,1009,1014,3,182,
        91,0,1010,1014,3,188,94,0,1011,1014,3,192,96,0,1012,1014,3,200,100,
        0,1013,1009,1,0,0,0,1013,1010,1,0,0,0,1013,1011,1,0,0,0,1013,1012,
        1,0,0,0,1014,181,1,0,0,0,1015,1016,5,19,0,0,1016,1019,5,86,0,0,1017,
        1020,3,184,92,0,1018,1020,3,186,93,0,1019,1017,1,0,0,0,1019,1018,
        1,0,0,0,1020,1021,1,0,0,0,1021,1022,5,87,0,0,1022,183,1,0,0,0,1023,
        1024,5,167,0,0,1024,1025,5,107,0,0,1025,1026,3,348,174,0,1026,185,
        1,0,0,0,1027,1028,5,167,0,0,1028,1029,7,0,0,0,1029,1030,5,69,0,0,
        1030,187,1,0,0,0,1031,1032,5,28,0,0,1032,1033,5,86,0,0,1033,1034,
        3,190,95,0,1034,1035,5,87,0,0,1035,189,1,0,0,0,1036,1039,3,336,168,
        0,1037,1039,3,338,169,0,1038,1036,1,0,0,0,1038,1037,1,0,0,0,1039,
        1040,1,0,0,0,1040,1041,5,155,0,0,1041,191,1,0,0,0,1042,1043,5,31,
        0,0,1043,1044,5,86,0,0,1044,1045,3,194,97,0,1045,1046,5,87,0,0,1046,
        193,1,0,0,0,1047,1050,3,306,153,0,1048,1050,3,328,164,0,1049,1047,
        1,0,0,0,1049,1048,1,0,0,0,1050,195,1,0,0,0,1051,1054,5,129,0,0,1052,
        1055,3,184,92,0,1053,1055,3,186,93,0,1054,1052,1,0,0,0,1054,1053,
        1,0,0,0,1055,197,1,0,0,0,1056,1067,1,0,0,0,1057,1067,5,129,0,0,1058,
        1059,5,129,0,0,1059,1067,5,167,0,0,1060,1061,5,129,0,0,1061,1062,
        5,167,0,0,1062,1067,5,107,0,0,1063,1064,5,129,0,0,1064,1065,5,167,
        0,0,1065,1067,7,0,0,0,1066,1056,1,0,0,0,1066,1057,1,0,0,0,1066,1058,
        1,0,0,0,1066,1060,1,0,0,0,1066,1063,1,0,0,0,1067,199,1,0,0,0,1068,
        1069,5,19,0,0,1069,1070,5,86,0,0,1070,1153,5,87,0,0,1071,1072,5,
        19,0,0,1072,1073,5,86,0,0,1073,1074,5,167,0,0,1074,1153,5,87,0,0,
        1075,1076,5,19,0,0,1076,1077,5,86,0,0,1077,1078,5,167,0,0,1078,1079,
        5,107,0,0,1079,1153,5,87,0,0,1080,1081,5,19,0,0,1081,1082,5,86,0,
        0,1082,1083,5,167,0,0,1083,1084,7,0,0,0,1084,1153,5,87,0,0,1085,
        1086,5,28,0,0,1086,1087,5,86,0,0,1087,1153,5,87,0,0,1088,1089,5,
        28,0,0,1089,1090,5,86,0,0,1090,1091,5,121,0,0,1091,1153,5,87,0,0,
        1092,1093,5,28,0,0,1093,1094,5,86,0,0,1094,1095,5,121,0,0,1095,1096,
        3,346,173,0,1096,1097,5,87,0,0,1097,1153,1,0,0,0,1098,1099,5,28,
        0,0,1099,1100,5,86,0,0,1100,1101,5,121,0,0,1101,1102,3,346,173,0,
        1102,1103,5,116,0,0,1103,1104,5,87,0,0,1104,1153,1,0,0,0,1105,1106,
        5,28,0,0,1106,1107,5,86,0,0,1107,1108,5,124,0,0,1108,1153,5,87,0,
        0,1109,1110,5,28,0,0,1110,1111,5,86,0,0,1111,1112,5,124,0,0,1112,
        1113,3,346,173,0,1113,1114,5,87,0,0,1114,1153,1,0,0,0,1115,1116,
        5,28,0,0,1116,1117,5,86,0,0,1117,1118,5,124,0,0,1118,1119,3,346,
        173,0,1119,1120,5,116,0,0,1120,1121,5,87,0,0,1121,1153,1,0,0,0,1122,
        1123,5,28,0,0,1123,1124,5,86,0,0,1124,1125,5,125,0,0,1125,1153,5,
        87,0,0,1126,1127,5,28,0,0,1127,1128,5,86,0,0,1128,1129,5,125,0,0,
        1129,1130,3,346,173,0,1130,1131,5,87,0,0,1131,1153,1,0,0,0,1132,
        1133,5,28,0,0,1133,1134,5,86,0,0,1134,1135,5,125,0,0,1135,1136,3,
        346,173,0,1136,1137,5,116,0,0,1137,1138,5,87,0,0,1138,1153,1,0,0,
        0,1139,1140,5,31,0,0,1140,1141,5,86,0,0,1141,1153,5,87,0,0,1142,
        1143,5,31,0,0,1143,1144,5,86,0,0,1144,1145,3,308,154,0,1145,1146,
        5,87,0,0,1146,1153,1,0,0,0,1147,1148,5,31,0,0,1148,1149,5,86,0,0,
        1149,1150,3,330,165,0,1150,1151,5,87,0,0,1151,1153,1,0,0,0,1152,
        1068,1,0,0,0,1152,1071,1,0,0,0,1152,1075,1,0,0,0,1152,1080,1,0,0,
        0,1152,1085,1,0,0,0,1152,1088,1,0,0,0,1152,1092,1,0,0,0,1152,1098,
        1,0,0,0,1152,1105,1,0,0,0,1152,1109,1,0,0,0,1152,1115,1,0,0,0,1152,
        1122,1,0,0,0,1152,1126,1,0,0,0,1152,1132,1,0,0,0,1152,1139,1,0,0,
        0,1152,1142,1,0,0,0,1152,1147,1,0,0,0,1153,201,1,0,0,0,1154,1159,
        3,204,102,0,1155,1156,5,89,0,0,1156,1158,3,204,102,0,1157,1155,1,
        0,0,0,1158,1161,1,0,0,0,1159,1157,1,0,0,0,1159,1160,1,0,0,0,1160,
        203,1,0,0,0,1161,1159,1,0,0,0,1162,1168,3,206,103,0,1163,1168,3,
        212,106,0,1164,1168,3,218,109,0,1165,1168,3,222,111,0,1166,1168,
        3,226,113,0,1167,1162,1,0,0,0,1167,1163,1,0,0,0,1167,1164,1,0,0,
        0,1167,1165,1,0,0,0,1167,1166,1,0,0,0,1168,205,1,0,0,0,1169,1170,
        5,19,0,0,1170,1173,5,86,0,0,1171,1174,3,208,104,0,1172,1174,3,210,
        105,0,1173,1171,1,0,0,0,1173,1172,1,0,0,0,1174,1175,1,0,0,0,1175,
        1176,5,87,0,0,1176,207,1,0,0,0,1177,1178,5,168,0,0,1178,1179,5,107,
        0,0,1179,1180,3,348,174,0,1180,209,1,0,0,0,1181,1182,5,168,0,0,1182,
        1183,7,0,0,0,1183,1184,5,69,0,0,1184,211,1,0,0,0,1185,1186,5,22,
        0,0,1186,1189,5,86,0,0,1187,1190,3,214,107,0,1188,1190,3,216,108,
        0,1189,1187,1,0,0,0,1189,1188,1,0,0,0,1190,1191,1,0,0,0,1191,1192,
        5,87,0,0,1192,213,1,0,0,0,1193,1194,5,166,0,0,1194,1195,3,334,167,
        0,1195,1196,3,344,172,0,1196,215,1,0,0,0,1197,1198,5,162,0,0,1198,
        1199,3,334,167,0,1199,1200,3,346,173,0,1200,217,1,0,0,0,1201,1202,
        5,28,0,0,1202,1203,5,86,0,0,1203,1204,3,220,110,0,1204,1205,5,87,
        0,0,1205,219,1,0,0,0,1206,1209,3,336,168,0,1207,1209,3,338,169,0,
        1208,1206,1,0,0,0,1208,1207,1,0,0,0,1209,1210,1,0,0,0,1210,1211,
        5,156,0,0,1211,221,1,0,0,0,1212,1213,5,31,0,0,1213,1214,5,86,0,0,
        1214,1215,3,224,112,0,1215,1216,5,87,0,0,1216,223,1,0,0,0,1217,1220,
        3,306,153,0,1218,1220,3,328,164,0,1219,1217,1,0,0,0,1219,1218,1,
        0,0,0,1220,225,1,0,0,0,1221,1222,5,19,0,0,1222,1223,5,86,0,0,1223,
        1329,5,87,0,0,1224,1225,5,19,0,0,1225,1226,5,86,0,0,1226,1227,5,
        168,0,0,1227,1329,5,87,0,0,1228,1229,5,19,0,0,1229,1230,5,86,0,0,
        1230,1231,5,168,0,0,1231,1232,5,107,0,0,1232,1329,5,87,0,0,1233,
        1234,5,19,0,0,1234,1235,5,86,0,0,1235,1236,5,168,0,0,1236,1237,7,
        0,0,0,1237,1329,5,87,0,0,1238,1239,5,22,0,0,1239,1240,5,86,0,0,1240,
        1329,5,87,0,0,1241,1242,5,22,0,0,1242,1243,5,86,0,0,1243,1244,5,
        166,0,0,1244,1329,5,87,0,0,1245,1246,5,22,0,0,1246,1247,5,86,0,0,
        1247,1248,5,166,0,0,1248,1249,3,334,167,0,1249,1250,5,87,0,0,1250,
        1329,1,0,0,0,1251,1252,5,22,0,0,1252,1253,5,86,0,0,1253,1254,5,162,
        0,0,1254,1329,5,87,0,0,1255,1256,5,22,0,0,1256,1257,5,86,0,0,1257,
        1258,5,162,0,0,1258,1259,3,334,167,0,1259,1260,5,87,0,0,1260,1329,
        1,0,0,0,1261,1262,5,28,0,0,1262,1263,5,86,0,0,1263,1329,5,87,0,0,
        1264,1265,5,28,0,0,1265,1266,5,86,0,0,1266,1267,5,121,0,0,1267,1329,
        5,87,0,0,1268,1269,5,28,0,0,1269,1270,5,86,0,0,1270,1271,5,121,0,
        0,1271,1272,3,346,173,0,1272,1273,5,87,0,0,1273,1329,1,0,0,0,1274,
        1275,5,28,0,0,1275,1276,5,86,0,0,1276,1277,5,121,0,0,1277,1278,3,
        346,173,0,1278,1279,5,116,0,0,1279,1280,5,87,0,0,1280,1329,1,0,0,
        0,1281,1282,5,28,0,0,1282,1283,5,86,0,0,1283,1284,5,124,0,0,1284,
        1329,5,87,0,0,1285,1286,5,28,0,0,1286,1287,5,86,0,0,1287,1288,5,
        124,0,0,1288,1289,3,346,173,0,1289,1290,5,87,0,0,1290,1329,1,0,0,
        0,1291,1292,5,28,0,0,1292,1293,5,86,0,0,1293,1294,5,124,0,0,1294,
        1295,3,346,173,0,1295,1296,5,116,0,0,1296,1297,5,87,0,0,1297,1329,
        1,0,0,0,1298,1299,5,28,0,0,1299,1300,5,86,0,0,1300,1301,5,125,0,
        0,1301,1329,5,87,0,0,1302,1303,5,28,0,0,1303,1304,5,86,0,0,1304,
        1305,5,125,0,0,1305,1306,3,346,173,0,1306,1307,5,87,0,0,1307,1329,
        1,0,0,0,1308,1309,5,28,0,0,1309,1310,5,86,0,0,1310,1311,5,125,0,
        0,1311,1312,3,346,173,0,1312,1313,5,116,0,0,1313,1314,5,87,0,0,1314,
        1329,1,0,0,0,1315,1316,5,31,0,0,1316,1317,5,86,0,0,1317,1329,5,87,
        0,0,1318,1319,5,31,0,0,1319,1320,5,86,0,0,1320,1321,3,308,154,0,
        1321,1322,5,87,0,0,1322,1329,1,0,0,0,1323,1324,5,31,0,0,1324,1325,
        5,86,0,0,1325,1326,3,330,165,0,1326,1327,5,87,0,0,1327,1329,1,0,
        0,0,1328,1221,1,0,0,0,1328,1224,1,0,0,0,1328,1228,1,0,0,0,1328,1233,
        1,0,0,0,1328,1238,1,0,0,0,1328,1241,1,0,0,0,1328,1245,1,0,0,0,1328,
        1251,1,0,0,0,1328,1255,1,0,0,0,1328,1261,1,0,0,0,1328,1264,1,0,0,
        0,1328,1268,1,0,0,0,1328,1274,1,0,0,0,1328,1281,1,0,0,0,1328,1285,
        1,0,0,0,1328,1291,1,0,0,0,1328,1298,1,0,0,0,1328,1302,1,0,0,0,1328,
        1308,1,0,0,0,1328,1315,1,0,0,0,1328,1318,1,0,0,0,1328,1323,1,0,0,
        0,1329,227,1,0,0,0,1330,1335,3,230,115,0,1331,1332,5,89,0,0,1332,
        1334,3,230,115,0,1333,1331,1,0,0,0,1334,1337,1,0,0,0,1335,1333,1,
        0,0,0,1335,1336,1,0,0,0,1336,229,1,0,0,0,1337,1335,1,0,0,0,1338,
        1344,3,232,116,0,1339,1344,3,238,119,0,1340,1344,3,242,121,0,1341,
        1344,3,246,123,0,1342,1344,3,250,125,0,1343,1338,1,0,0,0,1343,1339,
        1,0,0,0,1343,1340,1,0,0,0,1343,1341,1,0,0,0,1343,1342,1,0,0,0,1344,
        231,1,0,0,0,1345,1346,5,19,0,0,1346,1349,5,86,0,0,1347,1350,3,234,
        117,0,1348,1350,3,236,118,0,1349,1347,1,0,0,0,1349,1348,1,0,0,0,
        1350,1351,1,0,0,0,1351,1352,5,87,0,0,1352,233,1,0,0,0,1353,1354,
        7,6,0,0,1354,1355,5,107,0,0,1355,1356,3,348,174,0,1356,235,1,0,0,
        0,1357,1358,7,6,0,0,1358,1359,7,0,0,0,1359,1360,5,69,0,0,1360,237,
        1,0,0,0,1361,1362,5,22,0,0,1362,1363,5,86,0,0,1363,1364,3,240,120,
        0,1364,1365,5,87,0,0,1365,239,1,0,0,0,1366,1367,7,7,0,0,1367,1368,
        3,334,167,0,1368,1369,3,344,172,0,1369,241,1,0,0,0,1370,1371,5,28,
        0,0,1371,1372,5,86,0,0,1372,1373,3,244,122,0,1373,1374,5,87,0,0,
        1374,243,1,0,0,0,1375,1378,3,336,168,0,1376,1378,3,338,169,0,1377,
        1375,1,0,0,0,1377,1376,1,0,0,0,1378,1379,1,0,0,0,1379,1380,5,157,
        0,0,1380,245,1,0,0,0,1381,1382,5,31,0,0,1382,1383,5,86,0,0,1383,
        1384,3,248,124,0,1384,1385,5,87,0,0,1385,247,1,0,0,0,1386,1389,3,
        306,153,0,1387,1389,3,328,164,0,1388,1386,1,0,0,0,1388,1387,1,0,
        0,0,1389,249,1,0,0,0,1390,1391,5,19,0,0,1391,1392,5,86,0,0,1392,
        1502,5,87,0,0,1393,1394,5,19,0,0,1394,1395,5,86,0,0,1395,1396,5,
        169,0,0,1396,1502,5,87,0,0,1397,1398,5,19,0,0,1398,1399,5,86,0,0,
        1399,1400,5,169,0,0,1400,1401,5,107,0,0,1401,1502,5,87,0,0,1402,
        1403,5,19,0,0,1403,1404,5,86,0,0,1404,1405,5,169,0,0,1405,1406,7,
        0,0,0,1406,1502,5,87,0,0,1407,1408,5,19,0,0,1408,1409,5,86,0,0,1409,
        1410,5,175,0,0,1410,1502,5,87,0,0,1411,1412,5,19,0,0,1412,1413,5,
        86,0,0,1413,1414,5,175,0,0,1414,1415,5,107,0,0,1415,1502,5,87,0,
        0,1416,1417,5,19,0,0,1417,1418,5,86,0,0,1418,1419,5,175,0,0,1419,
        1420,7,0,0,0,1420,1502,5,87,0,0,1421,1422,5,22,0,0,1422,1423,5,86,
        0,0,1423,1502,5,87,0,0,1424,1425,5,22,0,0,1425,1426,5,86,0,0,1426,
        1427,7,7,0,0,1427,1502,5,87,0,0,1428,1429,5,22,0,0,1429,1430,5,86,
        0,0,1430,1431,7,7,0,0,1431,1432,3,334,167,0,1432,1433,5,87,0,0,1433,
        1502,1,0,0,0,1434,1435,5,28,0,0,1435,1436,5,86,0,0,1436,1502,5,87,
        0,0,1437,1438,5,28,0,0,1438,1439,5,86,0,0,1439,1440,5,121,0,0,1440,
        1502,5,87,0,0,1441,1442,5,28,0,0,1442,1443,5,86,0,0,1443,1444,5,
        121,0,0,1444,1445,3,346,173,0,1445,1446,5,87,0,0,1446,1502,1,0,0,
        0,1447,1448,5,28,0,0,1448,1449,5,86,0,0,1449,1450,5,121,0,0,1450,
        1451,3,346,173,0,1451,1452,5,116,0,0,1452,1453,5,87,0,0,1453,1502,
        1,0,0,0,1454,1455,5,28,0,0,1455,1456,5,86,0,0,1456,1457,5,124,0,
        0,1457,1502,5,87,0,0,1458,1459,5,28,0,0,1459,1460,5,86,0,0,1460,
        1461,5,124,0,0,1461,1462,3,346,173,0,1462,1463,5,87,0,0,1463,1502,
        1,0,0,0,1464,1465,5,28,0,0,1465,1466,5,86,0,0,1466,1467,5,124,0,
        0,1467,1468,3,346,173,0,1468,1469,5,116,0,0,1469,1470,5,87,0,0,1470,
        1502,1,0,0,0,1471,1472,5,28,0,0,1472,1473,5,86,0,0,1473,1474,5,125,
        0,0,1474,1502,5,87,0,0,1475,1476,5,28,0,0,1476,1477,5,86,0,0,1477,
        1478,5,125,0,0,1478,1479,3,346,173,0,1479,1480,5,87,0,0,1480,1502,
        1,0,0,0,1481,1482,5,28,0,0,1482,1483,5,86,0,0,1483,1484,5,125,0,
        0,1484,1485,3,346,173,0,1485,1486,5,116,0,0,1486,1487,5,87,0,0,1487,
        1502,1,0,0,0,1488,1489,5,31,0,0,1489,1490,5,86,0,0,1490,1502,5,87,
        0,0,1491,1492,5,31,0,0,1492,1493,5,86,0,0,1493,1494,3,308,154,0,
        1494,1495,5,87,0,0,1495,1502,1,0,0,0,1496,1497,5,31,0,0,1497,1498,
        5,86,0,0,1498,1499,3,330,165,0,1499,1500,5,87,0,0,1500,1502,1,0,
        0,0,1501,1390,1,0,0,0,1501,1393,1,0,0,0,1501,1397,1,0,0,0,1501,1402,
        1,0,0,0,1501,1407,1,0,0,0,1501,1411,1,0,0,0,1501,1416,1,0,0,0,1501,
        1421,1,0,0,0,1501,1424,1,0,0,0,1501,1428,1,0,0,0,1501,1434,1,0,0,
        0,1501,1437,1,0,0,0,1501,1441,1,0,0,0,1501,1447,1,0,0,0,1501,1454,
        1,0,0,0,1501,1458,1,0,0,0,1501,1464,1,0,0,0,1501,1471,1,0,0,0,1501,
        1475,1,0,0,0,1501,1481,1,0,0,0,1501,1488,1,0,0,0,1501,1491,1,0,0,
        0,1501,1496,1,0,0,0,1502,251,1,0,0,0,1503,1508,3,254,127,0,1504,
        1505,5,89,0,0,1505,1507,3,254,127,0,1506,1504,1,0,0,0,1507,1510,
        1,0,0,0,1508,1506,1,0,0,0,1508,1509,1,0,0,0,1509,253,1,0,0,0,1510,
        1508,1,0,0,0,1511,1517,3,256,128,0,1512,1517,3,262,131,0,1513,1517,
        3,266,133,0,1514,1517,3,270,135,0,1515,1517,3,274,137,0,1516,1511,
        1,0,0,0,1516,1512,1,0,0,0,1516,1513,1,0,0,0,1516,1514,1,0,0,0,1516,
        1515,1,0,0,0,1517,255,1,0,0,0,1518,1519,5,19,0,0,1519,1522,5,86,
        0,0,1520,1523,3,258,129,0,1521,1523,3,260,130,0,1522,1520,1,0,0,
        0,1522,1521,1,0,0,0,1523,1524,1,0,0,0,1524,1525,5,87,0,0,1525,257,
        1,0,0,0,1526,1527,7,8,0,0,1527,1528,5,107,0,0,1528,1529,3,348,174,
        0,1529,259,1,0,0,0,1530,1531,7,8,0,0,1531,1532,7,0,0,0,1532,1533,
        5,69,0,0,1533,261,1,0,0,0,1534,1535,5,22,0,0,1535,1536,5,86,0,0,
        1536,1537,3,264,132,0,1537,1538,5,87,0,0,1538,263,1,0,0,0,1539,1540,
        5,165,0,0,1540,1541,3,334,167,0,1541,1542,3,344,172,0,1542,265,1,
        0,0,0,1543,1544,5,28,0,0,1544,1545,5,86,0,0,1545,1546,3,268,134,
        0,1546,1547,5,87,0,0,1547,267,1,0,0,0,1548,1551,3,336,168,0,1549,
        1551,3,338,169,0,1550,1548,1,0,0,0,1550,1549,1,0,0,0,1551,1552,1,
        0,0,0,1552,1553,5,158,0,0,1553,269,1,0,0,0,1554,1555,5,31,0,0,1555,
        1556,5,86,0,0,1556,1557,3,272,136,0,1557,1558,5,87,0,0,1558,271,
        1,0,0,0,1559,1562,3,306,153,0,1560,1562,3,328,164,0,1561,1559,1,
        0,0,0,1561,1560,1,0,0,0,1562,273,1,0,0,0,1563,1564,5,19,0,0,1564,
        1565,5,86,0,0,1565,1675,5,87,0,0,1566,1567,5,19,0,0,1567,1568,5,
        86,0,0,1568,1569,5,170,0,0,1569,1675,5,87,0,0,1570,1571,5,19,0,0,
        1571,1572,5,86,0,0,1572,1573,5,170,0,0,1573,1574,5,107,0,0,1574,
        1675,5,87,0,0,1575,1576,5,19,0,0,1576,1577,5,86,0,0,1577,1578,5,
        170,0,0,1578,1579,7,0,0,0,1579,1675,5,87,0,0,1580,1581,5,19,0,0,
        1581,1582,5,86,0,0,1582,1583,5,175,0,0,1583,1675,5,87,0,0,1584,1585,
        5,19,0,0,1585,1586,5,86,0,0,1586,1587,5,175,0,0,1587,1588,5,107,
        0,0,1588,1675,5,87,0,0,1589,1590,5,19,0,0,1590,1591,5,86,0,0,1591,
        1592,5,175,0,0,1592,1593,7,0,0,0,1593,1675,5,87,0,0,1594,1595,5,
        22,0,0,1595,1596,5,86,0,0,1596,1675,5,87,0,0,1597,1598,5,22,0,0,
        1598,1599,5,86,0,0,1599,1600,5,165,0,0,1600,1675,5,87,0,0,1601,1602,
        5,22,0,0,1602,1603,5,86,0,0,1603,1604,5,165,0,0,1604,1605,3,334,
        167,0,1605,1606,5,87,0,0,1606,1675,1,0,0,0,1607,1608,5,28,0,0,1608,
        1609,5,86,0,0,1609,1675,5,87,0,0,1610,1611,5,28,0,0,1611,1612,5,
        86,0,0,1612,1613,5,121,0,0,1613,1675,5,87,0,0,1614,1615,5,28,0,0,
        1615,1616,5,86,0,0,1616,1617,5,121,0,0,1617,1618,3,346,173,0,1618,
        1619,5,87,0,0,1619,1675,1,0,0,0,1620,1621,5,28,0,0,1621,1622,5,86,
        0,0,1622,1623,5,121,0,0,1623,1624,3,346,173,0,1624,1625,5,116,0,
        0,1625,1626,5,87,0,0,1626,1675,1,0,0,0,1627,1628,5,28,0,0,1628,1629,
        5,86,0,0,1629,1630,5,124,0,0,1630,1675,5,87,0,0,1631,1632,5,28,0,
        0,1632,1633,5,86,0,0,1633,1634,5,124,0,0,1634,1635,3,346,173,0,1635,
        1636,5,87,0,0,1636,1675,1,0,0,0,1637,1638,5,28,0,0,1638,1639,5,86,
        0,0,1639,1640,5,124,0,0,1640,1641,3,346,173,0,1641,1642,5,116,0,
        0,1642,1643,5,87,0,0,1643,1675,1,0,0,0,1644,1645,5,28,0,0,1645,1646,
        5,86,0,0,1646,1647,5,125,0,0,1647,1675,5,87,0,0,1648,1649,5,28,0,
        0,1649,1650,5,86,0,0,1650,1651,5,125,0,0,1651,1652,3,346,173,0,1652,
        1653,5,87,0,0,1653,1675,1,0,0,0,1654,1655,5,28,0,0,1655,1656,5,86,
        0,0,1656,1657,5,125,0,0,1657,1658,3,346,173,0,1658,1659,5,116,0,
        0,1659,1660,5,87,0,0,1660,1675,1,0,0,0,1661,1662,5,31,0,0,1662,1663,
        5,86,0,0,1663,1675,5,87,0,0,1664,1665,5,31,0,0,1665,1666,5,86,0,
        0,1666,1667,3,308,154,0,1667,1668,5,87,0,0,1668,1675,1,0,0,0,1669,
        1670,5,31,0,0,1670,1671,5,86,0,0,1671,1672,3,330,165,0,1672,1673,
        5,87,0,0,1673,1675,1,0,0,0,1674,1563,1,0,0,0,1674,1566,1,0,0,0,1674,
        1570,1,0,0,0,1674,1575,1,0,0,0,1674,1580,1,0,0,0,1674,1584,1,0,0,
        0,1674,1589,1,0,0,0,1674,1594,1,0,0,0,1674,1597,1,0,0,0,1674,1601,
        1,0,0,0,1674,1607,1,0,0,0,1674,1610,1,0,0,0,1674,1614,1,0,0,0,1674,
        1620,1,0,0,0,1674,1627,1,0,0,0,1674,1631,1,0,0,0,1674,1637,1,0,0,
        0,1674,1644,1,0,0,0,1674,1648,1,0,0,0,1674,1654,1,0,0,0,1674,1661,
        1,0,0,0,1674,1664,1,0,0,0,1674,1669,1,0,0,0,1675,275,1,0,0,0,1676,
        1681,3,278,139,0,1677,1678,5,89,0,0,1678,1680,3,278,139,0,1679,1677,
        1,0,0,0,1680,1683,1,0,0,0,1681,1679,1,0,0,0,1681,1682,1,0,0,0,1682,
        277,1,0,0,0,1683,1681,1,0,0,0,1684,1690,3,280,140,0,1685,1690,3,
        286,143,0,1686,1690,3,290,145,0,1687,1690,3,294,147,0,1688,1690,
        3,298,149,0,1689,1684,1,0,0,0,1689,1685,1,0,0,0,1689,1686,1,0,0,
        0,1689,1687,1,0,0,0,1689,1688,1,0,0,0,1690,279,1,0,0,0,1691,1692,
        5,19,0,0,1692,1695,5,86,0,0,1693,1696,3,282,141,0,1694,1696,3,284,
        142,0,1695,1693,1,0,0,0,1695,1694,1,0,0,0,1696,1697,1,0,0,0,1697,
        1698,5,87,0,0,1698,281,1,0,0,0,1699,1700,5,172,0,0,1700,1701,5,107,
        0,0,1701,1702,3,348,174,0,1702,283,1,0,0,0,1703,1704,5,172,0,0,1704,
        1705,7,0,0,0,1705,1706,5,69,0,0,1706,285,1,0,0,0,1707,1708,5,22,
        0,0,1708,1709,5,86,0,0,1709,1710,3,288,144,0,1710,1711,5,87,0,0,
        1711,287,1,0,0,0,1712,1713,5,166,0,0,1713,1714,3,334,167,0,1714,
        1715,3,346,173,0,1715,289,1,0,0,0,1716,1717,5,28,0,0,1717,1718,5,
        86,0,0,1718,1719,3,292,146,0,1719,1720,5,87,0,0,1720,291,1,0,0,0,
        1721,1724,3,336,168,0,1722,1724,3,338,169,0,1723,1721,1,0,0,0,1723,
        1722,1,0,0,0,1724,1725,1,0,0,0,1725,1726,5,159,0,0,1726,293,1,0,
        0,0,1727,1728,5,31,0,0,1728,1729,5,86,0,0,1729,1730,3,296,148,0,
        1730,1731,5,87,0,0,1731,295,1,0,0,0,1732,1735,3,306,153,0,1733,1735,
        3,328,164,0,1734,1732,1,0,0,0,1734,1733,1,0,0,0,1735,297,1,0,0,0,
        1736,1737,5,19,0,0,1737,1738,5,86,0,0,1738,1834,5,87,0,0,1739,1740,
        5,19,0,0,1740,1741,5,86,0,0,1741,1742,5,172,0,0,1742,1834,5,87,0,
        0,1743,1744,5,19,0,0,1744,1745,5,86,0,0,1745,1746,5,172,0,0,1746,
        1747,5,107,0,0,1747,1834,5,87,0,0,1748,1749,5,19,0,0,1749,1750,5,
        86,0,0,1750,1751,5,172,0,0,1751,1752,7,0,0,0,1752,1834,5,87,0,0,
        1753,1754,5,22,0,0,1754,1755,5,86,0,0,1755,1834,5,87,0,0,1756,1757,
        5,22,0,0,1757,1758,5,86,0,0,1758,1759,5,166,0,0,1759,1834,5,87,0,
        0,1760,1761,5,22,0,0,1761,1762,5,86,0,0,1762,1763,5,166,0,0,1763,
        1764,3,334,167,0,1764,1765,5,87,0,0,1765,1834,1,0,0,0,1766,1767,
        5,28,0,0,1767,1768,5,86,0,0,1768,1834,5,87,0,0,1769,1770,5,28,0,
        0,1770,1771,5,86,0,0,1771,1772,5,121,0,0,1772,1834,5,87,0,0,1773,
        1774,5,28,0,0,1774,1775,5,86,0,0,1775,1776,5,121,0,0,1776,1777,3,
        346,173,0,1777,1778,5,87,0,0,1778,1834,1,0,0,0,1779,1780,5,28,0,
        0,1780,1781,5,86,0,0,1781,1782,5,121,0,0,1782,1783,3,346,173,0,1783,
        1784,5,116,0,0,1784,1785,5,87,0,0,1785,1834,1,0,0,0,1786,1787,5,
        28,0,0,1787,1788,5,86,0,0,1788,1789,5,124,0,0,1789,1834,5,87,0,0,
        1790,1791,5,28,0,0,1791,1792,5,86,0,0,1792,1793,5,124,0,0,1793,1794,
        3,346,173,0,1794,1795,5,87,0,0,1795,1834,1,0,0,0,1796,1797,5,28,
        0,0,1797,1798,5,86,0,0,1798,1799,5,124,0,0,1799,1800,3,346,173,0,
        1800,1801,5,116,0,0,1801,1802,5,87,0,0,1802,1834,1,0,0,0,1803,1804,
        5,28,0,0,1804,1805,5,86,0,0,1805,1806,5,125,0,0,1806,1834,5,87,0,
        0,1807,1808,5,28,0,0,1808,1809,5,86,0,0,1809,1810,5,125,0,0,1810,
        1811,3,346,173,0,1811,1812,5,87,0,0,1812,1834,1,0,0,0,1813,1814,
        5,28,0,0,1814,1815,5,86,0,0,1815,1816,5,125,0,0,1816,1817,3,346,
        173,0,1817,1818,5,116,0,0,1818,1819,5,87,0,0,1819,1834,1,0,0,0,1820,
        1821,5,31,0,0,1821,1822,5,86,0,0,1822,1834,5,87,0,0,1823,1824,5,
        31,0,0,1824,1825,5,86,0,0,1825,1826,3,308,154,0,1826,1827,5,87,0,
        0,1827,1834,1,0,0,0,1828,1829,5,31,0,0,1829,1830,5,86,0,0,1830,1831,
        3,330,165,0,1831,1832,5,87,0,0,1832,1834,1,0,0,0,1833,1736,1,0,0,
        0,1833,1739,1,0,0,0,1833,1743,1,0,0,0,1833,1748,1,0,0,0,1833,1753,
        1,0,0,0,1833,1756,1,0,0,0,1833,1760,1,0,0,0,1833,1766,1,0,0,0,1833,
        1769,1,0,0,0,1833,1773,1,0,0,0,1833,1779,1,0,0,0,1833,1786,1,0,0,
        0,1833,1790,1,0,0,0,1833,1796,1,0,0,0,1833,1803,1,0,0,0,1833,1807,
        1,0,0,0,1833,1813,1,0,0,0,1833,1820,1,0,0,0,1833,1823,1,0,0,0,1833,
        1828,1,0,0,0,1834,299,1,0,0,0,1835,1836,5,19,0,0,1836,1839,5,86,
        0,0,1837,1840,3,302,151,0,1838,1840,3,304,152,0,1839,1837,1,0,0,
        0,1839,1838,1,0,0,0,1840,1841,1,0,0,0,1841,1842,5,87,0,0,1842,301,
        1,0,0,0,1843,1844,5,173,0,0,1844,1845,5,107,0,0,1845,1846,3,348,
        174,0,1846,303,1,0,0,0,1847,1848,5,173,0,0,1848,1849,7,0,0,0,1849,
        1850,5,69,0,0,1850,305,1,0,0,0,1851,1854,5,135,0,0,1852,1855,3,302,
        151,0,1853,1855,3,304,152,0,1854,1852,1,0,0,0,1854,1853,1,0,0,0,
        1855,307,1,0,0,0,1856,1867,1,0,0,0,1857,1867,5,135,0,0,1858,1859,
        5,135,0,0,1859,1867,5,173,0,0,1860,1861,5,135,0,0,1861,1862,5,173,
        0,0,1862,1867,5,107,0,0,1863,1864,5,135,0,0,1864,1865,5,173,0,0,
        1865,1867,7,0,0,0,1866,1856,1,0,0,0,1866,1857,1,0,0,0,1866,1858,
        1,0,0,0,1866,1860,1,0,0,0,1866,1863,1,0,0,0,1867,309,1,0,0,0,1868,
        1873,3,312,156,0,1869,1870,5,89,0,0,1870,1872,3,312,156,0,1871,1869,
        1,0,0,0,1872,1875,1,0,0,0,1873,1871,1,0,0,0,1873,1874,1,0,0,0,1874,
        311,1,0,0,0,1875,1873,1,0,0,0,1876,1881,3,314,157,0,1877,1881,3,
        320,160,0,1878,1881,3,324,162,0,1879,1881,3,332,166,0,1880,1876,
        1,0,0,0,1880,1877,1,0,0,0,1880,1878,1,0,0,0,1880,1879,1,0,0,0,1881,
        313,1,0,0,0,1882,1883,5,19,0,0,1883,1886,5,86,0,0,1884,1887,3,316,
        158,0,1885,1887,3,318,159,0,1886,1884,1,0,0,0,1886,1885,1,0,0,0,
        1887,1888,1,0,0,0,1888,1889,5,87,0,0,1889,315,1,0,0,0,1890,1891,
        5,174,0,0,1891,1892,5,107,0,0,1892,1893,3,348,174,0,1893,317,1,0,
        0,0,1894,1895,5,174,0,0,1895,1896,7,0,0,0,1896,1897,5,69,0,0,1897,
        319,1,0,0,0,1898,1899,5,28,0,0,1899,1900,5,86,0,0,1900,1901,3,322,
        161,0,1901,1902,5,87,0,0,1902,321,1,0,0,0,1903,1906,3,336,168,0,
        1904,1906,3,338,169,0,1905,1903,1,0,0,0,1905,1904,1,0,0,0,1906,1907,
        1,0,0,0,1907,1908,5,160,0,0,1908,323,1,0,0,0,1909,1910,5,31,0,0,
        1910,1911,5,86,0,0,1911,1912,3,326,163,0,1912,1913,5,87,0,0,1913,
        325,1,0,0,0,1914,1917,3,306,153,0,1915,1917,3,196,98,0,1916,1914,
        1,0,0,0,1916,1915,1,0,0,0,1917,327,1,0,0,0,1918,1921,5,136,0,0,1919,
        1922,3,316,158,0,1920,1922,3,318,159,0,1921,1919,1,0,0,0,1921,1920,
        1,0,0,0,1922,329,1,0,0,0,1923,1934,1,0,0,0,1924,1934,5,136,0,0,1925,
        1926,5,136,0,0,1926,1934,5,174,0,0,1927,1928,5,136,0,0,1928,1929,
        5,174,0,0,1929,1934,5,107,0,0,1930,1931,5,136,0,0,1931,1932,5,174,
        0,0,1932,1934,7,0,0,0,1933,1923,1,0,0,0,1933,1924,1,0,0,0,1933,1925,
        1,0,0,0,1933,1927,1,0,0,0,1933,1930,1,0,0,0,1934,331,1,0,0,0,1935,
        1936,5,19,0,0,1936,1937,5,86,0,0,1937,2020,5,87,0,0,1938,1939,5,
        19,0,0,1939,1940,5,86,0,0,1940,1941,5,174,0,0,1941,2020,5,87,0,0,
        1942,1943,5,19,0,0,1943,1944,5,86,0,0,1944,1945,5,174,0,0,1945,1946,
        5,107,0,0,1946,2020,5,87,0,0,1947,1948,5,19,0,0,1948,1949,5,86,0,
        0,1949,1950,5,174,0,0,1950,1951,7,0,0,0,1951,2020,5,87,0,0,1952,
        1953,5,28,0,0,1953,1954,5,86,0,0,1954,2020,5,87,0,0,1955,1956,5,
        28,0,0,1956,1957,5,86,0,0,1957,1958,5,121,0,0,1958,2020,5,87,0,0,
        1959,1960,5,28,0,0,1960,1961,5,86,0,0,1961,1962,5,121,0,0,1962,1963,
        3,346,173,0,1963,1964,5,87,0,0,1964,2020,1,0,0,0,1965,1966,5,28,
        0,0,1966,1967,5,86,0,0,1967,1968,5,121,0,0,1968,1969,3,346,173,0,
        1969,1970,5,116,0,0,1970,1971,5,87,0,0,1971,2020,1,0,0,0,1972,1973,
        5,28,0,0,1973,1974,5,86,0,0,1974,1975,5,124,0,0,1975,2020,5,87,0,
        0,1976,1977,5,28,0,0,1977,1978,5,86,0,0,1978,1979,5,124,0,0,1979,
        1980,3,346,173,0,1980,1981,5,87,0,0,1981,2020,1,0,0,0,1982,1983,
        5,28,0,0,1983,1984,5,86,0,0,1984,1985,5,124,0,0,1985,1986,3,346,
        173,0,1986,1987,5,116,0,0,1987,1988,5,87,0,0,1988,2020,1,0,0,0,1989,
        1990,5,28,0,0,1990,1991,5,86,0,0,1991,1992,5,125,0,0,1992,2020,5,
        87,0,0,1993,1994,5,28,0,0,1994,1995,5,86,0,0,1995,1996,5,125,0,0,
        1996,1997,3,346,173,0,1997,1998,5,87,0,0,1998,2020,1,0,0,0,1999,
        2000,5,28,0,0,2000,2001,5,86,0,0,2001,2002,5,125,0,0,2002,2003,3,
        346,173,0,2003,2004,5,116,0,0,2004,2005,5,87,0,0,2005,2020,1,0,0,
        0,2006,2007,5,31,0,0,2007,2008,5,86,0,0,2008,2020,5,87,0,0,2009,
        2010,5,31,0,0,2010,2011,5,86,0,0,2011,2012,3,308,154,0,2012,2013,
        5,87,0,0,2013,2020,1,0,0,0,2014,2015,5,31,0,0,2015,2016,5,86,0,0,
        2016,2017,3,198,99,0,2017,2018,5,87,0,0,2018,2020,1,0,0,0,2019,1935,
        1,0,0,0,2019,1938,1,0,0,0,2019,1942,1,0,0,0,2019,1947,1,0,0,0,2019,
        1952,1,0,0,0,2019,1955,1,0,0,0,2019,1959,1,0,0,0,2019,1965,1,0,0,
        0,2019,1972,1,0,0,0,2019,1976,1,0,0,0,2019,1982,1,0,0,0,2019,1989,
        1,0,0,0,2019,1993,1,0,0,0,2019,1999,1,0,0,0,2019,2006,1,0,0,0,2019,
        2009,1,0,0,0,2019,2014,1,0,0,0,2020,333,1,0,0,0,2021,2022,7,9,0,
        0,2022,335,1,0,0,0,2023,2024,5,121,0,0,2024,2025,3,346,173,0,2025,
        2026,5,116,0,0,2026,337,1,0,0,0,2027,2030,3,340,170,0,2028,2030,
        3,342,171,0,2029,2027,1,0,0,0,2029,2028,1,0,0,0,2030,339,1,0,0,0,
        2031,2032,5,124,0,0,2032,2033,3,346,173,0,2033,2034,5,116,0,0,2034,
        341,1,0,0,0,2035,2036,5,125,0,0,2036,2037,3,346,173,0,2037,2038,
        5,116,0,0,2038,343,1,0,0,0,2039,2048,3,346,173,0,2040,2042,5,81,
        0,0,2041,2040,1,0,0,0,2041,2042,1,0,0,0,2042,2043,1,0,0,0,2043,2045,
        5,126,0,0,2044,2046,5,81,0,0,2045,2044,1,0,0,0,2045,2046,1,0,0,0,
        2046,2048,1,0,0,0,2047,2039,1,0,0,0,2047,2041,1,0,0,0,2048,345,1,
        0,0,0,2049,2050,5,81,0,0,2050,347,1,0,0,0,2051,2056,5,53,0,0,2052,
        2053,5,89,0,0,2053,2055,5,53,0,0,2054,2052,1,0,0,0,2055,2058,1,0,
        0,0,2056,2054,1,0,0,0,2056,2057,1,0,0,0,2057,349,1,0,0,0,2058,2056,
        1,0,0,0,102,352,355,358,361,366,369,374,380,399,406,410,414,469,
        496,501,510,516,522,568,581,593,599,604,635,644,654,658,662,668,
        681,739,754,761,765,780,786,793,808,815,821,829,849,869,887,901,
        909,927,962,969,976,983,990,997,1006,1013,1019,1038,1049,1054,1066,
        1152,1159,1167,1173,1189,1208,1219,1328,1335,1343,1349,1377,1388,
        1501,1508,1516,1522,1550,1561,1674,1681,1689,1695,1723,1734,1833,
        1839,1854,1866,1873,1880,1886,1905,1916,1921,1933,2019,2029,2041,
        2045,2047,2056
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!CohortDefinition.__ATN) {
            CohortDefinition.__ATN = new antlr.ATNDeserializer().deserialize(CohortDefinition._serializedATN);
        }

        return CohortDefinition.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(CohortDefinition.literalNames, CohortDefinition.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return CohortDefinition.vocabulary;
    }

    private static readonly decisionsToDFA = CohortDefinition._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}

export class Cohort_definitionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public inclusion_criteria(): Inclusion_criteriaContext | null {
        return this.getRuleContext(0, Inclusion_criteriaContext);
    }
    public exclusion_criteria(): Exclusion_criteriaContext | null {
        return this.getRuleContext(0, Exclusion_criteriaContext);
    }
    public study_period_criteria(): Study_period_criteriaContext | null {
        return this.getRuleContext(0, Study_period_criteriaContext);
    }
    public baseline_period_criteria(): Baseline_period_criteriaContext | null {
        return this.getRuleContext(0, Baseline_period_criteriaContext);
    }
    public follow_up_period_criteria(): Follow_up_period_criteriaContext | null {
        return this.getRuleContext(0, Follow_up_period_criteriaContext);
    }
    public subjects_variable(): Subjects_variableContext[];
    public subjects_variable(i: number): Subjects_variableContext | null;
    public subjects_variable(i?: number): Subjects_variableContext[] | Subjects_variableContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Subjects_variableContext);
        }

        return this.getRuleContext(i, Subjects_variableContext);
    }
    public index_date(): Index_dateContext | null {
        return this.getRuleContext(0, Index_dateContext);
    }
    public derived_event(): Derived_eventContext[];
    public derived_event(i: number): Derived_eventContext | null;
    public derived_event(i?: number): Derived_eventContext[] | Derived_eventContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Derived_eventContext);
        }

        return this.getRuleContext(i, Derived_eventContext);
    }
    public simple_event(): Simple_eventContext[];
    public simple_event(i: number): Simple_eventContext | null;
    public simple_event(i?: number): Simple_eventContext[] | Simple_eventContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Simple_eventContext);
        }

        return this.getRuleContext(i, Simple_eventContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_cohort_definition;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCohort_definition) {
             listener.enterCohort_definition(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCohort_definition) {
             listener.exitCohort_definition(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCohort_definition) {
            return visitor.visitCohort_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Inclusion_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INCLUDE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INCLUDE, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public cohort_criterion_set(): Cohort_criterion_setContext {
        return this.getRuleContext(0, Cohort_criterion_setContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_inclusion_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterInclusion_criteria) {
             listener.enterInclusion_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitInclusion_criteria) {
             listener.exitInclusion_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitInclusion_criteria) {
            return visitor.visitInclusion_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Exclusion_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EXCLUDE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EXCLUDE, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public cohort_criterion_set(): Cohort_criterion_setContext {
        return this.getRuleContext(0, Cohort_criterion_setContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_exclusion_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterExclusion_criteria) {
             listener.enterExclusion_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitExclusion_criteria) {
             listener.exitExclusion_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitExclusion_criteria) {
            return visitor.visitExclusion_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Cohort_criterion_setContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SUBJECTS_VARIABLE_NAME(): antlr.TerminalNode[];
    public SUBJECTS_VARIABLE_NAME(i: number): antlr.TerminalNode | null;
    public SUBJECTS_VARIABLE_NAME(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.SUBJECTS_VARIABLE_NAME);
    	} else {
    		return this.getToken(CohortDefinition.SUBJECTS_VARIABLE_NAME, i);
    	}
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_cohort_criterion_set;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCohort_criterion_set) {
             listener.enterCohort_criterion_set(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCohort_criterion_set) {
             listener.exitCohort_criterion_set(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCohort_criterion_set) {
            return visitor.visitCohort_criterion_set(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Study_period_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public overall_study_period(): Overall_study_periodContext | null {
        return this.getRuleContext(0, Overall_study_periodContext);
    }
    public overall_study_period_error(): Overall_study_period_errorContext | null {
        return this.getRuleContext(0, Overall_study_period_errorContext);
    }
    public overall_study_period_error2(): Overall_study_period_error2Context | null {
        return this.getRuleContext(0, Overall_study_period_error2Context);
    }
    public overall_study_period_error3(): Overall_study_period_error3Context | null {
        return this.getRuleContext(0, Overall_study_period_error3Context);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_study_period_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterStudy_period_criteria) {
             listener.enterStudy_period_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitStudy_period_criteria) {
             listener.exitStudy_period_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitStudy_period_criteria) {
            return visitor.visitStudy_period_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Baseline_period_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public baseline_period(): Baseline_periodContext | null {
        return this.getRuleContext(0, Baseline_periodContext);
    }
    public baseline_period_error(): Baseline_period_errorContext | null {
        return this.getRuleContext(0, Baseline_period_errorContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_baseline_period_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterBaseline_period_criteria) {
             listener.enterBaseline_period_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitBaseline_period_criteria) {
             listener.exitBaseline_period_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitBaseline_period_criteria) {
            return visitor.visitBaseline_period_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Follow_up_period_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public follow_up_period(): Follow_up_periodContext | null {
        return this.getRuleContext(0, Follow_up_periodContext);
    }
    public follow_up_period_error(): Follow_up_period_errorContext | null {
        return this.getRuleContext(0, Follow_up_period_errorContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_follow_up_period_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterFollow_up_period_criteria) {
             listener.enterFollow_up_period_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitFollow_up_period_criteria) {
             listener.exitFollow_up_period_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitFollow_up_period_criteria) {
            return visitor.visitFollow_up_period_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Overall_study_periodContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public STUDY_PERIOD(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.STUDY_PERIOD, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode[];
    public DATE(i: number): antlr.TerminalNode | null;
    public DATE(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.DATE);
    	} else {
    		return this.getToken(CohortDefinition.DATE, i);
    	}
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.COMMA, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_overall_study_period;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterOverall_study_period) {
             listener.enterOverall_study_period(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitOverall_study_period) {
             listener.exitOverall_study_period(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitOverall_study_period) {
            return visitor.visitOverall_study_period(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Overall_study_period_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public STUDY_PERIOD(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.STUDY_PERIOD, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_overall_study_period_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterOverall_study_period_error) {
             listener.enterOverall_study_period_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitOverall_study_period_error) {
             listener.exitOverall_study_period_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitOverall_study_period_error) {
            return visitor.visitOverall_study_period_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Overall_study_period_error2Context extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public STUDY_PERIOD(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.STUDY_PERIOD, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_overall_study_period_error2;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterOverall_study_period_error2) {
             listener.enterOverall_study_period_error2(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitOverall_study_period_error2) {
             listener.exitOverall_study_period_error2(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitOverall_study_period_error2) {
            return visitor.visitOverall_study_period_error2(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Overall_study_period_error3Context extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public STUDY_PERIOD(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.STUDY_PERIOD, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DATE, 0)!;
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.COMMA, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_overall_study_period_error3;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterOverall_study_period_error3) {
             listener.enterOverall_study_period_error3(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitOverall_study_period_error3) {
             listener.exitOverall_study_period_error3(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitOverall_study_period_error3) {
            return visitor.visitOverall_study_period_error3(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Baseline_periodContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public BASELINE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.BASELINE, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INT, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_baseline_period;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterBaseline_period) {
             listener.enterBaseline_period(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitBaseline_period) {
             listener.exitBaseline_period(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitBaseline_period) {
            return visitor.visitBaseline_period(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Baseline_period_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public BASELINE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.BASELINE, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_baseline_period_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterBaseline_period_error) {
             listener.enterBaseline_period_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitBaseline_period_error) {
             listener.exitBaseline_period_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitBaseline_period_error) {
            return visitor.visitBaseline_period_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Follow_up_periodContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FOLLOW_UP(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.FOLLOW_UP, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INT, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_follow_up_period;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterFollow_up_period) {
             listener.enterFollow_up_period(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitFollow_up_period) {
             listener.exitFollow_up_period(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitFollow_up_period) {
            return visitor.visitFollow_up_period(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Follow_up_period_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FOLLOW_UP(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.FOLLOW_UP, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_follow_up_period_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterFollow_up_period_error) {
             listener.enterFollow_up_period_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitFollow_up_period_error) {
             listener.exitFollow_up_period_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitFollow_up_period_error) {
            return visitor.visitFollow_up_period_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Subjects_variableContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SUBJECTS_VARIABLE_NAME(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SUBJECTS_VARIABLE_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public demographic_event_criteria(): Demographic_event_criteriaContext | null {
        return this.getRuleContext(0, Demographic_event_criteriaContext);
    }
    public event_count_criteria(): Event_count_criteriaContext | null {
        return this.getRuleContext(0, Event_count_criteriaContext);
    }
    public event_count_criteria_error(): Event_count_criteria_errorContext | null {
        return this.getRuleContext(0, Event_count_criteria_errorContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_subjects_variable;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSubjects_variable) {
             listener.enterSubjects_variable(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSubjects_variable) {
             listener.exitSubjects_variable(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSubjects_variable) {
            return visitor.visitSubjects_variable(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Event_count_criteriaContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Count_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public COUNT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.COUNT, 0)!;
    }
    public count_criteria(): Count_criteriaContext {
        return this.getRuleContext(0, Count_criteriaContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_event_count_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterEvent_count_criteria) {
             listener.enterEvent_count_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitEvent_count_criteria) {
             listener.exitEvent_count_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitEvent_count_criteria) {
            return visitor.visitEvent_count_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Count_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public subject_variable_event_name(): Subject_variable_event_nameContext {
        return this.getRuleContext(0, Subject_variable_event_nameContext)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_count_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCount_criteria) {
             listener.enterCount_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCount_criteria) {
             listener.exitCount_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCount_criteria) {
            return visitor.visitCount_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Event_count_criteria_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COUNT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.COUNT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public subject_variable_event_name(): Subject_variable_event_nameContext | null {
        return this.getRuleContext(0, Subject_variable_event_nameContext);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_event_count_criteria_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterEvent_count_criteria_error) {
             listener.enterEvent_count_criteria_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitEvent_count_criteria_error) {
             listener.exitEvent_count_criteria_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitEvent_count_criteria_error) {
            return visitor.visitEvent_count_criteria_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_event_criteriaContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public PERSON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PERSON, 0)!;
    }
    public demographic_event_filters(): Demographic_event_filtersContext | null {
        return this.getRuleContext(0, Demographic_event_filtersContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_demographic_event_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDemographic_event_criteria) {
             listener.enterDemographic_event_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDemographic_event_criteria) {
             listener.exitDemographic_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDemographic_event_criteria) {
            return visitor.visitDemographic_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_event_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public demographic_event_filter(): Demographic_event_filterContext[];
    public demographic_event_filter(i: number): Demographic_event_filterContext | null;
    public demographic_event_filter(i?: number): Demographic_event_filterContext[] | Demographic_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Demographic_event_filterContext);
        }

        return this.getRuleContext(i, Demographic_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_demographic_event_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDemographic_event_filters) {
             listener.enterDemographic_event_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDemographic_event_filters) {
             listener.exitDemographic_event_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDemographic_event_filters) {
            return visitor.visitDemographic_event_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public demographic_concept_filter(): Demographic_concept_filterContext | null {
        return this.getRuleContext(0, Demographic_concept_filterContext);
    }
    public demographic_numeric_filter(): Demographic_numeric_filterContext | null {
        return this.getRuleContext(0, Demographic_numeric_filterContext);
    }
    public demographic_error_filter(): Demographic_error_filterContext | null {
        return this.getRuleContext(0, Demographic_error_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_demographic_event_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDemographic_event_filter) {
             listener.enterDemographic_event_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDemographic_event_filter) {
             listener.exitDemographic_event_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDemographic_event_filter) {
            return visitor.visitDemographic_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_concept_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public demographic_concept_group_filter(): Demographic_concept_group_filterContext | null {
        return this.getRuleContext(0, Demographic_concept_group_filterContext);
    }
    public demographic_concept_id_filter(): Demographic_concept_id_filterContext | null {
        return this.getRuleContext(0, Demographic_concept_id_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_demographic_concept_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDemographic_concept_filter) {
             listener.enterDemographic_concept_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDemographic_concept_filter) {
             listener.exitDemographic_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDemographic_concept_filter) {
            return visitor.visitDemographic_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PERSON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PERSON_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_demographic_concept_group_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDemographic_concept_group_filter) {
             listener.enterDemographic_concept_group_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDemographic_concept_group_filter) {
             listener.exitDemographic_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDemographic_concept_group_filter) {
            return visitor.visitDemographic_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_concept_id_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PERSON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PERSON_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_demographic_concept_id_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDemographic_concept_id_filter) {
             listener.enterDemographic_concept_id_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDemographic_concept_id_filter) {
             listener.exitDemographic_concept_id_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDemographic_concept_id_filter) {
            return visitor.visitDemographic_concept_id_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_numeric_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public demographic_int_filter(): Demographic_int_filterContext | null {
        return this.getRuleContext(0, Demographic_int_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_demographic_numeric_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDemographic_numeric_filter) {
             listener.enterDemographic_numeric_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDemographic_numeric_filter) {
             listener.exitDemographic_numeric_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDemographic_numeric_filter) {
            return visitor.visitDemographic_numeric_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PERSON_INT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PERSON_INT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_demographic_int_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDemographic_int_filter) {
             listener.enterDemographic_int_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDemographic_int_filter) {
             listener.exitDemographic_int_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDemographic_int_filter) {
            return visitor.visitDemographic_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_error_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public PERSON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.PERSON_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.IN, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NF, 0);
    }
    public PERSON_INT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.PERSON_INT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_demographic_error_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDemographic_error_filter) {
             listener.enterDemographic_error_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDemographic_error_filter) {
             listener.exitDemographic_error_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDemographic_error_filter) {
            return visitor.visitDemographic_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Subject_variable_event_nameContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SUBJECT_VARIABLE_CARE_SITE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.SUBJECT_VARIABLE_CARE_SITE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.SUBJECT_VARIABLE_MEASUREMENT_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.SUBJECT_VARIABLE_OBSERVATION_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_PROVIDER_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.SUBJECT_VARIABLE_PROVIDER_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_DERIVED_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.SUBJECT_VARIABLE_DERIVED_EVENT_NAME, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_subject_variable_event_name;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSubject_variable_event_name) {
             listener.enterSubject_variable_event_name(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSubject_variable_event_name) {
             listener.exitSubject_variable_event_name(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSubject_variable_event_name) {
            return visitor.visitSubject_variable_event_name(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_dateContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INDEX_DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INDEX_DATE, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public index_date_definition(): Index_date_definitionContext {
        return this.getRuleContext(0, Index_date_definitionContext)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_index_date;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterIndex_date) {
             listener.enterIndex_date(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitIndex_date) {
             listener.exitIndex_date(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitIndex_date) {
            return visitor.visitIndex_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_date_definitionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public calendar_date(): Calendar_dateContext | null {
        return this.getRuleContext(0, Calendar_dateContext);
    }
    public calendarError(): CalendarErrorContext | null {
        return this.getRuleContext(0, CalendarErrorContext);
    }
    public index_event_date(): Index_event_dateContext | null {
        return this.getRuleContext(0, Index_event_dateContext);
    }
    public index_event_date_error(): Index_event_date_errorContext | null {
        return this.getRuleContext(0, Index_event_date_errorContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_index_date_definition;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterIndex_date_definition) {
             listener.enterIndex_date_definition(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitIndex_date_definition) {
             listener.exitIndex_date_definition(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitIndex_date_definition) {
            return visitor.visitIndex_date_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Calendar_dateContext extends antlr.ParserRuleContext {
    public _index_date_type?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public CALENDAR_DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CALENDAR_DATE, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_calendar_date;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCalendar_date) {
             listener.enterCalendar_date(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCalendar_date) {
             listener.exitCalendar_date(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCalendar_date) {
            return visitor.visitCalendar_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_event_dateContext extends antlr.ParserRuleContext {
    public _index_date_type?: Token | null;
    public _date?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public EVENT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EVENT, 0)!;
    }
    public INSTANCE_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.INSTANCE_EVENT_NAME, 0);
    }
    public PERSON_DATE_TIME_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.PERSON_DATE_TIME_ATTRIBUTE, 0);
    }
    public COMMA(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMA, 0);
    }
    public index_date_bounds(): Index_date_boundsContext | null {
        return this.getRuleContext(0, Index_date_boundsContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_index_event_date;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterIndex_event_date) {
             listener.enterIndex_event_date(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitIndex_event_date) {
             listener.exitIndex_event_date(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitIndex_event_date) {
            return visitor.visitIndex_event_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.COMMA, 0)!;
    }
    public lower_date_bounds(): Lower_date_boundsContext | null {
        return this.getRuleContext(0, Lower_date_boundsContext);
    }
    public lower_date_bounds_error(): Lower_date_bounds_errorContext | null {
        return this.getRuleContext(0, Lower_date_bounds_errorContext);
    }
    public upper_date_bounds(): Upper_date_boundsContext | null {
        return this.getRuleContext(0, Upper_date_boundsContext);
    }
    public upper_date_bounds_error(): Upper_date_bounds_errorContext | null {
        return this.getRuleContext(0, Upper_date_bounds_errorContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_index_date_bounds;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterIndex_date_bounds) {
             listener.enterIndex_date_bounds(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitIndex_date_bounds) {
             listener.exitIndex_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitIndex_date_bounds) {
            return visitor.visitIndex_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Upper_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UPPER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.UPPER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_upper_date_bounds;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterUpper_date_bounds) {
             listener.enterUpper_date_bounds(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitUpper_date_bounds) {
             listener.exitUpper_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitUpper_date_bounds) {
            return visitor.visitUpper_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Lower_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public LOWER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.LOWER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_lower_date_bounds;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterLower_date_bounds) {
             listener.enterLower_date_bounds(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitLower_date_bounds) {
             listener.exitLower_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitLower_date_bounds) {
            return visitor.visitLower_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class CalendarErrorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CALENDAR_DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CALENDAR_DATE, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_calendarError;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCalendarError) {
             listener.enterCalendarError(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCalendarError) {
             listener.exitCalendarError(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCalendarError) {
            return visitor.visitCalendarError(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_event_date_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EVENT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_index_event_date_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterIndex_event_date_error) {
             listener.enterIndex_event_date_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitIndex_event_date_error) {
             listener.exitIndex_event_date_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitIndex_event_date_error) {
            return visitor.visitIndex_event_date_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Lower_date_bounds_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public LOWER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.LOWER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_lower_date_bounds_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterLower_date_bounds_error) {
             listener.enterLower_date_bounds_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitLower_date_bounds_error) {
             listener.exitLower_date_bounds_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitLower_date_bounds_error) {
            return visitor.visitLower_date_bounds_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Upper_date_bounds_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UPPER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.UPPER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_upper_date_bounds_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterUpper_date_bounds_error) {
             listener.enterUpper_date_bounds_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitUpper_date_bounds_error) {
             listener.exitUpper_date_bounds_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitUpper_date_bounds_error) {
            return visitor.visitUpper_date_bounds_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event(): Merged_eventContext | null {
        return this.getRuleContext(0, Merged_eventContext);
    }
    public sequence_event(): Sequence_eventContext | null {
        return this.getRuleContext(0, Sequence_eventContext);
    }
    public instance_event(): Instance_eventContext | null {
        return this.getRuleContext(0, Instance_eventContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_derived_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDerived_event) {
             listener.enterDerived_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDerived_event) {
             listener.exitDerived_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDerived_event) {
            return visitor.visitDerived_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MERGED_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.MERGED_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public MERGED_EVENT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.MERGED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public merged_event_criteria(): Merged_event_criteriaContext {
        return this.getRuleContext(0, Merged_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public COMMA(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMA, 0);
    }
    public merged_event_filter_criterion(): Merged_event_filter_criterionContext | null {
        return this.getRuleContext(0, Merged_event_filter_criterionContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_merged_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMerged_event) {
             listener.enterMerged_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMerged_event) {
             listener.exitMerged_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMerged_event) {
            return visitor.visitMerged_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_criterion(): Merged_event_criterionContext[];
    public merged_event_criterion(i: number): Merged_event_criterionContext | null;
    public merged_event_criterion(i?: number): Merged_event_criterionContext[] | Merged_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Merged_event_criterionContext);
        }

        return this.getRuleContext(i, Merged_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_merged_event_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMerged_event_criteria) {
             listener.enterMerged_event_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMerged_event_criteria) {
             listener.exitMerged_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_criteria) {
            return visitor.visitMerged_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_event(): Merged_event_eventContext | null {
        return this.getRuleContext(0, Merged_event_eventContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_merged_event_criterion;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMerged_event_criterion) {
             listener.enterMerged_event_criterion(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMerged_event_criterion) {
             listener.exitMerged_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_criterion) {
            return visitor.visitMerged_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filter_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_filter(): Merged_event_filterContext | null {
        return this.getRuleContext(0, Merged_event_filterContext);
    }
    public merged_event_filter_error(): Merged_event_filter_errorContext | null {
        return this.getRuleContext(0, Merged_event_filter_errorContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_merged_event_filter_criterion;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMerged_event_filter_criterion) {
             listener.enterMerged_event_filter_criterion(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMerged_event_filter_criterion) {
             listener.exitMerged_event_filter_criterion(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter_criterion) {
            return visitor.visitMerged_event_filter_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_merged_event_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMerged_event_event) {
             listener.enterMerged_event_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMerged_event_event) {
             listener.exitMerged_event_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_event) {
            return visitor.visitMerged_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_uniqueness_filter(): Merged_event_uniqueness_filterContext {
        return this.getRuleContext(0, Merged_event_uniqueness_filterContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_merged_event_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMerged_event_filter) {
             listener.enterMerged_event_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMerged_event_filter) {
             listener.exitMerged_event_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter) {
            return visitor.visitMerged_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public merged_event_uniqueness_filter_criteria(): Merged_event_uniqueness_filter_criteriaContext {
        return this.getRuleContext(0, Merged_event_uniqueness_filter_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_merged_event_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMerged_event_uniqueness_filter) {
             listener.enterMerged_event_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMerged_event_uniqueness_filter) {
             listener.exitMerged_event_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_uniqueness_filter) {
            return visitor.visitMerged_event_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_uniqueness_filter_criteriaContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DERIVED_EVENT_DATE, 0)!;
    }
    public derived_uniqueness_filter(): Derived_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_uniqueness_filterContext);
    }
    public derived_uniqueness_filter_window(): Derived_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Derived_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_merged_event_uniqueness_filter_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMerged_event_uniqueness_filter_criteria) {
             listener.enterMerged_event_uniqueness_filter_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMerged_event_uniqueness_filter_criteria) {
             listener.exitMerged_event_uniqueness_filter_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_uniqueness_filter_criteria) {
            return visitor.visitMerged_event_uniqueness_filter_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filter_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0);
    }
    public derived_event_int(): Derived_event_intContext | null {
        return this.getRuleContext(0, Derived_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.ROLLING_WINDOW, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_merged_event_filter_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMerged_event_filter_error) {
             listener.enterMerged_event_filter_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMerged_event_filter_error) {
             listener.exitMerged_event_filter_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter_error) {
            return visitor.visitMerged_event_filter_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SEQUENCE_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEQUENCE_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public SEQUENCE_EVENT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEQUENCE_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public sequence_event_criteria(): Sequence_event_criteriaContext {
        return this.getRuleContext(0, Sequence_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_sequence_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSequence_event) {
             listener.enterSequence_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSequence_event) {
             listener.exitSequence_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSequence_event) {
            return visitor.visitSequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public sequence_event_criterion(): Sequence_event_criterionContext[];
    public sequence_event_criterion(i: number): Sequence_event_criterionContext | null;
    public sequence_event_criterion(i?: number): Sequence_event_criterionContext[] | Sequence_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Sequence_event_criterionContext);
        }

        return this.getRuleContext(i, Sequence_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_sequence_event_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSequence_event_criteria) {
             listener.enterSequence_event_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSequence_event_criteria) {
             listener.exitSequence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_criteria) {
            return visitor.visitSequence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public sequence_event_constraint(): Sequence_event_constraintContext | null {
        return this.getRuleContext(0, Sequence_event_constraintContext);
    }
    public sequence_event_event(): Sequence_event_eventContext | null {
        return this.getRuleContext(0, Sequence_event_eventContext);
    }
    public sequence_event_constraint_error(): Sequence_event_constraint_errorContext | null {
        return this.getRuleContext(0, Sequence_event_constraint_errorContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_sequence_event_criterion;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSequence_event_criterion) {
             listener.enterSequence_event_criterion(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSequence_event_criterion) {
             listener.exitSequence_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_criterion) {
            return visitor.visitSequence_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_constraintContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ANY_ORDER(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.ANY_ORDER, 0);
    }
    public temporal_constraint(): Temporal_constraintContext | null {
        return this.getRuleContext(0, Temporal_constraintContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_sequence_event_constraint;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSequence_event_constraint) {
             listener.enterSequence_event_constraint(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSequence_event_constraint) {
             listener.exitSequence_event_constraint(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_constraint) {
            return visitor.visitSequence_event_constraint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Temporal_constraintContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TC(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.TC, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public sequence_temporal_filter(): Sequence_temporal_filterContext {
        return this.getRuleContext(0, Sequence_temporal_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_temporal_constraint;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterTemporal_constraint) {
             listener.enterTemporal_constraint(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitTemporal_constraint) {
             listener.exitTemporal_constraint(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitTemporal_constraint) {
            return visitor.visitTemporal_constraint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_temporal_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INT, 0)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.TIME_UNIT, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0);
    }
    public MAXIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MAXIMUM_BETWEEN, 0);
    }
    public TOTAL_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.TOTAL_BETWEEN, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_sequence_temporal_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSequence_temporal_filter) {
             listener.enterSequence_temporal_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSequence_temporal_filter) {
             listener.exitSequence_temporal_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSequence_temporal_filter) {
            return visitor.visitSequence_temporal_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public selected_sequence_event(): Selected_sequence_eventContext | null {
        return this.getRuleContext(0, Selected_sequence_eventContext);
    }
    public unselected_sequence_event(): Unselected_sequence_eventContext | null {
        return this.getRuleContext(0, Unselected_sequence_eventContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_sequence_event_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSequence_event_event) {
             listener.enterSequence_event_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSequence_event_event) {
             listener.exitSequence_event_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_event) {
            return visitor.visitSequence_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Selected_sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.COMMA, 0)!;
    }
    public IS_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.IS_EVENT_DATE, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_selected_sequence_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSelected_sequence_event) {
             listener.enterSelected_sequence_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSelected_sequence_event) {
             listener.exitSelected_sequence_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSelected_sequence_event) {
            return visitor.visitSelected_sequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Unselected_sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_unselected_sequence_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterUnselected_sequence_event) {
             listener.enterUnselected_sequence_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitUnselected_sequence_event) {
             listener.exitUnselected_sequence_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitUnselected_sequence_event) {
            return visitor.visitUnselected_sequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INSTANCE_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INSTANCE_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public INSTANCE_EVENT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INSTANCE_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public instance_event_criteria(): Instance_event_criteriaContext {
        return this.getRuleContext(0, Instance_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_instance_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterInstance_event) {
             listener.enterInstance_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitInstance_event) {
             listener.exitInstance_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitInstance_event) {
            return visitor.visitInstance_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public instance_event_criterion(): Instance_event_criterionContext[];
    public instance_event_criterion(i: number): Instance_event_criterionContext | null;
    public instance_event_criterion(i?: number): Instance_event_criterionContext[] | Instance_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Instance_event_criterionContext);
        }

        return this.getRuleContext(i, Instance_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_instance_event_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterInstance_event_criteria) {
             listener.enterInstance_event_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitInstance_event_criteria) {
             listener.exitInstance_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_criteria) {
            return visitor.visitInstance_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public instance_event_event(): Instance_event_eventContext | null {
        return this.getRuleContext(0, Instance_event_eventContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public instance_event_position(): Instance_event_positionContext | null {
        return this.getRuleContext(0, Instance_event_positionContext);
    }
    public instance_event_position_error(): Instance_event_position_errorContext | null {
        return this.getRuleContext(0, Instance_event_position_errorContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_instance_event_criterion;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterInstance_event_criterion) {
             listener.enterInstance_event_criterion(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitInstance_event_criterion) {
             listener.exitInstance_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_criterion) {
            return visitor.visitInstance_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_instance_event_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterInstance_event_event) {
             listener.enterInstance_event_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitInstance_event_event) {
             listener.exitInstance_event_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_event) {
            return visitor.visitInstance_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_positionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public POSITION(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.POSITION, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public aggregation_qualified(): Aggregation_qualifiedContext | null {
        return this.getRuleContext(0, Aggregation_qualifiedContext);
    }
    public specific_instance(): Specific_instanceContext | null {
        return this.getRuleContext(0, Specific_instanceContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_instance_event_position;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterInstance_event_position) {
             listener.enterInstance_event_position(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitInstance_event_position) {
             listener.exitInstance_event_position(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_position) {
            return visitor.visitInstance_event_position(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Aggregation_qualifiedContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MAX(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MAX, 0);
    }
    public MIN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MIN, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_aggregation_qualified;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterAggregation_qualified) {
             listener.enterAggregation_qualified(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitAggregation_qualified) {
             listener.exitAggregation_qualified(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitAggregation_qualified) {
            return visitor.visitAggregation_qualified(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Specific_instanceContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INDEX(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INDEX, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INT, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_specific_instance;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSpecific_instance) {
             listener.enterSpecific_instance(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSpecific_instance) {
             listener.exitSpecific_instance(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSpecific_instance) {
            return visitor.visitSpecific_instance(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_position_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public POSITION(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.POSITION, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode[];
    public OPEN_PAREN(i: number): antlr.TerminalNode | null;
    public OPEN_PAREN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.OPEN_PAREN);
    	} else {
    		return this.getToken(CohortDefinition.OPEN_PAREN, i);
    	}
    }
    public CLOSE_PAREN(): antlr.TerminalNode[];
    public CLOSE_PAREN(i: number): antlr.TerminalNode | null;
    public CLOSE_PAREN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.CLOSE_PAREN);
    	} else {
    		return this.getToken(CohortDefinition.CLOSE_PAREN, i);
    	}
    }
    public INDEX(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.INDEX, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_instance_event_position_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterInstance_event_position_error) {
             listener.enterInstance_event_position_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitInstance_event_position_error) {
             listener.exitInstance_event_position_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_position_error) {
            return visitor.visitInstance_event_position_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Qualified_simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUALIFIED_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public PERIOD(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PERIOD, 0)!;
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_DRUG_EXPOSURE_ALIAS, 0);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_MEASUREMENT_ALIAS, 0);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MEASUREMENT_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_OBSERVATION_ALIAS, 0);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.OBSERVATION_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_qualified_simple_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterQualified_simple_event) {
             listener.enterQualified_simple_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitQualified_simple_event) {
             listener.exitQualified_simple_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitQualified_simple_event) {
            return visitor.visitQualified_simple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Qualified_derived_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUALIFIED_DERIVED_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.QUALIFIED_DERIVED_EVENT_NAME, 0)!;
    }
    public PERIOD(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PERIOD, 0)!;
    }
    public DERIVED_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DERIVED_EVENT_DATE, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_qualified_derived_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterQualified_derived_event) {
             listener.enterQualified_derived_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitQualified_derived_event) {
             listener.exitQualified_derived_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitQualified_derived_event) {
            return visitor.visitQualified_derived_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_constraint_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TC(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.TC, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0);
    }
    public MAXIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MAXIMUM_BETWEEN, 0);
    }
    public TOTAL_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.TOTAL_BETWEEN, 0);
    }
    public INT(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.INT, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_sequence_event_constraint_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSequence_event_constraint_error) {
             listener.enterSequence_event_constraint_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSequence_event_constraint_error) {
             listener.exitSequence_event_constraint_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_constraint_error) {
            return visitor.visitSequence_event_constraint_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_event_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public QUALIFIED_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_DRUG_EXPOSURE_ALIAS, 0);
    }
    public QUALIFIED_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_MEASUREMENT_ALIAS, 0);
    }
    public QUALIFIED_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_OBSERVATION_ALIAS, 0);
    }
    public QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_DERIVED_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUALIFIED_DERIVED_EVENT_NAME, 0);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.PERIOD, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_derived_event_error;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDerived_event_error) {
             listener.enterDerived_event_error(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDerived_event_error) {
             listener.exitDerived_event_error(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDerived_event_error) {
            return visitor.visitDerived_event_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_derived_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDerived_uniqueness_filter) {
             listener.enterDerived_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDerived_uniqueness_filter) {
             listener.exitDerived_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDerived_uniqueness_filter) {
            return visitor.visitDerived_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public derived_fixed_window_uniqueness_filter(): Derived_fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_fixed_window_uniqueness_filterContext);
    }
    public derived_rolling_window_uniqueness_filter(): Derived_rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_derived_uniqueness_filter_window;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDerived_uniqueness_filter_window) {
             listener.enterDerived_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDerived_uniqueness_filter_window) {
             listener.exitDerived_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDerived_uniqueness_filter_window) {
            return visitor.visitDerived_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.FIXED_WINDOW, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_derived_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDerived_fixed_window_uniqueness_filter) {
             listener.enterDerived_fixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDerived_fixed_window_uniqueness_filter) {
             listener.exitDerived_fixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDerived_fixed_window_uniqueness_filter) {
            return visitor.visitDerived_fixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.ROLLING_WINDOW, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_derived_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDerived_rolling_window_uniqueness_filter) {
             listener.enterDerived_rolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDerived_rolling_window_uniqueness_filter) {
             listener.exitDerived_rolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDerived_rolling_window_uniqueness_filter) {
            return visitor.visitDerived_rolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_derived_event_int;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDerived_event_int) {
             listener.enterDerived_event_int(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDerived_event_int) {
             listener.exitDerived_event_int(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDerived_event_int) {
            return visitor.visitDerived_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext | null {
        return this.getRuleContext(0, Condition_occurrence_eventContext);
    }
    public drug_exposure_event(): Drug_exposure_eventContext | null {
        return this.getRuleContext(0, Drug_exposure_eventContext);
    }
    public measurement_event(): Measurement_eventContext | null {
        return this.getRuleContext(0, Measurement_eventContext);
    }
    public observation_event(): Observation_eventContext | null {
        return this.getRuleContext(0, Observation_eventContext);
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext | null {
        return this.getRuleContext(0, Procedure_occurrence_eventContext);
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext | null {
        return this.getRuleContext(0, Visit_occurrence_eventContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_simple_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSimple_event) {
             listener.enterSimple_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSimple_event) {
             listener.exitSimple_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSimple_event) {
            return visitor.visitSimple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Condition_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONDITION_OCCURRENCE_ALIAS, 0)!;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        return this.getRuleContext(0, Condition_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_event) {
             listener.enterCondition_occurrence_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_event) {
             listener.exitCondition_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event) {
            return visitor.visitCondition_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Drug_exposure_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DRUG_EXPOSURE_ALIAS, 0)!;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        return this.getRuleContext(0, Drug_exposure_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_event) {
             listener.enterDrug_exposure_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_event) {
             listener.exitDrug_exposure_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event) {
            return visitor.visitDrug_exposure_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Measurement_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public MEASUREMENT_ALIAS(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.MEASUREMENT_ALIAS, 0)!;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        return this.getRuleContext(0, Measurement_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_event) {
             listener.enterMeasurement_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_event) {
             listener.exitMeasurement_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event) {
            return visitor.visitMeasurement_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Observation_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public OBSERVATION_ALIAS(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OBSERVATION_ALIAS, 0)!;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        return this.getRuleContext(0, Observation_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_event) {
             listener.enterObservation_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_event) {
             listener.exitObservation_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_event) {
            return visitor.visitObservation_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Procedure_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PROCEDURE_OCCURRENCE_ALIAS, 0)!;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        return this.getRuleContext(0, Procedure_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_event) {
             listener.enterProcedure_occurrence_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_event) {
             listener.exitProcedure_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event) {
            return visitor.visitProcedure_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Visit_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.SEMICOLON, 0)!;
    }
    public VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.VISIT_OCCURRENCE_ALIAS, 0)!;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        return this.getRuleContext(0, Visit_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_event;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_event) {
             listener.enterVisit_occurrence_event(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_event) {
             listener.exitVisit_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event) {
            return visitor.visitVisit_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Condition_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Condition_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_event_definition;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_event_definition) {
             listener.enterCondition_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_event_definition) {
             listener.exitCondition_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_definition) {
            return visitor.visitCondition_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Drug_exposure_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DRUG_EXPOSURE, 0)!;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext | null {
        return this.getRuleContext(0, Drug_exposure_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_event_definition;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_event_definition) {
             listener.enterDrug_exposure_event_definition(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_event_definition) {
             listener.exitDrug_exposure_event_definition(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_definition) {
            return visitor.visitDrug_exposure_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Measurement_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.MEASUREMENT, 0)!;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext | null {
        return this.getRuleContext(0, Measurement_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_event_definition;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_event_definition) {
             listener.enterMeasurement_event_definition(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_event_definition) {
             listener.exitMeasurement_event_definition(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_definition) {
            return visitor.visitMeasurement_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Observation_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OBSERVATION, 0)!;
    }
    public observation_event_criteria(): Observation_event_criteriaContext | null {
        return this.getRuleContext(0, Observation_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_event_definition;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_event_definition) {
             listener.enterObservation_event_definition(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_event_definition) {
             listener.exitObservation_event_definition(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_definition) {
            return visitor.visitObservation_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Procedure_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PROCEDURE_OCCURRENCE, 0)!;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Procedure_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_event_definition;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_event_definition) {
             listener.enterProcedure_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_event_definition) {
             listener.exitProcedure_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_definition) {
            return visitor.visitProcedure_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Visit_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Visit_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_event_definition;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_event_definition) {
             listener.enterVisit_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_event_definition) {
             listener.exitVisit_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_definition) {
            return visitor.visitVisit_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext[];
    public condition_occurrence_event_filter(i: number): Condition_occurrence_event_filterContext | null;
    public condition_occurrence_event_filter(i?: number): Condition_occurrence_event_filterContext[] | Condition_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Condition_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Condition_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_event_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_event_criteria) {
             listener.enterCondition_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_event_criteria) {
             listener.exitCondition_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_criteria) {
            return visitor.visitCondition_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filtersContext);
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filtersContext);
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filtersContext);
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_event_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_event_filter) {
             listener.enterCondition_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_event_filter) {
             listener.exitCondition_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_filter) {
            return visitor.visitCondition_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_concept_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_concept_filters) {
             listener.enterCondition_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_concept_filters) {
             listener.exitCondition_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filters) {
            return visitor.visitCondition_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_concept_group_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_concept_group_filter) {
             listener.enterCondition_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_concept_group_filter) {
             listener.exitCondition_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_group_filter) {
            return visitor.visitCondition_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_concept_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_concept_filter) {
             listener.enterCondition_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_concept_filter) {
             listener.exitCondition_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filter) {
            return visitor.visitCondition_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filters) {
             listener.enterCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filters) {
             listener.exitCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filters) {
            return visitor.visitCondition_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filter) {
             listener.enterCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filter) {
             listener.exitCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filter) {
            return visitor.visitCondition_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_related_entity_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_related_entity_filters) {
             listener.enterCondition_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_related_entity_filters) {
             listener.exitCondition_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filters) {
            return visitor.visitCondition_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_related_entity_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_related_entity_filter) {
             listener.enterCondition_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_related_entity_filter) {
             listener.exitCondition_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filter) {
            return visitor.visitCondition_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_sub_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_sub_filter) {
             listener.enterCondition_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_sub_filter) {
             listener.exitCondition_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_sub_filter) {
            return visitor.visitCondition_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CONDITION_OCCURRENCE, 0);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_error_sub_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_error_sub_filter) {
             listener.enterCondition_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_error_sub_filter) {
             listener.exitCondition_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_sub_filter) {
            return visitor.visitCondition_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_condition_occurrence_error_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterCondition_occurrence_error_filter) {
             listener.enterCondition_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitCondition_occurrence_error_filter) {
             listener.exitCondition_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_filter) {
            return visitor.visitCondition_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext[];
    public drug_exposure_event_filter(i: number): Drug_exposure_event_filterContext | null;
    public drug_exposure_event_filter(i?: number): Drug_exposure_event_filterContext[] | Drug_exposure_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Drug_exposure_event_filterContext);
        }

        return this.getRuleContext(i, Drug_exposure_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_event_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_event_criteria) {
             listener.enterDrug_exposure_event_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_event_criteria) {
             listener.exitDrug_exposure_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_criteria) {
            return visitor.visitDrug_exposure_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filtersContext);
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_numeric_filtersContext);
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filtersContext);
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_related_entity_filtersContext);
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_error_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_event_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_event_filter) {
             listener.enterDrug_exposure_event_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_event_filter) {
             listener.exitDrug_exposure_event_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_filter) {
            return visitor.visitDrug_exposure_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_group_filterContext);
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_concept_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_concept_filters) {
             listener.enterDrug_exposure_concept_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_concept_filters) {
             listener.exitDrug_exposure_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filters) {
            return visitor.visitDrug_exposure_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_concept_group_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_concept_group_filter) {
             listener.enterDrug_exposure_concept_group_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_concept_group_filter) {
             listener.exitDrug_exposure_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_group_filter) {
            return visitor.visitDrug_exposure_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_concept_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_concept_filter) {
             listener.enterDrug_exposure_concept_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_concept_filter) {
             listener.exitDrug_exposure_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filter) {
            return visitor.visitDrug_exposure_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_float_filterContext);
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_int_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_numeric_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_numeric_filters) {
             listener.enterDrug_exposure_numeric_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_numeric_filters) {
             listener.exitDrug_exposure_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_numeric_filters) {
            return visitor.visitDrug_exposure_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_float_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_float_filter) {
             listener.enterDrug_exposure_float_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_float_filter) {
             listener.exitDrug_exposure_float_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_float_filter) {
            return visitor.visitDrug_exposure_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DRUG_EXPOSURE_INT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_int_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_int_filter) {
             listener.enterDrug_exposure_int_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_int_filter) {
             listener.exitDrug_exposure_int_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_int_filter) {
            return visitor.visitDrug_exposure_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_uniqueness_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_uniqueness_filters) {
             listener.enterDrug_exposure_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_uniqueness_filters) {
             listener.exitDrug_exposure_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filters) {
            return visitor.visitDrug_exposure_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_uniqueness_filter) {
             listener.enterDrug_exposure_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_uniqueness_filter) {
             listener.exitDrug_exposure_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filter) {
            return visitor.visitDrug_exposure_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        return this.getRuleContext(0, Drug_exposure_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_related_entity_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_related_entity_filters) {
             listener.enterDrug_exposure_related_entity_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_related_entity_filters) {
             listener.exitDrug_exposure_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filters) {
            return visitor.visitDrug_exposure_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_related_entity_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_related_entity_filter) {
             listener.enterDrug_exposure_related_entity_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_related_entity_filter) {
             listener.exitDrug_exposure_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filter) {
            return visitor.visitDrug_exposure_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.DRUG_EXPOSURE_INT_ATTRIBUTE, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_drug_exposure_error_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterDrug_exposure_error_filter) {
             listener.enterDrug_exposure_error_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitDrug_exposure_error_filter) {
             listener.exitDrug_exposure_error_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_error_filter) {
            return visitor.visitDrug_exposure_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_event_filter(): Measurement_event_filterContext[];
    public measurement_event_filter(i: number): Measurement_event_filterContext | null;
    public measurement_event_filter(i?: number): Measurement_event_filterContext[] | Measurement_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Measurement_event_filterContext);
        }

        return this.getRuleContext(i, Measurement_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_event_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_event_criteria) {
             listener.enterMeasurement_event_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_event_criteria) {
             listener.exitMeasurement_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_criteria) {
            return visitor.visitMeasurement_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext | null {
        return this.getRuleContext(0, Measurement_concept_filtersContext);
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext | null {
        return this.getRuleContext(0, Measurement_numeric_filtersContext);
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Measurement_uniqueness_filtersContext);
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext | null {
        return this.getRuleContext(0, Measurement_related_entity_filtersContext);
    }
    public measurement_error_filter(): Measurement_error_filterContext | null {
        return this.getRuleContext(0, Measurement_error_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_event_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_event_filter) {
             listener.enterMeasurement_event_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_event_filter) {
             listener.exitMeasurement_event_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_filter) {
            return visitor.visitMeasurement_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_group_filterContext);
    }
    public measurement_concept_filter(): Measurement_concept_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_concept_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_concept_filters) {
             listener.enterMeasurement_concept_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_concept_filters) {
             listener.exitMeasurement_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filters) {
            return visitor.visitMeasurement_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_concept_group_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_concept_group_filter) {
             listener.enterMeasurement_concept_group_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_concept_group_filter) {
             listener.exitMeasurement_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_group_filter) {
            return visitor.visitMeasurement_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONCEPT, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_concept_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_concept_filter) {
             listener.enterMeasurement_concept_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_concept_filter) {
             listener.exitMeasurement_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filter) {
            return visitor.visitMeasurement_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        return this.getRuleContext(0, Measurement_float_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_numeric_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_numeric_filters) {
             listener.enterMeasurement_numeric_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_numeric_filters) {
             listener.exitMeasurement_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_numeric_filters) {
            return visitor.visitMeasurement_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_float_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_float_filter) {
             listener.enterMeasurement_float_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_float_filter) {
             listener.exitMeasurement_float_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_float_filter) {
            return visitor.visitMeasurement_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        return this.getRuleContext(0, Measurement_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_uniqueness_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_uniqueness_filters) {
             listener.enterMeasurement_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_uniqueness_filters) {
             listener.exitMeasurement_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filters) {
            return visitor.visitMeasurement_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.MEASUREMENT_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_uniqueness_filter) {
             listener.enterMeasurement_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_uniqueness_filter) {
             listener.exitMeasurement_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filter) {
            return visitor.visitMeasurement_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        return this.getRuleContext(0, Measurement_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_related_entity_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_related_entity_filters) {
             listener.enterMeasurement_related_entity_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_related_entity_filters) {
             listener.exitMeasurement_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filters) {
            return visitor.visitMeasurement_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_related_entity_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_related_entity_filter) {
             listener.enterMeasurement_related_entity_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_related_entity_filter) {
             listener.exitMeasurement_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filter) {
            return visitor.visitMeasurement_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NF, 0);
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_measurement_error_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterMeasurement_error_filter) {
             listener.enterMeasurement_error_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitMeasurement_error_filter) {
             listener.exitMeasurement_error_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_error_filter) {
            return visitor.visitMeasurement_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_event_filter(): Observation_event_filterContext[];
    public observation_event_filter(i: number): Observation_event_filterContext | null;
    public observation_event_filter(i?: number): Observation_event_filterContext[] | Observation_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Observation_event_filterContext);
        }

        return this.getRuleContext(i, Observation_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_event_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_event_criteria) {
             listener.enterObservation_event_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_event_criteria) {
             listener.exitObservation_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_criteria) {
            return visitor.visitObservation_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_concept_filters(): Observation_concept_filtersContext | null {
        return this.getRuleContext(0, Observation_concept_filtersContext);
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext | null {
        return this.getRuleContext(0, Observation_numeric_filtersContext);
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Observation_uniqueness_filtersContext);
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext | null {
        return this.getRuleContext(0, Observation_related_entity_filtersContext);
    }
    public observation_error_filter(): Observation_error_filterContext | null {
        return this.getRuleContext(0, Observation_error_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_event_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_event_filter) {
             listener.enterObservation_event_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_event_filter) {
             listener.exitObservation_event_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_filter) {
            return visitor.visitObservation_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext | null {
        return this.getRuleContext(0, Observation_concept_group_filterContext);
    }
    public observation_concept_filter(): Observation_concept_filterContext | null {
        return this.getRuleContext(0, Observation_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_concept_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_concept_filters) {
             listener.enterObservation_concept_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_concept_filters) {
             listener.exitObservation_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filters) {
            return visitor.visitObservation_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_concept_group_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_concept_group_filter) {
             listener.enterObservation_concept_group_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_concept_group_filter) {
             listener.exitObservation_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_group_filter) {
            return visitor.visitObservation_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONCEPT, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_concept_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_concept_filter) {
             listener.enterObservation_concept_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_concept_filter) {
             listener.exitObservation_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filter) {
            return visitor.visitObservation_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public observation_float_filter(): Observation_float_filterContext | null {
        return this.getRuleContext(0, Observation_float_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_numeric_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_numeric_filters) {
             listener.enterObservation_numeric_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_numeric_filters) {
             listener.exitObservation_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_numeric_filters) {
            return visitor.visitObservation_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_float_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_float_filter) {
             listener.enterObservation_float_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_float_filter) {
             listener.exitObservation_float_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_float_filter) {
            return visitor.visitObservation_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        return this.getRuleContext(0, Observation_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_uniqueness_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_uniqueness_filters) {
             listener.enterObservation_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_uniqueness_filters) {
             listener.exitObservation_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filters) {
            return visitor.visitObservation_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OBSERVATION_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_uniqueness_filter) {
             listener.enterObservation_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_uniqueness_filter) {
             listener.exitObservation_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filter) {
            return visitor.visitObservation_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        return this.getRuleContext(0, Observation_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_related_entity_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_related_entity_filters) {
             listener.enterObservation_related_entity_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_related_entity_filters) {
             listener.exitObservation_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filters) {
            return visitor.visitObservation_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_related_entity_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_related_entity_filter) {
             listener.enterObservation_related_entity_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_related_entity_filter) {
             listener.exitObservation_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filter) {
            return visitor.visitObservation_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NF, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_observation_error_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterObservation_error_filter) {
             listener.enterObservation_error_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitObservation_error_filter) {
             listener.exitObservation_error_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitObservation_error_filter) {
            return visitor.visitObservation_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext[];
    public procedure_occurrence_event_filter(i: number): Procedure_occurrence_event_filterContext | null;
    public procedure_occurrence_event_filter(i?: number): Procedure_occurrence_event_filterContext[] | Procedure_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Procedure_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Procedure_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_event_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_event_criteria) {
             listener.enterProcedure_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_event_criteria) {
             listener.exitProcedure_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_criteria) {
            return visitor.visitProcedure_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filtersContext);
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_numeric_filtersContext);
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filtersContext);
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filtersContext);
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_event_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_event_filter) {
             listener.enterProcedure_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_event_filter) {
             listener.exitProcedure_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_filter) {
            return visitor.visitProcedure_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_group_filterContext);
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_concept_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_concept_filters) {
             listener.enterProcedure_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_concept_filters) {
             listener.exitProcedure_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filters) {
            return visitor.visitProcedure_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_concept_group_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_concept_group_filter) {
             listener.enterProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_concept_group_filter) {
             listener.exitProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_group_filter) {
            return visitor.visitProcedure_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_concept_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_concept_filter) {
             listener.enterProcedure_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_concept_filter) {
             listener.exitProcedure_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filter) {
            return visitor.visitProcedure_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_int_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_numeric_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_numeric_filters) {
             listener.enterProcedure_occurrence_numeric_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_numeric_filters) {
             listener.exitProcedure_occurrence_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_numeric_filters) {
            return visitor.visitProcedure_occurrence_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_int_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_int_filter) {
             listener.enterProcedure_occurrence_int_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_int_filter) {
             listener.exitProcedure_occurrence_int_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_int_filter) {
            return visitor.visitProcedure_occurrence_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filters) {
             listener.enterProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filters) {
             listener.exitProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filters) {
            return visitor.visitProcedure_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filter) {
             listener.enterProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filter) {
             listener.exitProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filter) {
            return visitor.visitProcedure_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_related_entity_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filters) {
             listener.enterProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filters) {
             listener.exitProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filters) {
            return visitor.visitProcedure_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_related_entity_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filter) {
             listener.enterProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filter) {
             listener.exitProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filter) {
            return visitor.visitProcedure_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_procedure_occurrence_error_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProcedure_occurrence_error_filter) {
             listener.enterProcedure_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProcedure_occurrence_error_filter) {
             listener.exitProcedure_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_error_filter) {
            return visitor.visitProcedure_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_provider_concept_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProvider_concept_filters) {
             listener.enterProvider_concept_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProvider_concept_filters) {
             listener.exitProvider_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filters) {
            return visitor.visitProvider_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_provider_concept_group_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProvider_concept_group_filter) {
             listener.enterProvider_concept_group_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProvider_concept_group_filter) {
             listener.exitProvider_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_group_filter) {
            return visitor.visitProvider_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_provider_concept_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProvider_concept_filter) {
             listener.enterProvider_concept_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProvider_concept_filter) {
             listener.exitProvider_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filter) {
            return visitor.visitProvider_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.PROVIDER, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_provider_sub_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProvider_sub_filter) {
             listener.enterProvider_sub_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProvider_sub_filter) {
             listener.exitProvider_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProvider_sub_filter) {
            return visitor.visitProvider_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.PROVIDER, 0);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.PROVIDER_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_provider_error_sub_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterProvider_error_sub_filter) {
             listener.enterProvider_error_sub_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitProvider_error_sub_filter) {
             listener.exitProvider_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitProvider_error_sub_filter) {
            return visitor.visitProvider_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext[];
    public visit_occurrence_event_filter(i: number): Visit_occurrence_event_filterContext | null;
    public visit_occurrence_event_filter(i?: number): Visit_occurrence_event_filterContext[] | Visit_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Visit_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Visit_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_event_criteria;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_event_criteria) {
             listener.enterVisit_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_event_criteria) {
             listener.exitVisit_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_criteria) {
            return visitor.visitVisit_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filtersContext);
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filtersContext);
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filtersContext);
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_event_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_event_filter) {
             listener.enterVisit_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_event_filter) {
             listener.exitVisit_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_filter) {
            return visitor.visitVisit_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_concept_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_concept_filters) {
             listener.enterVisit_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_concept_filters) {
             listener.exitVisit_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filters) {
            return visitor.visitVisit_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_concept_group_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_concept_group_filter) {
             listener.enterVisit_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_concept_group_filter) {
             listener.exitVisit_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_group_filter) {
            return visitor.visitVisit_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_concept_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_concept_filter) {
             listener.enterVisit_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_concept_filter) {
             listener.exitVisit_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filter) {
            return visitor.visitVisit_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filters) {
             listener.enterVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filters) {
             listener.exitVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filters) {
            return visitor.visitVisit_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filter) {
             listener.enterVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filter) {
             listener.exitVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filter) {
            return visitor.visitVisit_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_related_entity_filters;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_related_entity_filters) {
             listener.enterVisit_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_related_entity_filters) {
             listener.exitVisit_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filters) {
            return visitor.visitVisit_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_related_entity_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_related_entity_filter) {
             listener.enterVisit_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_related_entity_filter) {
             listener.exitVisit_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filter) {
            return visitor.visitVisit_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_sub_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_sub_filter) {
             listener.enterVisit_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_sub_filter) {
             listener.exitVisit_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_sub_filter) {
            return visitor.visitVisit_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.VISIT_OCCURRENCE, 0);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_error_sub_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_error_sub_filter) {
             listener.enterVisit_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_error_sub_filter) {
             listener.exitVisit_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_sub_filter) {
            return visitor.visitVisit_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_visit_occurrence_error_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterVisit_occurrence_error_filter) {
             listener.enterVisit_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitVisit_occurrence_error_filter) {
             listener.exitVisit_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_filter) {
            return visitor.visitVisit_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Comparison_opContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.EQ, 0);
    }
    public LT(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.LT, 0);
    }
    public GT(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.GT, 0);
    }
    public LTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.LTE, 0);
    }
    public GTE(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.GTE, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_comparison_op;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterComparison_op) {
             listener.enterComparison_op(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitComparison_op) {
             listener.exitComparison_op(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitComparison_op) {
            return visitor.visitComparison_op(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.MINIMUM_BETWEEN, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_simple_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSimple_uniqueness_filter) {
             listener.enterSimple_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSimple_uniqueness_filter) {
             listener.exitSimple_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter) {
            return visitor.visitSimple_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Fixed_window_uniqueness_filterContext);
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_simple_uniqueness_filter_window;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSimple_uniqueness_filter_window) {
             listener.enterSimple_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSimple_uniqueness_filter_window) {
             listener.exitSimple_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter_window) {
            return visitor.visitSimple_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.FIXED_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterFixed_window_uniqueness_filter) {
             listener.enterFixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitFixed_window_uniqueness_filter) {
             listener.exitFixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitFixed_window_uniqueness_filter) {
            return visitor.visitFixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.ROLLING_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterRolling_window_uniqueness_filter) {
             listener.enterRolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitRolling_window_uniqueness_filter) {
             listener.exitRolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitRolling_window_uniqueness_filter) {
            return visitor.visitRolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_floatContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(CohortDefinition.PERIOD, 0);
    }
    public INT(): antlr.TerminalNode[];
    public INT(i: number): antlr.TerminalNode | null;
    public INT(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.INT);
    	} else {
    		return this.getToken(CohortDefinition.INT, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_simple_event_float;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSimple_event_float) {
             listener.enterSimple_event_float(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSimple_event_float) {
             listener.exitSimple_event_float(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_float) {
            return visitor.visitSimple_event_float(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(CohortDefinition.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_simple_event_int;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterSimple_event_int) {
             listener.enterSimple_event_int(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitSimple_event_int) {
             listener.exitSimple_event_int(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_int) {
            return visitor.visitSimple_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Concept_group_selectionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT_GROUP(): antlr.TerminalNode[];
    public CONCEPT_GROUP(i: number): antlr.TerminalNode | null;
    public CONCEPT_GROUP(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.CONCEPT_GROUP);
    	} else {
    		return this.getToken(CohortDefinition.CONCEPT_GROUP, i);
    	}
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(CohortDefinition.COMMA);
    	} else {
    		return this.getToken(CohortDefinition.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return CohortDefinition.RULE_concept_group_selection;
    }
    public override enterRule(listener: CohortDefinitionListener): void {
        if(listener.enterConcept_group_selection) {
             listener.enterConcept_group_selection(this);
        }
    }
    public override exitRule(listener: CohortDefinitionListener): void {
        if(listener.exitConcept_group_selection) {
             listener.exitConcept_group_selection(this);
        }
    }
    public override accept<Result>(visitor: CohortDefinitionVisitor<Result>): Result | null {
        if (visitor.visitConcept_group_selection) {
            return visitor.visitConcept_group_selection(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
